import React from "react";
/**
 * Svg React component for hexa world mao
 */
function HexaMap() {
  return (
    <svg
      width="1000"
      height="800"
      viewBox="0 0 1501 894"
      fill="none"
      xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none"
    >
      <g filter="url(#filter0_dddddd_625_20601)">
        <path
          d="M109.56 178.938L103.163 175.18L96.8004 178.938V186.703L103.163 190.673L109.56 186.703V178.938Z"
          fill="#F2F0FA"
        />
        <path
          d="M116.851 191.698L110.454 187.939L104.091 191.698V199.462L110.454 203.433L116.851 199.462V191.698Z"
          fill="#F2F0FA"
        />
        <path
          d="M396.135 50.1609L389.329 46.1621L382.558 50.1609V58.4225L389.329 62.6476L396.135 58.4225V50.1609Z"
          fill="white"
        />
        <path
          d="M411.65 50.1609L404.844 46.1621L398.073 50.1609V58.4225L404.844 62.6476L411.65 58.4225V50.1609Z"
          fill="white"
        />
        <path
          d="M427.166 50.1609L420.36 46.1621L413.59 50.1609V58.4225L420.36 62.6476L427.166 58.4225V50.1609Z"
          fill="white"
        />
        <path
          d="M489.23 50.1609L482.424 46.1621L475.653 50.1609V58.4225L482.424 62.6476L489.23 58.4225V50.1609Z"
          fill="white"
        />
        <path
          d="M504.745 50.1609L497.939 46.1621L491.169 50.1609V58.4225L497.939 62.6476L504.745 58.4225V50.1609Z"
          fill="white"
        />
        <path
          d="M520.261 50.1609L513.455 46.1621L506.685 50.1609V58.4225L513.455 62.6476L520.261 58.4225V50.1609Z"
          fill="white"
        />
        <path
          d="M535.777 50.1609L528.971 46.1621L522.201 50.1609V58.4225L528.971 62.6476L535.777 58.4225V50.1609Z"
          fill="white"
        />
        <path
          d="M752.998 50.1609L746.192 46.1621L739.421 50.1609V58.4225L746.192 62.6476L752.998 58.4225V50.1609Z"
          fill="white"
        />
        <path
          d="M768.514 50.1609L761.708 46.1621L754.938 50.1609V58.4225L761.708 62.6476L768.514 58.4225V50.1609Z"
          fill="white"
        />
        <path
          d="M357.345 63.7361L350.539 59.7373L343.769 63.7361V71.9977L350.539 76.2228L357.345 71.9977V63.7361Z"
          fill="white"
        />
        <path
          d="M372.861 63.7361L366.055 59.7373L359.285 63.7361V71.9977L366.055 76.2228L372.861 71.9977V63.7361Z"
          fill="white"
        />
        <path
          d="M388.377 63.7361L381.571 59.7373L374.8 63.7361V71.9977L381.571 76.2228L388.377 71.9977V63.7361Z"
          fill="white"
        />
        <path
          d="M403.893 63.7361L397.087 59.7373L390.316 63.7361V71.9977L397.087 76.2228L403.893 71.9977V63.7361Z"
          fill="white"
        />
        <path
          d="M419.408 63.7361L412.602 59.7373L405.832 63.7361V71.9977L412.602 76.2228L419.408 71.9977V63.7361Z"
          fill="white"
        />
        <path
          d="M434.924 63.7361L428.118 59.7373L421.348 63.7361V71.9977L428.118 76.2228L434.924 71.9977V63.7361Z"
          fill="white"
        />
        <path
          d="M450.44 63.7361L443.634 59.7373L436.864 63.7361V71.9977L443.634 76.2228L450.44 71.9977V63.7361Z"
          fill="white"
        />
        <path
          d="M465.955 63.7361L459.149 59.7373L452.379 63.7361V71.9977L459.149 76.2228L465.955 71.9977V63.7361Z"
          fill="white"
        />
        <path
          d="M481.472 63.7361L474.666 59.7373L467.895 63.7361V71.9977L474.666 76.2228L481.472 71.9977V63.7361Z"
          fill="white"
        />
        <path
          d="M496.988 63.7361L490.182 59.7373L483.411 63.7361V71.9977L490.182 76.2228L496.988 71.9977V63.7361Z"
          fill="white"
        />
        <path
          d="M512.503 63.7361L505.697 59.7373L498.927 63.7361V71.9977L505.697 76.2228L512.503 71.9977V63.7361Z"
          fill="white"
        />
        <path
          d="M528.018 63.7361L521.212 59.7373L514.442 63.7361V71.9977L521.212 76.2228L528.018 71.9977V63.7361Z"
          fill="white"
        />
        <path
          d="M543.535 63.7361L536.729 59.7373L529.959 63.7361V71.9977L536.729 76.2228L543.535 71.9977V63.7361Z"
          fill="white"
        />
        <path
          d="M745.24 63.7361L738.433 59.7373L731.663 63.7361V71.9977L738.433 76.2228L745.24 71.9977V63.7361Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M760.756 63.7361L753.95 59.7373L747.179 63.7361V71.9977L753.95 76.2228L760.756 71.9977V63.7361Z"
          fill="#8676FF"
        />
        <path
          d="M349.587 77.3123L342.781 73.3135L336.011 77.3123V85.5739L342.781 89.799L349.587 85.5739V77.3123Z"
          fill="white"
        />
        <path
          d="M365.103 77.3123L358.297 73.3135L351.527 77.3123V85.5739L358.297 89.799L365.103 85.5739V77.3123Z"
          fill="white"
        />
        <path
          d="M380.619 77.3123L373.812 73.3135L367.042 77.3123V85.5739L373.812 89.799L380.619 85.5739V77.3123Z"
          fill="white"
        />
        <path
          d="M396.135 77.3123L389.329 73.3135L382.558 77.3123V85.5739L389.329 89.799L396.135 85.5739V77.3123Z"
          fill="white"
        />
        <path
          d="M411.65 77.3123L404.844 73.3135L398.073 77.3123V85.5739L404.844 89.799L411.65 85.5739V77.3123Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M427.166 77.3123L420.36 73.3135L413.59 77.3123V85.5739L420.36 89.799L427.166 85.5739V77.3123Z"
          fill="#8676FF"
        />
        <path
          d="M442.682 77.3123L435.876 73.3135L429.106 77.3123V85.5739L435.876 89.799L442.682 85.5739V77.3123Z"
          fill="white"
        />
        <path
          d="M458.197 77.3123L451.391 73.3135L444.621 77.3123V85.5739L451.391 89.799L458.197 85.5739V77.3123Z"
          fill="white"
        />
        <path
          d="M473.714 77.3123L466.907 73.3135L460.137 77.3123V85.5739L466.907 89.799L473.714 85.5739V77.3123Z"
          fill="white"
        />
        <path
          d="M489.23 77.3123L482.424 73.3135L475.653 77.3123V85.5739L482.424 89.799L489.23 85.5739V77.3123Z"
          fill="white"
        />
        <path
          d="M504.745 77.3123L497.939 73.3135L491.169 77.3123V85.5739L497.939 89.799L504.745 85.5739V77.3123Z"
          fill="white"
        />
        <path
          d="M520.261 77.3123L513.455 73.3135L506.685 77.3123V85.5739L513.455 89.799L520.261 85.5739V77.3123Z"
          fill="white"
        />
        <path
          d="M535.777 77.3123L528.971 73.3135L522.201 77.3123V85.5739L528.971 89.799L535.777 85.5739V77.3123Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M737.482 77.3123L730.676 73.3135L723.906 77.3123V85.5739L730.676 89.799L737.482 85.5739V77.3123Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M752.998 77.3123L746.192 73.3135L739.421 77.3123V85.5739L746.192 89.799L752.998 85.5739V77.3123Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M768.514 77.3123L761.708 73.3135L754.938 77.3123V85.5739L761.708 89.799L768.514 85.5739V77.3123Z"
          fill="#8676FF"
        />
        <path
          d="M279.765 90.8884L272.959 86.8896L266.189 90.8884V99.1501L272.959 103.375L279.765 99.1501V90.8884Z"
          fill="white"
        />
        <path
          d="M341.829 90.8884L335.023 86.8896L328.253 90.8884V99.1501L335.023 103.375L341.829 99.1501V90.8884Z"
          fill="white"
        />
        <path
          d="M357.345 90.8884L350.539 86.8896L343.769 90.8884V99.1501L350.539 103.375L357.345 99.1501V90.8884Z"
          fill="white"
        />
        <path
          d="M372.861 90.8884L366.055 86.8896L359.285 90.8884V99.1501L366.055 103.375L372.861 99.1501V90.8884Z"
          fill="white"
        />
        <path
          d="M388.377 90.8884L381.571 86.8896L374.8 90.8884V99.1501L381.571 103.375L388.377 99.1501V90.8884Z"
          fill="white"
        />
        <path
          d="M403.893 90.8884L397.087 86.8896L390.316 90.8884V99.1501L397.087 103.375L403.893 99.1501V90.8884Z"
          fill="white"
        />
        <path
          d="M419.408 90.8884L412.602 86.8896L405.832 90.8884V99.1501L412.602 103.375L419.408 99.1501V90.8884Z"
          fill="white"
        />
        <path
          d="M434.924 90.8884L428.118 86.8896L421.348 90.8884V99.1501L428.118 103.375L434.924 99.1501V90.8884Z"
          fill="white"
        />
        <path
          d="M450.44 90.8884L443.634 86.8896L436.864 90.8884V99.1501L443.634 103.375L450.44 99.1501V90.8884Z"
          fill="white"
        />
        <path
          d="M465.955 90.8884L459.149 86.8896L452.379 90.8884V99.1501L459.149 103.375L465.955 99.1501V90.8884Z"
          fill="white"
        />
        <path
          d="M481.472 90.8884L474.666 86.8896L467.895 90.8884V99.1501L474.666 103.375L481.472 99.1501V90.8884Z"
          fill="white"
        />
        <path
          d="M496.988 90.8884L490.182 86.8896L483.411 90.8884V99.1501L490.182 103.375L496.988 99.1501V90.8884Z"
          fill="white"
        />
        <path
          d="M512.503 90.8884L505.697 86.8896L498.927 90.8884V99.1501L505.697 103.375L512.503 99.1501V90.8884Z"
          fill="white"
        />
        <path
          d="M528.018 90.8884L521.212 86.8896L514.442 90.8884V99.1501L521.212 103.375L528.018 99.1501V90.8884Z"
          fill="white"
        />
        <path
          d="M543.535 90.8884L536.729 86.8896L529.959 90.8884V99.1501L536.729 103.375L543.535 99.1501V90.8884Z"
          fill="white"
        />
        <path
          d="M132.366 104.465L125.56 100.466L118.789 104.465V112.726L125.56 116.951L132.366 112.726V104.465Z"
          fill="white"
        />
        <path
          d="M147.882 104.465L141.076 100.466L134.306 104.465V112.726L141.076 116.951L147.882 112.726V104.465Z"
          fill="white"
        />
        <path
          d="M163.397 104.465L156.591 100.466L149.821 104.465V112.726L156.591 116.951L163.397 112.726V104.465Z"
          fill="white"
        />
        <path
          d="M178.913 104.465L172.107 100.466L165.337 104.465V112.726L172.107 116.951L178.913 112.726V104.465Z"
          fill="white"
        />
        <path
          d="M256.492 104.465L249.686 100.466L242.916 104.465V112.726L249.686 116.951L256.492 112.726V104.465Z"
          fill="white"
        />
        <path
          d="M272.008 104.465L265.202 100.466L258.432 104.465V112.726L265.202 116.951L272.008 112.726V104.465Z"
          fill="white"
        />
        <path
          d="M287.523 104.465L280.717 100.466L273.947 104.465V112.726L280.717 116.951L287.523 112.726V104.465Z"
          fill="white"
        />
        <path
          d="M303.04 104.465L296.234 100.466L289.463 104.465V112.726L296.234 116.951L303.04 112.726V104.465Z"
          fill="white"
        />
        <path
          d="M318.556 104.465L311.75 100.466L304.979 104.465V112.726L311.75 116.951L318.556 112.726V104.465Z"
          fill="white"
        />
        <path
          d="M349.587 104.465L342.781 100.466L336.011 104.465V112.726L342.781 116.951L349.587 112.726V104.465Z"
          fill="white"
        />
        <path
          d="M365.103 104.465L358.297 100.466L351.527 104.465V112.726L358.297 116.951L365.103 112.726V104.465Z"
          fill="white"
        />
        <path
          d="M380.619 104.465L373.812 100.466L367.042 104.465V112.726L373.812 116.951L380.619 112.726V104.465Z"
          fill="white"
        />
        <path
          d="M427.166 104.465L420.36 100.466L413.59 104.465V112.726L420.36 116.951L427.166 112.726V104.465Z"
          fill="white"
        />
        <path
          d="M442.682 104.465L435.876 100.466L429.106 104.465V112.726L435.876 116.951L442.682 112.726V104.465Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M458.197 104.465L451.391 100.466L444.621 104.465V112.726L451.391 116.951L458.197 112.726V104.465Z"
          fill="#8676FF"
        />
        <path
          d="M473.714 104.465L466.907 100.466L460.137 104.465V112.726L466.907 116.951L473.714 112.726V104.465Z"
          fill="white"
        />
        <path
          d="M489.23 104.465L482.424 100.466L475.653 104.465V112.726L482.424 116.951L489.23 112.726V104.465Z"
          fill="white"
        />
        <path
          d="M504.745 104.465L497.939 100.466L491.169 104.465V112.726L497.939 116.951L504.745 112.726V104.465Z"
          fill="white"
        />
        <path
          d="M520.261 104.465L513.455 100.466L506.685 104.465V112.726L513.455 116.951L520.261 112.726V104.465Z"
          fill="white"
        />
        <path
          d="M535.777 104.465L528.971 100.466L522.201 104.465V112.726L528.971 116.951L535.777 112.726V104.465Z"
          fill="white"
        />
        <path
          d="M124.609 118.042L117.803 114.043L111.032 118.042V126.303L117.803 130.529L124.609 126.303V118.042Z"
          fill="white"
        />
        <path
          d="M140.124 118.042L133.318 114.043L126.547 118.042V126.303L133.318 130.529L140.124 126.303V118.042Z"
          fill="white"
        />
        <path
          d="M155.64 118.042L148.834 114.043L142.064 118.042V126.303L148.834 130.529L155.64 126.303V118.042Z"
          fill="white"
        />
        <path
          d="M171.155 118.042L164.349 114.043L157.579 118.042V126.303L164.349 130.529L171.155 126.303V118.042Z"
          fill="white"
        />
        <path
          d="M186.671 118.042L179.865 114.043L173.095 118.042V126.303L179.865 130.529L186.671 126.303V118.042Z"
          fill="white"
        />
        <path
          d="M248.735 118.042L241.929 114.043L235.159 118.042V126.303L241.929 130.529L248.735 126.303V118.042Z"
          fill="white"
        />
        <path
          d="M264.25 118.042L257.444 114.043L250.674 118.042V126.303L257.444 130.529L264.25 126.303V118.042Z"
          fill="white"
        />
        <path
          d="M279.765 118.042L272.959 114.043L266.189 118.042V126.303L272.959 130.529L279.765 126.303V118.042Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M295.282 118.042L288.475 114.043L281.705 118.042V126.303L288.475 130.529L295.282 126.303V118.042Z"
          fill="#8676FF"
        />
        <path
          d="M310.799 118.042L303.993 114.043L297.222 118.042V126.303L303.993 130.529L310.799 126.303V118.042Z"
          fill="white"
        />
        <path
          d="M326.313 118.042L319.507 114.043L312.737 118.042V126.303L319.507 130.529L326.313 126.303V118.042Z"
          fill="white"
        />
        <path
          d="M341.829 118.042L335.023 114.043L328.253 118.042V126.303L335.023 130.529L341.829 126.303V118.042Z"
          fill="white"
        />
        <path
          d="M357.345 118.042L350.539 114.043L343.769 118.042V126.303L350.539 130.529L357.345 126.303V118.042Z"
          fill="white"
        />
        <path
          d="M372.861 118.042L366.055 114.043L359.285 118.042V126.303L366.055 130.529L372.861 126.303V118.042Z"
          fill="white"
        />
        <path
          d="M388.377 118.042L381.571 114.043L374.8 118.042V126.303L381.571 130.529L388.377 126.303V118.042Z"
          fill="white"
        />
        <path
          d="M450.44 118.042L443.634 114.043L436.864 118.042V126.303L443.634 130.529L450.44 126.303V118.042Z"
          fill="white"
        />
        <path
          d="M465.955 118.042L459.149 114.043L452.379 118.042V126.303L459.149 130.529L465.955 126.303V118.042Z"
          fill="white"
        />
        <path
          d="M481.472 118.042L474.666 114.043L467.895 118.042V126.303L474.666 130.529L481.472 126.303V118.042Z"
          fill="white"
        />
        <path
          d="M496.988 118.042L490.182 114.043L483.411 118.042V126.303L490.182 130.529L496.988 126.303V118.042Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M512.503 118.042L505.697 114.043L498.927 118.042V126.303L505.697 130.529L512.503 126.303V118.042Z"
          fill="#8676FF"
        />
        <path
          d="M528.018 118.042L521.212 114.043L514.442 118.042V126.303L521.212 130.529L528.018 126.303V118.042Z"
          fill="white"
        />
        <path
          d="M543.535 118.042L536.729 114.043L529.959 118.042V126.303L536.729 130.529L543.535 126.303V118.042Z"
          fill="white"
        />
        <path
          d="M776.272 118.042L769.466 114.043L762.696 118.042V126.303L769.466 130.529L776.272 126.303V118.042Z"
          fill="white"
        />
        <path
          d="M791.788 118.042L784.982 114.043L778.212 118.042V126.303L784.982 130.529L791.788 126.303V118.042Z"
          fill="white"
        />
        <path
          d="M116.85 131.618L110.043 127.619L103.273 131.618V139.88L110.043 144.105L116.85 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M132.366 131.618L125.56 127.619L118.789 131.618V139.88L125.56 144.105L132.366 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M147.882 131.618L141.076 127.619L134.306 131.618V139.88L141.076 144.105L147.882 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M163.397 131.618L156.591 127.619L149.821 131.618V139.88L156.591 144.105L163.397 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M178.913 131.618L172.107 127.619L165.337 131.618V139.88L172.107 144.105L178.913 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M194.429 131.618L187.623 127.619L180.853 131.618V139.88L187.623 144.105L194.429 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M209.945 131.618L203.139 127.619L196.368 131.618V139.88L203.139 144.105L209.945 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M225.461 131.618L218.655 127.619L211.885 131.618V139.88L218.655 144.105L225.461 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M240.976 131.618L234.17 127.619L227.4 131.618V139.88L234.17 144.105L240.976 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M256.492 131.618L249.686 127.619L242.916 131.618V139.88L249.686 144.105L256.492 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M272.008 131.618L265.202 127.619L258.432 131.618V139.88L265.202 144.105L272.008 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M287.523 131.618L280.717 127.619L273.947 131.618V139.88L280.717 144.105L287.523 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M303.04 131.618L296.234 127.619L289.463 131.618V139.88L296.234 144.105L303.04 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M318.556 131.618L311.75 127.619L304.979 131.618V139.88L311.75 144.105L318.556 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M334.071 131.618L327.265 127.619L320.495 131.618V139.88L327.265 144.105L334.071 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M349.587 131.618L342.781 127.619L336.011 131.618V139.88L342.781 144.105L349.587 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M365.103 131.618L358.297 127.619L351.527 131.618V139.88L358.297 144.105L365.103 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M380.619 131.618L373.812 127.619L367.042 131.618V139.88L373.812 144.105L380.619 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M396.135 131.618L389.329 127.619L382.558 131.618V139.88L389.329 144.105L396.135 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M411.65 131.618L404.844 127.619L398.073 131.618V139.88L404.844 144.105L411.65 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M442.682 131.618L435.876 127.619L429.106 131.618V139.88L435.876 144.105L442.682 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M458.197 131.618L451.391 127.619L444.621 131.618V139.88L451.391 144.105L458.197 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M473.714 131.618L466.907 127.619L460.137 131.618V139.88L466.907 144.105L473.714 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M489.23 131.618L482.424 127.619L475.653 131.618V139.88L482.424 144.105L489.23 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M504.745 131.618L497.939 127.619L491.169 131.618V139.88L497.939 144.105L504.745 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M520.261 131.618L513.455 127.619L506.685 131.618V139.88L513.455 144.105L520.261 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M535.777 131.618L528.971 127.619L522.201 131.618V139.88L528.971 144.105L535.777 139.88V131.618Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M737.482 131.618L730.676 127.619L723.906 131.618V139.88L730.676 144.105L737.482 139.88V131.618Z"
          fill="#8676FF"
        />
        <path
          d="M752.998 131.618L746.192 127.619L739.421 131.618V139.88L746.192 144.105L752.998 139.88V131.618Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M768.514 131.618L761.708 127.619L754.938 131.618V139.88L761.708 144.105L768.514 139.88V131.618Z"
          fill="#8676FF"
        />
        <path
          d="M784.03 131.618L777.224 127.619L770.454 131.618V139.88L777.224 144.105L784.03 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M799.545 131.618L792.739 127.619L785.969 131.618V139.88L792.739 144.105L799.545 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M815.061 131.618L808.255 127.619L801.485 131.618V139.88L808.255 144.105L815.061 139.88V131.618Z"
          fill="#8676FF"
        />
        <path
          d="M830.577 131.618L823.77 127.619L817 131.618V139.88L823.77 144.105L830.577 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M846.093 131.618L839.287 127.619L832.516 131.618V139.88L839.287 144.105L846.093 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M861.609 131.618L854.803 127.619L848.032 131.618V139.88L854.803 144.105L861.609 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M109.093 145.194L102.286 141.195L95.5162 145.194V153.456L102.286 157.681L109.093 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M124.609 145.194L117.803 141.195L111.032 145.194V153.456L117.803 157.681L124.609 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M140.124 145.194L133.318 141.195L126.547 145.194V153.456L133.318 157.681L140.124 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M155.64 145.194L148.834 141.195L142.064 145.194V153.456L148.834 157.681L155.64 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M171.155 145.194L164.349 141.195L157.579 145.194V153.456L164.349 157.681L171.155 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M186.671 145.194L179.865 141.195L173.095 145.194V153.456L179.865 157.681L186.671 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M202.188 145.194L195.381 141.195L188.611 145.194V153.456L195.381 157.681L202.188 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M217.703 145.194L210.897 141.195L204.126 145.194V153.456L210.897 157.681L217.703 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M233.218 145.194L226.412 141.195L219.642 145.194V153.456L226.412 157.681L233.218 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M248.735 145.194L241.929 141.195L235.159 145.194V153.456L241.929 157.681L248.735 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M264.25 145.194L257.444 141.195L250.674 145.194V153.456L257.444 157.681L264.25 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M279.765 145.194L272.959 141.195L266.189 145.194V153.456L272.959 157.681L279.765 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M295.282 145.194L288.475 141.195L281.705 145.194V153.456L288.475 157.681L295.282 153.456V145.194Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M310.799 145.194L303.993 141.195L297.222 145.194V153.456L303.993 157.681L310.799 153.456V145.194Z"
          fill="#8676FF"
        />
        <path
          d="M326.313 145.194L319.507 141.195L312.737 145.194V153.456L319.507 157.681L326.313 153.456V145.194Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M341.829 145.194L335.023 141.195L328.253 145.194V153.456L335.023 157.681L341.829 153.456V145.194Z"
          fill="#8676FF"
        />
        <path
          d="M357.345 145.194L350.539 141.195L343.769 145.194V153.456L350.539 157.681L357.345 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M388.377 145.194L381.571 141.195L374.8 145.194V153.456L381.571 157.681L388.377 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M403.893 145.194L397.087 141.195L390.316 145.194V153.456L397.087 157.681L403.893 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M450.44 145.194L443.634 141.195L436.864 145.194V153.456L443.634 157.681L450.44 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M465.955 145.194L459.149 141.195L452.379 145.194V153.456L459.149 157.681L465.955 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M481.472 145.194L474.666 141.195L467.895 145.194V153.456L474.666 157.681L481.472 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M496.988 145.194L490.182 141.195L483.411 145.194V153.456L490.182 157.681L496.988 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M512.503 145.194L505.697 141.195L498.927 145.194V153.456L505.697 157.681L512.503 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M528.018 145.194L521.212 141.195L514.442 145.194V153.456L521.212 157.681L528.018 153.456V145.194Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M745.24 145.194L738.433 141.195L731.663 145.194V153.456L738.433 157.681L745.24 153.456V145.194Z"
          fill="#8676FF"
        />
        <path
          d="M760.756 145.194L753.95 141.195L747.179 145.194V153.456L753.95 157.681L760.756 153.456V145.194Z"
          fill="#8676FF"
        />
        <path
          d="M776.272 145.194L769.466 141.195L762.696 145.194V153.456L769.466 157.681L776.272 153.456V145.194Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M791.788 145.194L784.982 141.195L778.212 145.194V153.456L784.982 157.681L791.788 153.456V145.194Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M807.303 145.194L800.497 141.195L793.727 145.194V153.456L800.497 157.681L807.303 153.456V145.194Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M822.818 145.194L816.012 141.195L809.242 145.194V153.456L816.012 157.681L822.818 153.456V145.194Z"
          fill="#8676FF"
        />
        <path
          d="M838.336 145.194L831.53 141.195L824.759 145.194V153.456L831.53 157.681L838.336 153.456V145.194Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M853.851 145.194L847.045 141.195L840.274 145.194V153.456L847.045 157.681L853.851 153.456V145.194Z"
          fill="#8676FF"
        />
        <path
          d="M869.366 145.194L862.56 141.195L855.79 145.194V153.456L862.56 157.681L869.366 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M101.334 158.771L94.5283 154.772L87.7581 158.771V167.033L94.5283 171.258L101.334 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M116.85 158.771L110.043 154.772L103.273 158.771V167.033L110.043 171.258L116.85 167.033V158.771Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M132.366 158.771L125.56 154.772L118.789 158.771V167.033L125.56 171.258L132.366 167.033V158.771Z"
          fill="#8676FF"
        />
        <path
          d="M147.882 158.771L141.076 154.772L134.306 158.771V167.033L141.076 171.258L147.882 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M163.397 158.771L156.591 154.772L149.821 158.771V167.033L156.591 171.258L163.397 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M178.913 158.771L172.107 154.772L165.337 158.771V167.033L172.107 171.258L178.913 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M194.429 158.771L187.623 154.772L180.853 158.771V167.033L187.623 171.258L194.429 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M209.945 158.771L203.139 154.772L196.368 158.771V167.033L203.139 171.258L209.945 167.033V158.771Z"
          fill="#8676FF"
        />
        <path
          d="M225.461 158.771L218.655 154.772L211.885 158.771V167.033L218.655 171.258L225.461 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M240.976 158.771L234.17 154.772L227.4 158.771V167.033L234.17 171.258L240.976 167.033V158.771Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M256.492 158.771L249.686 154.772L242.916 158.771V167.033L249.686 171.258L256.492 167.033V158.771Z"
          fill="#8676FF"
        />
        <path
          d="M272.008 158.771L265.202 154.772L258.432 158.771V167.033L265.202 171.258L272.008 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M287.523 158.771L280.717 154.772L273.947 158.771V167.033L280.717 171.258L287.523 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M303.04 158.771L296.234 154.772L289.463 158.771V167.033L296.234 171.258L303.04 167.033V158.771Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M318.556 158.771L311.75 154.772L304.979 158.771V167.033L311.75 171.258L318.556 167.033V158.771Z"
          fill="#8676FF"
        />
        <path
          d="M334.071 158.771L327.265 154.772L320.495 158.771V167.033L327.265 171.258L334.071 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M349.587 158.771L342.781 154.772L336.011 158.771V167.033L342.781 171.258L349.587 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M380.619 158.771L373.812 154.772L367.042 158.771V167.033L373.812 171.258L380.619 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M396.135 158.771L389.329 154.772L382.558 158.771V167.033L389.329 171.258L396.135 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M411.65 158.771L404.844 154.772L398.073 158.771V167.033L404.844 171.258L411.65 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M458.197 158.771L451.391 154.772L444.621 158.771V167.033L451.391 171.258L458.197 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M473.714 158.771L466.907 154.772L460.137 158.771V167.033L466.907 171.258L473.714 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M489.23 158.771L482.424 154.772L475.653 158.771V167.033L482.424 171.258L489.23 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M504.745 158.771L497.939 154.772L491.169 158.771V167.033L497.939 171.258L504.745 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M520.261 158.771L513.455 154.772L506.685 158.771V167.033L513.455 171.258L520.261 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M551.292 158.771L544.486 154.772L537.716 158.771V167.033L544.486 171.258L551.292 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M566.809 158.771L560.002 154.772L553.232 158.771V167.033L560.002 171.258L566.809 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M721.966 158.771L715.16 154.772L708.39 158.771V167.033L715.16 171.258L721.966 167.033V158.771Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M737.482 158.771L730.676 154.772L723.906 158.771V167.033L730.676 171.258L737.482 167.033V158.771Z"
          fill="#8676FF"
        />
        <path
          d="M752.998 158.771L746.192 154.772L739.421 158.771V167.033L746.192 171.258L752.998 167.033V158.771Z"
          fill="#8676FF"
        />
        <path
          d="M768.514 158.771L761.708 154.772L754.938 158.771V167.033L761.708 171.258L768.514 167.033V158.771Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M784.03 158.771L777.224 154.772L770.454 158.771V167.033L777.224 171.258L784.03 167.033V158.771Z"
          fill="#8676FF"
        />
        <path
          d="M799.545 158.771L792.739 154.772L785.969 158.771V167.033L792.739 171.258L799.545 167.033V158.771Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M815.061 158.771L808.255 154.772L801.485 158.771V167.033L808.255 171.258L815.061 167.033V158.771Z"
          fill="#8676FF"
        />
        <path
          d="M830.577 158.771L823.77 154.772L817 158.771V167.033L823.77 171.258L830.577 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M846.093 158.771L839.287 154.772L832.516 158.771V167.033L839.287 171.258L846.093 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M861.609 158.771L854.803 154.772L848.032 158.771V167.033L854.803 171.258L861.609 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M93.5763 172.346L86.7703 168.348L80 172.346V180.608L86.7703 184.833L93.5763 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M109.093 172.346L102.286 168.348L95.5162 172.346V180.608L102.286 184.833L109.093 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M124.609 172.346L117.803 168.348L111.032 172.346V180.608L117.803 184.833L124.609 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M140.124 172.346L133.318 168.348L126.547 172.346V180.608L133.318 184.833L140.124 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M155.64 172.346L148.834 168.348L142.064 172.346V180.608L148.834 184.833L155.64 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M171.155 172.346L164.349 168.348L157.579 172.346V180.608L164.349 184.833L171.155 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M186.671 172.346L179.865 168.348L173.095 172.346V180.608L179.865 184.833L186.671 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M202.188 172.346L195.381 168.348L188.611 172.346V180.608L195.381 184.833L202.188 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M217.703 172.346L210.897 168.348L204.126 172.346V180.608L210.897 184.833L217.703 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M233.218 172.346L226.412 168.348L219.642 172.346V180.608L226.412 184.833L233.218 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M248.735 172.346L241.929 168.348L235.159 172.346V180.608L241.929 184.833L248.735 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M264.25 172.346L257.444 168.348L250.674 172.346V180.608L257.444 184.833L264.25 180.608V172.346Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M279.765 172.346L272.959 168.348L266.189 172.346V180.608L272.959 184.833L279.765 180.608V172.346Z"
          fill="#8676FF"
        />
        <path
          d="M295.282 172.346L288.475 168.348L281.705 172.346V180.608L288.475 184.833L295.282 180.608V172.346Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M310.799 172.346L303.993 168.348L297.222 172.346V180.608L303.993 184.833L310.799 180.608V172.346Z"
          fill="#8676FF"
        />
        <path
          d="M326.313 172.346L319.507 168.348L312.737 172.346V180.608L319.507 184.833L326.313 180.608V172.346Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M341.829 172.346L335.023 168.348L328.253 172.346V180.608L335.023 184.833L341.829 180.608V172.346Z"
          fill="#8676FF"
        />
        <path
          d="M357.345 172.346L350.539 168.348L343.769 172.346V180.608L350.539 184.833L357.345 180.608V172.346Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M372.861 172.346L366.055 168.348L359.285 172.346V180.608L366.055 184.833L372.861 180.608V172.346Z"
          fill="#8676FF"
        />
        <path
          d="M388.377 172.346L381.571 168.348L374.8 172.346V180.608L381.571 184.833L388.377 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M403.893 172.346L397.087 168.348L390.316 172.346V180.608L397.087 184.833L403.893 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M450.44 172.346L443.634 168.348L436.864 172.346V180.608L443.634 184.833L450.44 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M465.955 172.346L459.149 168.348L452.379 172.346V180.608L459.149 184.833L465.955 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M481.472 172.346L474.666 168.348L467.895 172.346V180.608L474.666 184.833L481.472 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M496.988 172.346L490.182 168.348L483.411 172.346V180.608L490.182 184.833L496.988 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M543.535 172.346L536.729 168.348L529.959 172.346V180.608L536.729 184.833L543.535 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M559.05 172.346L552.244 168.348L545.474 172.346V180.608L552.244 184.833L559.05 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M574.566 172.346L567.76 168.348L560.989 172.346V180.608L567.76 184.833L574.566 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M683.177 172.346L676.371 168.348L669.601 172.346V180.608L676.371 184.833L683.177 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M729.724 172.346L722.918 168.348L716.148 172.346V180.608L722.918 184.833L729.724 180.608V172.346Z"
          fill="#D45AFF"
        />
        <path
          opacity="0.3"
          d="M745.24 172.346L738.433 168.348L731.663 172.346V180.608L738.433 184.833L745.24 180.608V172.346Z"
          fill="#8676FF"
        />
        <path
          d="M760.756 172.346L753.95 168.348L747.179 172.346V180.608L753.95 184.833L760.756 180.608V172.346Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M776.272 172.346L769.466 168.348L762.696 172.346V180.608L769.466 184.833L776.272 180.608V172.346Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M791.788 172.346L784.982 168.348L778.212 172.346V180.608L784.982 184.833L791.788 180.608V172.346Z"
          fill="#8676FF"
        />
        <path
          d="M807.303 172.346L800.497 168.348L793.727 172.346V180.608L800.497 184.833L807.303 180.608V172.346Z"
          fill="#8676FF"
        />
        <path
          d="M822.818 172.346L816.012 168.348L809.242 172.346V180.608L816.012 184.833L822.818 180.608V172.346Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M838.336 172.346L831.53 168.348L824.759 172.346V180.608L831.53 184.833L838.336 180.608V172.346Z"
          fill="#8676FF"
        />
        <path
          d="M853.851 172.346L847.045 168.348L840.274 172.346V180.608L847.045 184.833L853.851 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M869.366 172.346L862.56 168.348L855.79 172.346V180.608L862.56 184.833L869.366 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M101.334 185.922L94.5283 181.923L87.7581 185.922V194.183L94.5283 198.408L101.334 194.183V185.922Z"
          fill="white"
        />
        <path
          d="M163.397 185.922L156.591 181.923L149.821 185.922V194.183L156.591 198.408L163.397 194.183V185.922Z"
          fill="white"
        />
        <path
          d="M178.913 185.922L172.107 181.923L165.337 185.922V194.183L172.107 198.408L178.913 194.183V185.922Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M194.429 185.922L187.623 181.923L180.853 185.922V194.183L187.623 198.408L194.429 194.183V185.922Z"
          fill="#8676FF"
        />
        <path
          d="M209.945 185.922L203.139 181.923L196.368 185.922V194.183L203.139 198.408L209.945 194.183V185.922Z"
          fill="white"
        />
        <path
          d="M225.461 185.922L218.655 181.923L211.885 185.922V194.183L218.655 198.408L225.461 194.183V185.922Z"
          fill="white"
        />
        <path
          d="M240.976 185.922L234.17 181.923L227.4 185.922V194.183L234.17 198.408L240.976 194.183V185.922Z"
          fill="white"
        />
        <path
          d="M256.492 185.922L249.686 181.923L242.916 185.922V194.183L249.686 198.408L256.492 194.183V185.922Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M272.008 185.922L265.202 181.923L258.432 185.922V194.183L265.202 198.408L272.008 194.183V185.922Z"
          fill="#8676FF"
        />
        <path
          d="M287.523 185.922L280.717 181.923L273.947 185.922V194.183L280.717 198.408L287.523 194.183V185.922Z"
          fill="white"
        />
        <path
          d="M303.04 185.922L296.234 181.923L289.463 185.922V194.183L296.234 198.408L303.04 194.183V185.922Z"
          fill="white"
        />
        <path
          d="M365.103 185.922L358.297 181.923L351.527 185.922V194.183L358.297 198.408L365.103 194.183V185.922Z"
          fill="white"
        />
        <path
          d="M380.619 185.922L373.812 181.923L367.042 185.922V194.183L373.812 198.408L380.619 194.183V185.922Z"
          fill="white"
        />
        <path
          d="M396.135 185.922L389.329 181.923L382.558 185.922V194.183L389.329 198.408L396.135 194.183V185.922Z"
          fill="white"
        />
        <path
          d="M458.197 185.922L451.391 181.923L444.621 185.922V194.183L451.391 198.408L458.197 194.183V185.922Z"
          fill="white"
        />
        <path
          d="M473.714 185.922L466.907 181.923L460.137 185.922V194.183L466.907 198.408L473.714 194.183V185.922Z"
          fill="white"
        />
        <path
          d="M489.23 185.922L482.424 181.923L475.653 185.922V194.183L482.424 198.408L489.23 194.183V185.922Z"
          fill="white"
        />
        <path
          d="M566.809 185.922L560.002 181.923L553.232 185.922V194.183L560.002 198.408L566.809 194.183V185.922Z"
          fill="white"
        />
        <path
          d="M675.419 185.922L668.613 181.923L661.843 185.922V194.183L668.613 198.408L675.419 194.183V185.922Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M721.966 185.922L715.16 181.923L708.39 185.922V194.183L715.16 198.408L721.966 194.183V185.922Z"
          fill="#8676FF"
        />
        <path
          d="M737.482 185.922L730.676 181.923L723.906 185.922V194.183L730.676 198.408L737.482 194.183V185.922Z"
          fill="#8676FF"
        />
        <path
          d="M752.998 185.922L746.192 181.923L739.421 185.922V194.183L746.192 198.408L752.998 194.183V185.922Z"
          fill="#FF2D2E"
        />
        <path
          d="M768.514 185.922L761.708 181.923L754.938 185.922V194.183L761.708 198.408L768.514 194.183V185.922Z"
          fill="#FF2D2E"
        />
        <path
          opacity="0.3"
          d="M784.03 185.922L777.224 181.923L770.454 185.922V194.183L777.224 198.408L784.03 194.183V185.922Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M799.545 185.922L792.739 181.923L785.969 185.922V194.183L792.739 198.408L799.545 194.183V185.922Z"
          fill="#8676FF"
        />
        <path
          d="M815.061 185.922L808.255 181.923L801.485 185.922V194.183L808.255 198.408L815.061 194.183V185.922Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M830.577 185.922L823.77 181.923L817 185.922V194.183L823.77 198.408L830.577 194.183V185.922Z"
          fill="#8676FF"
        />
        <path
          d="M846.093 185.922L839.287 181.923L832.516 185.922V194.183L839.287 198.408L846.093 194.183V185.922Z"
          fill="white"
        />
        <path
          d="M861.609 185.922L854.803 181.923L848.032 185.922V194.183L854.803 198.408L861.609 194.183V185.922Z"
          fill="white"
        />
        <path
          d="M171.155 199.501L164.349 195.502L157.579 199.501V207.762L164.349 211.987L171.155 207.762V199.501Z"
          fill="white"
        />
        <path
          d="M186.671 199.501L179.865 195.502L173.095 199.501V207.762L179.865 211.987L186.671 207.762V199.501Z"
          fill="white"
        />
        <path
          d="M202.188 199.501L195.381 195.502L188.611 199.501V207.762L195.381 211.987L202.188 207.762V199.501Z"
          fill="white"
        />
        <path
          d="M217.703 199.501L210.897 195.502L204.126 199.501V207.762L210.897 211.987L217.703 207.762V199.501Z"
          fill="white"
        />
        <path
          d="M233.218 199.501L226.412 195.502L219.642 199.501V207.762L226.412 211.987L233.218 207.762V199.501Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M248.735 199.501L241.929 195.502L235.159 199.501V207.762L241.929 211.987L248.735 207.762V199.501Z"
          fill="#8676FF"
        />
        <path
          d="M264.25 199.501L257.444 195.502L250.674 199.501V207.762L257.444 211.987L264.25 207.762V199.501Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M279.765 199.501L272.959 195.502L266.189 199.501V207.762L272.959 211.987L279.765 207.762V199.501Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M295.282 199.501L288.475 195.502L281.705 199.501V207.762L288.475 211.987L295.282 207.762V199.501Z"
          fill="#8676FF"
        />
        <path
          d="M310.799 199.501L303.993 195.502L297.222 199.501V207.762L303.993 211.987L310.799 207.762V199.501Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M372.861 199.501L366.055 195.502L359.285 199.501V207.762L366.055 211.987L372.861 207.762V199.501Z"
          fill="#8676FF"
        />
        <path
          d="M388.377 199.501L381.571 195.502L374.8 199.501V207.762L381.571 211.987L388.377 207.762V199.501Z"
          fill="white"
        />
        <path
          d="M403.893 199.501L397.087 195.502L390.316 199.501V207.762L397.087 211.987L403.893 207.762V199.501Z"
          fill="white"
        />
        <path
          d="M465.955 199.501L459.149 195.502L452.379 199.501V207.762L459.149 211.987L465.955 207.762V199.501Z"
          fill="white"
        />
        <path
          d="M481.472 199.501L474.666 195.502L467.895 199.501V207.762L474.666 211.987L481.472 207.762V199.501Z"
          fill="white"
        />
        <path
          d="M652.144 199.501L645.338 195.502L638.568 199.501V207.762L645.338 211.987L652.144 207.762V199.501Z"
          fill="#8676FF"
        />
        <path
          d="M667.662 199.501L660.856 195.502L654.085 199.501V207.762L660.856 211.987L667.662 207.762V199.501Z"
          fill="#8676FF"
        />
        <path
          d="M683.177 199.501L676.371 195.502L669.601 199.501V207.762L676.371 211.987L683.177 207.762V199.501Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M729.724 199.501L722.918 195.502L716.148 199.501V207.762L722.918 211.987L729.724 207.762V199.501Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M745.24 199.501L738.433 195.502L731.663 199.501V207.762L738.433 211.987L745.24 207.762V199.501Z"
          fill="#8676FF"
        />
        <path
          d="M760.756 199.501L753.95 195.502L747.179 199.501V207.762L753.95 211.987L760.756 207.762V199.501Z"
          fill="#FF2D2E"
        />
        <path
          d="M776.272 199.501L769.466 195.502L762.696 199.501V207.762L769.466 211.987L776.272 207.762V199.501Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M791.788 199.501L784.982 195.502L778.212 199.501V207.762L784.982 211.987L791.788 207.762V199.501Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M807.303 199.501L800.497 195.502L793.727 199.501V207.762L800.497 211.987L807.303 207.762V199.501Z"
          fill="#8676FF"
        />
        <path
          d="M822.818 199.501L816.012 195.502L809.242 199.501V207.762L816.012 211.987L822.818 207.762V199.501Z"
          fill="white"
        />
        <path
          d="M838.336 199.501L831.53 195.502L824.759 199.501V207.762L831.53 211.987L838.336 207.762V199.501Z"
          fill="white"
        />
        <path
          d="M853.851 199.501L847.045 195.502L840.274 199.501V207.762L847.045 211.987L853.851 207.762V199.501Z"
          fill="white"
        />
        <path
          d="M869.366 199.501L862.56 195.502L855.79 199.501V207.762L862.56 211.987L869.366 207.762V199.501Z"
          fill="white"
        />
        <path
          d="M163.397 213.077L156.591 209.078L149.821 213.077V221.339L156.591 225.564L163.397 221.339V213.077Z"
          fill="white"
        />
        <path
          d="M178.913 213.077L172.107 209.078L165.337 213.077V221.339L172.107 225.564L178.913 221.339V213.077Z"
          fill="white"
        />
        <path
          d="M194.429 213.077L187.623 209.078L180.853 213.077V221.339L187.623 225.564L194.429 221.339V213.077Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M209.945 213.077L203.139 209.078L196.368 213.077V221.339L203.139 225.564L209.945 221.339V213.077Z"
          fill="#8676FF"
        />
        <path
          d="M225.461 213.077L218.655 209.078L211.885 213.077V221.339L218.655 225.564L225.461 221.339V213.077Z"
          fill="white"
        />
        <path
          d="M240.976 213.077L234.17 209.078L227.4 213.077V221.339L234.17 225.564L240.976 221.339V213.077Z"
          fill="white"
        />
        <path
          d="M256.492 213.077L249.686 209.078L242.916 213.077V221.339L249.686 225.564L256.492 221.339V213.077Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M272.008 213.077L265.202 209.078L258.432 213.077V221.339L265.202 225.564L272.008 221.339V213.077Z"
          fill="#8676FF"
        />
        <path
          d="M287.523 213.077L280.717 209.078L273.947 213.077V221.339L280.717 225.564L287.523 221.339V213.077Z"
          fill="white"
        />
        <path
          d="M303.04 213.077L296.234 209.078L289.463 213.077V221.339L296.234 225.564L303.04 221.339V213.077Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M318.556 213.077L311.75 209.078L304.979 213.077V221.339L311.75 225.564L318.556 221.339V213.077Z"
          fill="#8676FF"
        />
        <path
          d="M365.103 213.077L358.297 209.078L351.527 213.077V221.339L358.297 225.564L365.103 221.339V213.077Z"
          fill="white"
        />
        <path
          d="M380.619 213.077L373.812 209.078L367.042 213.077V221.339L373.812 225.564L380.619 221.339V213.077Z"
          fill="white"
        />
        <path
          d="M396.135 213.077L389.329 209.078L382.558 213.077V221.339L389.329 225.564L396.135 221.339V213.077Z"
          fill="white"
        />
        <path
          d="M659.904 213.077L653.098 209.078L646.327 213.077V221.339L653.098 225.564L659.904 221.339V213.077Z"
          fill="white"
        />
        <path
          d="M675.419 213.077L668.613 209.078L661.843 213.077V221.339L668.613 225.564L675.419 221.339V213.077Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M690.934 213.077L684.128 209.078L677.358 213.077V221.339L684.128 225.564L690.934 221.339V213.077Z"
          fill="#8676FF"
        />
        <path
          d="M706.45 213.077L699.644 209.078L692.874 213.077V221.339L699.644 225.564L706.45 221.339V213.077Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M721.966 213.077L715.16 209.078L708.39 213.077V221.339L715.16 225.564L721.966 221.339V213.077Z"
          fill="#8676FF"
        />
        <path
          d="M737.482 213.077L730.676 209.078L723.906 213.077V221.339L730.676 225.564L737.482 221.339V213.077Z"
          fill="#FF2D2E"
        />
        <path
          opacity="0.3"
          d="M752.998 213.077L746.192 209.078L739.421 213.077V221.339L746.192 225.564L752.998 221.339V213.077Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M768.514 213.077L761.708 209.078L754.938 213.077V221.339L761.708 225.564L768.514 221.339V213.077Z"
          fill="#8676FF"
        />
        <path
          d="M784.03 213.077L777.224 209.078L770.454 213.077V221.339L777.224 225.564L784.03 221.339V213.077Z"
          fill="#8676FF"
        />
        <path
          d="M799.545 213.077L792.739 209.078L785.969 213.077V221.339L792.739 225.564L799.545 221.339V213.077Z"
          fill="#8676FF"
        />
        <path
          d="M815.061 213.077L808.255 209.078L801.485 213.077V221.339L808.255 225.564L815.061 221.339V213.077Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M830.577 213.077L823.77 209.078L817 213.077V221.339L823.77 225.564L830.577 221.339V213.077Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M846.093 213.077L839.287 209.078L832.516 213.077V221.339L839.287 225.564L846.093 221.339V213.077Z"
          fill="#8676FF"
        />
        <path
          d="M861.609 213.077L854.803 209.078L848.032 213.077V221.339L854.803 225.564L861.609 221.339V213.077Z"
          fill="white"
        />
        <path
          d="M171.155 226.653L164.349 222.654L157.579 226.653V234.915L164.349 239.14L171.155 234.915V226.653Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M186.671 226.653L179.865 222.654L173.095 226.653V234.915L179.865 239.14L186.671 234.915V226.653Z"
          fill="#8676FF"
        />
        <path
          d="M202.188 226.653L195.381 222.654L188.611 226.653V234.915L195.381 239.14L202.188 234.915V226.653Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M217.703 226.653L210.897 222.654L204.126 226.653V234.915L210.897 239.14L217.703 234.915V226.653Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M233.218 226.653L226.412 222.654L219.642 226.653V234.915L226.412 239.14L233.218 234.915V226.653Z"
          fill="#8676FF"
        />
        <path
          d="M248.735 226.653L241.929 222.654L235.159 226.653V234.915L241.929 239.14L248.735 234.915V226.653Z"
          fill="#8676FF"
        />
        <path
          d="M264.25 226.653L257.444 222.654L250.674 226.653V234.915L257.444 239.14L264.25 234.915V226.653Z"
          fill="white"
        />
        <path
          d="M279.765 226.653L272.959 222.654L266.189 226.653V234.915L272.959 239.14L279.765 234.915V226.653Z"
          fill="white"
        />
        <path
          d="M295.282 226.653L288.475 222.654L281.705 226.653V234.915L288.475 239.14L295.282 234.915V226.653Z"
          fill="white"
        />
        <path
          d="M310.799 226.653L303.993 222.654L297.222 226.653V234.915L303.993 239.14L310.799 234.915V226.653Z"
          fill="white"
        />
        <path
          d="M326.313 226.653L319.507 222.654L312.737 226.653V234.915L319.507 239.14L326.313 234.915V226.653Z"
          fill="white"
        />
        <path
          d="M357.345 226.653L350.539 222.654L343.769 226.653V234.915L350.539 239.14L357.345 234.915V226.653Z"
          fill="white"
        />
        <path
          d="M372.861 226.653L366.055 222.654L359.285 226.653V234.915L366.055 239.14L372.861 234.915V226.653Z"
          fill="white"
        />
        <path
          d="M388.377 226.653L381.571 222.654L374.8 226.653V234.915L381.571 239.14L388.377 234.915V226.653Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M403.893 226.653L397.087 222.654L390.316 226.653V234.915L397.087 239.14L403.893 234.915V226.653Z"
          fill="#8676FF"
        />
        <path
          d="M419.408 226.653L412.602 222.654L405.832 226.653V234.915L412.602 239.14L419.408 234.915V226.653Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M683.177 226.653L676.371 222.654L669.601 226.653V234.915L676.371 239.14L683.177 234.915V226.653Z"
          fill="#8676FF"
        />
        <path
          d="M698.693 226.653L691.887 222.654L685.117 226.653V234.915L691.887 239.14L698.693 234.915V226.653Z"
          fill="white"
        />
        <path
          d="M714.209 226.653L707.403 222.654L700.633 226.653V234.915L707.403 239.14L714.209 234.915V226.653Z"
          fill="#D45AFF"
        />
        <path
          opacity="0.3"
          d="M729.724 226.653L722.918 222.654L716.148 226.653V234.915L722.918 239.14L729.724 234.915V226.653Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M745.24 226.653L738.433 222.654L731.663 226.653V234.915L738.433 239.14L745.24 234.915V226.653Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M760.756 226.653L753.95 222.654L747.179 226.653V234.915L753.95 239.14L760.756 234.915V226.653Z"
          fill="#8676FF"
        />
        <path
          d="M776.272 226.653L769.466 222.654L762.696 226.653V234.915L769.466 239.14L776.272 234.915V226.653Z"
          fill="#FF2D2E"
        />
        <path
          opacity="0.3"
          d="M791.788 226.653L784.982 222.654L778.212 226.653V234.915L784.982 239.14L791.788 234.915V226.653Z"
          fill="#8676FF"
        />
        <path
          d="M807.303 226.653L800.497 222.654L793.727 226.653V234.915L800.497 239.14L807.303 234.915V226.653Z"
          fill="white"
        />
        <path
          d="M822.818 226.653L816.012 222.654L809.242 226.653V234.915L816.012 239.14L822.818 234.915V226.653Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M838.336 226.653L831.53 222.654L824.759 226.653V234.915L831.53 239.14L838.336 234.915V226.653Z"
          fill="#8676FF"
        />
        <path
          d="M853.851 226.653L847.045 222.654L840.274 226.653V234.915L847.045 239.14L853.851 234.915V226.653Z"
          fill="white"
        />
        <path
          d="M869.366 226.653L862.56 222.654L855.79 226.653V234.915L862.56 239.14L869.366 234.915V226.653Z"
          fill="white"
        />
        <path
          d="M163.397 240.228L156.591 236.229L149.821 240.228V248.49L156.591 252.715L163.397 248.49V240.228Z"
          fill="white"
        />
        <path
          d="M178.913 240.228L172.107 236.229L165.337 240.228V248.49L172.107 252.715L178.913 248.49V240.228Z"
          fill="white"
        />
        <path
          d="M194.429 240.228L187.623 236.229L180.853 240.228V248.49L187.623 252.715L194.429 248.49V240.228Z"
          fill="white"
        />
        <path
          d="M209.945 240.228L203.139 236.229L196.368 240.228V248.49L203.139 252.715L209.945 248.49V240.228Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M225.461 240.228L218.655 236.229L211.885 240.228V248.49L218.655 252.715L225.461 248.49V240.228Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M240.976 240.228L234.17 236.229L227.4 240.228V248.49L234.17 252.715L240.976 248.49V240.228Z"
          fill="#8676FF"
        />
        <path
          d="M256.492 240.228L249.686 236.229L242.916 240.228V248.49L249.686 252.715L256.492 248.49V240.228Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M272.008 240.228L265.202 236.229L258.432 240.228V248.49L265.202 252.715L272.008 248.49V240.228Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M287.523 240.228L280.717 236.229L273.947 240.228V248.49L280.717 252.715L287.523 248.49V240.228Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M303.04 240.228L296.234 236.229L289.463 240.228V248.49L296.234 252.715L303.04 248.49V240.228Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M318.556 240.228L311.75 236.229L304.979 240.228V248.49L311.75 252.715L318.556 248.49V240.228Z"
          fill="#8676FF"
        />
        <path
          d="M334.071 240.228L327.265 236.229L320.495 240.228V248.49L327.265 252.715L334.071 248.49V240.228Z"
          fill="white"
        />
        <path
          d="M349.587 240.228L342.781 236.229L336.011 240.228V248.49L342.781 252.715L349.587 248.49V240.228Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M365.103 240.228L358.297 236.229L351.527 240.228V248.49L358.297 252.715L365.103 248.49V240.228Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M380.619 240.228L373.812 236.229L367.042 240.228V248.49L373.812 252.715L380.619 248.49V240.228Z"
          fill="#8676FF"
        />
        <path
          d="M396.135 240.228L389.329 236.229L382.558 240.228V248.49L389.329 252.715L396.135 248.49V240.228Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M411.65 240.228L404.844 236.229L398.073 240.228V248.49L404.844 252.715L411.65 248.49V240.228Z"
          fill="#8676FF"
        />
        <path
          d="M427.166 240.228L420.36 236.229L413.59 240.228V248.49L420.36 252.715L427.166 248.49V240.228Z"
          fill="white"
        />
        <path
          d="M690.934 240.228L684.128 236.229L677.358 240.228V248.49L684.128 252.715L690.934 248.49V240.228Z"
          fill="#8676FF"
        />
        <path
          d="M706.45 240.228L699.644 236.229L692.874 240.228V248.49L699.644 252.715L706.45 248.49V240.228Z"
          fill="white"
        />
        <path
          d="M721.966 240.228L715.16 236.229L708.39 240.228V248.49L715.16 252.715L721.966 248.49V240.228Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M737.482 240.228L730.676 236.229L723.906 240.228V248.49L730.676 252.715L737.482 248.49V240.228Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M752.998 240.228L746.192 236.229L739.421 240.228V248.49L746.192 252.715L752.998 248.49V240.228Z"
          fill="#8676FF"
        />
        <path
          d="M768.514 240.228L761.708 236.229L754.938 240.228V248.49L761.708 252.715L768.514 248.49V240.228Z"
          fill="#D45AFF"
        />
        <path
          d="M784.03 240.228L777.224 236.229L770.454 240.228V248.49L777.224 252.715L784.03 248.49V240.228Z"
          fill="white"
        />
        <path
          d="M799.545 240.228L792.739 236.229L785.969 240.228V248.49L792.739 252.715L799.545 248.49V240.228Z"
          fill="white"
        />
        <path
          d="M815.061 240.228L808.255 236.229L801.485 240.228V248.49L808.255 252.715L815.061 248.49V240.228Z"
          fill="white"
        />
        <path
          d="M830.577 240.228L823.77 236.229L817 240.228V248.49L823.77 252.715L830.577 248.49V240.228Z"
          fill="white"
        />
        <path
          d="M846.093 240.228L839.287 236.229L832.516 240.228V248.49L839.287 252.715L846.093 248.49V240.228Z"
          fill="white"
        />
        <path
          d="M861.609 240.228L854.803 236.229L848.032 240.228V248.49L854.803 252.715L861.609 248.49V240.228Z"
          fill="white"
        />
        <path
          d="M155.64 253.804L148.834 249.806L142.064 253.804V262.066L148.834 266.291L155.64 262.066V253.804Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M171.155 253.804L164.349 249.806L157.579 253.804V262.066L164.349 266.291L171.155 262.066V253.804Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M186.671 253.804L179.865 249.806L173.095 253.804V262.066L179.865 266.291L186.671 262.066V253.804Z"
          fill="#8676FF"
        />
        <path
          d="M202.188 253.804L195.381 249.806L188.611 253.804V262.066L195.381 266.291L202.188 262.066V253.804Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M217.703 253.804L210.897 249.806L204.126 253.804V262.066L210.897 266.291L217.703 262.066V253.804Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M233.218 253.804L226.412 249.806L219.642 253.804V262.066L226.412 266.291L233.218 262.066V253.804Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M248.735 253.804L241.929 249.806L235.159 253.804V262.066L241.929 266.291L248.735 262.066V253.804Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M264.25 253.804L257.444 249.806L250.674 253.804V262.066L257.444 266.291L264.25 262.066V253.804Z"
          fill="#8676FF"
        />
        <path
          d="M279.765 253.804L272.959 249.806L266.189 253.804V262.066L272.959 266.291L279.765 262.066V253.804Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M295.282 253.804L288.475 249.806L281.705 253.804V262.066L288.475 266.291L295.282 262.066V253.804Z"
          fill="#8676FF"
        />
        <path
          d="M310.799 253.804L303.993 249.806L297.222 253.804V262.066L303.993 266.291L310.799 262.066V253.804Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M326.313 253.804L319.507 249.806L312.737 253.804V262.066L319.507 266.291L326.313 262.066V253.804Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M341.829 253.804L335.023 249.806L328.253 253.804V262.066L335.023 266.291L341.829 262.066V253.804Z"
          fill="#8676FF"
        />
        <path
          d="M357.345 253.804L350.539 249.806L343.769 253.804V262.066L350.539 266.291L357.345 262.066V253.804Z"
          fill="white"
        />
        <path
          d="M372.861 253.804L366.055 249.806L359.285 253.804V262.066L366.055 266.291L372.861 262.066V253.804Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M388.377 253.804L381.571 249.806L374.8 253.804V262.066L381.571 266.291L388.377 262.066V253.804Z"
          fill="#8676FF"
        />
        <path
          d="M434.924 253.804L428.118 249.806L421.348 253.804V262.066L428.118 266.291L434.924 262.066V253.804Z"
          fill="white"
        />
        <path
          d="M683.177 253.804L676.371 249.806L669.601 253.804V262.066L676.371 266.291L683.177 262.066V253.804Z"
          fill="white"
        />
        <path
          d="M698.693 253.804L691.887 249.806L685.117 253.804V262.066L691.887 266.291L698.693 262.066V253.804Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M714.209 253.804L707.403 249.806L700.633 253.804V262.066L707.403 266.291L714.209 262.066V253.804Z"
          fill="#8676FF"
        />
        <path
          d="M729.724 253.804L722.918 249.806L716.148 253.804V262.066L722.918 266.291L729.724 262.066V253.804Z"
          fill="white"
        />
        <path
          d="M745.24 253.804L738.433 249.806L731.663 253.804V262.066L738.433 266.291L745.24 262.066V253.804Z"
          fill="#8676FF"
        />
        <path
          d="M760.756 253.804L753.95 249.806L747.179 253.804V262.066L753.95 266.291L760.756 262.066V253.804Z"
          fill="#8676FF"
        />
        <path
          d="M776.272 253.804L769.466 249.806L762.696 253.804V262.066L769.466 266.291L776.272 262.066V253.804Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M791.788 253.804L784.982 249.806L778.212 253.804V262.066L784.982 266.291L791.788 262.066V253.804Z"
          fill="#8676FF"
        />
        <path
          d="M807.303 253.804L800.497 249.806L793.727 253.804V262.066L800.497 266.291L807.303 262.066V253.804Z"
          fill="white"
        />
        <path
          d="M869.366 253.804L862.56 249.806L855.79 253.804V262.066L862.56 266.291L869.366 262.066V253.804Z"
          fill="white"
        />
        <path
          d="M147.882 267.382L141.076 263.383L134.306 267.382V275.643L141.076 279.868L147.882 275.643V267.382Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M163.397 267.382L156.591 263.383L149.821 267.382V275.643L156.591 279.868L163.397 275.643V267.382Z"
          fill="#8676FF"
        />
        <path
          d="M178.913 267.382L172.107 263.383L165.337 267.382V275.643L172.107 279.868L178.913 275.643V267.382Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M194.429 267.382L187.623 263.383L180.853 267.382V275.643L187.623 279.868L194.429 275.643V267.382Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M209.945 267.382L203.139 263.383L196.368 267.382V275.643L203.139 279.868L209.945 275.643V267.382Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M225.461 267.382L218.655 263.383L211.885 267.382V275.643L218.655 279.868L225.461 275.643V267.382Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M240.976 267.382L234.17 263.383L227.4 267.382V275.643L234.17 279.868L240.976 275.643V267.382Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M256.492 267.382L249.686 263.383L242.916 267.382V275.643L249.686 279.868L256.492 275.643V267.382Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M272.008 267.382L265.202 263.383L258.432 267.382V275.643L265.202 279.868L272.008 275.643V267.382Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M287.523 267.382L280.717 263.383L273.947 267.382V275.643L280.717 279.868L287.523 275.643V267.382Z"
          fill="#8676FF"
        />
        <path
          d="M303.04 267.382L296.234 263.383L289.463 267.382V275.643L296.234 279.868L303.04 275.643V267.382Z"
          fill="#FF2D2E"
        />
        <path
          d="M318.556 267.382L311.75 263.383L304.979 267.382V275.643L311.75 279.868L318.556 275.643V267.382Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M334.071 267.382L327.265 263.383L320.495 267.382V275.643L327.265 279.868L334.071 275.643V267.382Z"
          fill="#8676FF"
        />
        <path
          d="M349.587 267.382L342.781 263.383L336.011 267.382V275.643L342.781 279.868L349.587 275.643V267.382Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M365.103 267.382L358.297 263.383L351.527 267.382V275.643L358.297 279.868L365.103 275.643V267.382Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M380.619 267.382L373.812 263.383L367.042 267.382V275.643L373.812 279.868L380.619 275.643V267.382Z"
          fill="#8676FF"
        />
        <path
          d="M396.135 267.382L389.329 263.383L382.558 267.382V275.643L389.329 279.868L396.135 275.643V267.382Z"
          fill="white"
        />
        <path
          d="M442.682 267.382L435.876 263.383L429.106 267.382V275.643L435.876 279.868L442.682 275.643V267.382Z"
          fill="white"
        />
        <path
          d="M644.386 267.382L637.58 263.383L630.81 267.382V275.643L637.58 279.868L644.386 275.643V267.382Z"
          fill="white"
        />
        <path
          d="M659.904 267.382L653.098 263.383L646.327 267.382V275.643L653.098 279.868L659.904 275.643V267.382Z"
          fill="white"
        />
        <path
          d="M675.419 267.382L668.613 263.383L661.843 267.382V275.643L668.613 279.868L675.419 275.643V267.382Z"
          fill="white"
        />
        <path
          d="M690.934 267.382L684.128 263.383L677.358 267.382V275.643L684.128 279.868L690.934 275.643V267.382Z"
          fill="#8676FF"
        />
        <path
          d="M752.998 267.382L746.192 263.383L739.421 267.382V275.643L746.192 279.868L752.998 275.643V267.382Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M768.514 267.382L761.708 263.383L754.938 267.382V275.643L761.708 279.868L768.514 275.643V267.382Z"
          fill="#8676FF"
        />
        <path
          d="M784.03 267.382L777.224 263.383L770.454 267.382V275.643L777.224 279.868L784.03 275.643V267.382Z"
          fill="#D45AFF"
        />
        <path
          d="M799.545 267.382L792.739 263.383L785.969 267.382V275.643L792.739 279.868L799.545 275.643V267.382Z"
          fill="white"
        />
        <path
          d="M155.64 280.957L148.834 276.958L142.064 280.957V289.218L148.834 293.444L155.64 289.218V280.957Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M171.155 280.957L164.349 276.958L157.579 280.957V289.218L164.349 293.444L171.155 289.218V280.957Z"
          fill="#8676FF"
        />
        <path
          d="M186.671 280.957L179.865 276.958L173.095 280.957V289.218L179.865 293.444L186.671 289.218V280.957Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M202.188 280.957L195.381 276.958L188.611 280.957V289.218L195.381 293.444L202.188 289.218V280.957Z"
          fill="#8676FF"
        />
        <path
          d="M217.703 280.957L210.897 276.958L204.126 280.957V289.218L210.897 293.444L217.703 289.218V280.957Z"
          fill="white"
        />
        <path
          d="M233.218 280.957L226.412 276.958L219.642 280.957V289.218L226.412 293.444L233.218 289.218V280.957Z"
          fill="#8676FF"
        />
        <path
          d="M248.735 280.957L241.929 276.958L235.159 280.957V289.218L241.929 293.444L248.735 289.218V280.957Z"
          fill="#8676FF"
        />
        <path
          d="M264.25 280.957L257.444 276.958L250.674 280.957V289.218L257.444 293.444L264.25 289.218V280.957Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M279.765 280.957L272.959 276.958L266.189 280.957V289.218L272.959 293.444L279.765 289.218V280.957Z"
          fill="#8676FF"
        />
        <path
          d="M295.282 280.957L288.475 276.958L281.705 280.957V289.218L288.475 293.444L295.282 289.218V280.957Z"
          fill="#FF2D2E"
        />
        <path
          d="M310.799 280.957L303.993 276.958L297.222 280.957V289.218L303.993 293.444L310.799 289.218V280.957Z"
          fill="#FF2D2E"
        />
        <path
          d="M326.313 280.957L319.507 276.958L312.737 280.957V289.218L319.507 293.444L326.313 289.218V280.957Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M341.829 280.957L335.023 276.958L328.253 280.957V289.218L335.023 293.444L341.829 289.218V280.957Z"
          fill="#8676FF"
        />
        <path
          d="M357.345 280.957L350.539 276.958L343.769 280.957V289.218L350.539 293.444L357.345 289.218V280.957Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M372.861 280.957L366.055 276.958L359.285 280.957V289.218L366.055 293.444L372.861 289.218V280.957Z"
          fill="#8676FF"
        />
        <path
          d="M403.893 280.957L397.087 276.958L390.316 280.957V289.218L397.087 293.444L403.893 289.218V280.957Z"
          fill="white"
        />
        <path
          d="M652.144 280.957L645.338 276.958L638.568 280.957V289.218L645.338 293.444L652.144 289.218V280.957Z"
          fill="white"
        />
        <path
          d="M667.662 280.957L660.856 276.958L654.085 280.957V289.218L660.856 293.444L667.662 289.218V280.957Z"
          fill="white"
        />
        <path
          d="M683.177 280.957L676.371 276.958L669.601 280.957V289.218L676.371 293.444L683.177 289.218V280.957Z"
          fill="white"
        />
        <path
          d="M791.788 280.957L784.982 276.958L778.212 280.957V289.218L784.982 293.444L791.788 289.218V280.957Z"
          fill="white"
        />
        <path
          d="M822.818 280.957L816.012 276.958L809.242 280.957V289.218L816.012 293.444L822.818 289.218V280.957Z"
          fill="white"
        />
        <path
          d="M838.336 280.957L831.53 276.958L824.759 280.957V289.218L831.53 293.444L838.336 289.218V280.957Z"
          fill="#D45AFF"
        />
        <path
          d="M853.851 280.957L847.045 276.958L840.274 280.957V289.218L847.045 293.444L853.851 289.218V280.957Z"
          fill="white"
        />
        <path
          d="M869.366 280.957L862.56 276.958L855.79 280.957V289.218L862.56 293.444L869.366 289.218V280.957Z"
          fill="white"
        />
        <path
          d="M147.882 294.534L141.076 290.535L134.306 294.534V302.796L141.076 307.021L147.882 302.796V294.534Z"
          fill="white"
        />
        <path
          d="M163.397 294.534L156.591 290.535L149.821 294.534V302.796L156.591 307.021L163.397 302.796V294.534Z"
          fill="white"
        />
        <path
          d="M178.913 294.534L172.107 290.535L165.337 294.534V302.796L172.107 307.021L178.913 302.796V294.534Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M194.429 294.534L187.623 290.535L180.853 294.534V302.796L187.623 307.021L194.429 302.796V294.534Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M209.945 294.534L203.139 290.535L196.368 294.534V302.796L203.139 307.021L209.945 302.796V294.534Z"
          fill="#8676FF"
        />
        <path
          d="M225.461 294.534L218.655 290.535L211.885 294.534V302.796L218.655 307.021L225.461 302.796V294.534Z"
          fill="#8676FF"
        />
        <path
          d="M240.976 294.534L234.17 290.535L227.4 294.534V302.796L234.17 307.021L240.976 302.796V294.534Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M256.492 294.534L249.686 290.535L242.916 294.534V302.796L249.686 307.021L256.492 302.796V294.534Z"
          fill="#8676FF"
        />
        <path
          d="M272.008 294.534L265.202 290.535L258.432 294.534V302.796L265.202 307.021L272.008 302.796V294.534Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M287.523 294.534L280.717 290.535L273.947 294.534V302.796L280.717 307.021L287.523 302.796V294.534Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M303.04 294.534L296.234 290.535L289.463 294.534V302.796L296.234 307.021L303.04 302.796V294.534Z"
          fill="#8676FF"
        />
        <path
          d="M318.556 294.534L311.75 290.535L304.979 294.534V302.796L311.75 307.021L318.556 302.796V294.534Z"
          fill="#8676FF"
        />
        <path
          d="M334.071 294.534L327.265 290.535L320.495 294.534V302.796L327.265 307.021L334.071 302.796V294.534Z"
          fill="#8676FF"
        />
        <path
          d="M349.587 294.534L342.781 290.535L336.011 294.534V302.796L342.781 307.021L349.587 302.796V294.534Z"
          fill="#8676FF"
        />
        <path
          d="M659.904 294.534L653.098 290.535L646.327 294.534V302.796L653.098 307.021L659.904 302.796V294.534Z"
          fill="white"
        />
        <path
          d="M675.419 294.534L668.613 290.535L661.843 294.534V302.796L668.613 307.021L675.419 302.796V294.534Z"
          fill="white"
        />
        <path
          d="M815.061 294.534L808.255 290.535L801.485 294.534V302.796L808.255 307.021L815.061 302.796V294.534Z"
          fill="white"
        />
        <path
          d="M830.577 294.534L823.77 290.535L817 294.534V302.796L823.77 307.021L830.577 302.796V294.534Z"
          fill="white"
        />
        <path
          d="M846.093 294.534L839.287 290.535L832.516 294.534V302.796L839.287 307.021L846.093 302.796V294.534Z"
          fill="white"
        />
        <path
          d="M861.609 294.534L854.803 290.535L848.032 294.534V302.796L854.803 307.021L861.609 302.796V294.534Z"
          fill="white"
        />
        <path
          d="M140.124 308.11L133.318 304.111L126.547 308.11V316.372L133.318 320.597L140.124 316.372V308.11Z"
          fill="white"
        />
        <path
          d="M155.64 308.11L148.834 304.111L142.064 308.11V316.372L148.834 320.597L155.64 316.372V308.11Z"
          fill="white"
        />
        <path
          d="M171.155 308.11L164.349 304.111L157.579 308.11V316.372L164.349 320.597L171.155 316.372V308.11Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M186.671 308.11L179.865 304.111L173.095 308.11V316.372L179.865 320.597L186.671 316.372V308.11Z"
          fill="#8676FF"
        />
        <path
          d="M202.188 308.11L195.381 304.111L188.611 308.11V316.372L195.381 320.597L202.188 316.372V308.11Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M217.703 308.11L210.897 304.111L204.126 308.11V316.372L210.897 320.597L217.703 316.372V308.11Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M233.218 308.11L226.412 304.111L219.642 308.11V316.372L226.412 320.597L233.218 316.372V308.11Z"
          fill="#8676FF"
        />
        <path
          d="M248.735 308.11L241.929 304.111L235.159 308.11V316.372L241.929 320.597L248.735 316.372V308.11Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M264.25 308.11L257.444 304.111L250.674 308.11V316.372L257.444 320.597L264.25 316.372V308.11Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M279.765 308.11L272.959 304.111L266.189 308.11V316.372L272.959 320.597L279.765 316.372V308.11Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M295.282 308.11L288.475 304.111L281.705 308.11V316.372L288.475 320.597L295.282 316.372V308.11Z"
          fill="#8676FF"
        />
        <path
          d="M310.799 308.11L303.993 304.111L297.222 308.11V316.372L303.993 320.597L310.799 316.372V308.11Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M326.313 308.11L319.507 304.111L312.737 308.11V316.372L319.507 320.597L326.313 316.372V308.11Z"
          fill="#8676FF"
        />
        <path
          d="M667.662 308.11L660.856 304.111L654.085 308.11V316.372L660.856 320.597L667.662 316.372V308.11Z"
          fill="#8676FF"
        />
        <path
          d="M683.177 308.11L676.371 304.111L669.601 308.11V316.372L676.371 320.597L683.177 316.372V308.11Z"
          fill="white"
        />
        <path
          d="M698.693 308.11L691.887 304.111L685.117 308.11V316.372L691.887 320.597L698.693 316.372V308.11Z"
          fill="white"
        />
        <path
          d="M714.209 308.11L707.403 304.111L700.633 308.11V316.372L707.403 320.597L714.209 316.372V308.11Z"
          fill="white"
        />
        <path
          d="M729.724 308.11L722.918 304.111L716.148 308.11V316.372L722.918 320.597L729.724 316.372V308.11Z"
          fill="white"
        />
        <path
          d="M853.851 308.11L847.045 304.111L840.274 308.11V316.372L847.045 320.597L853.851 316.372V308.11Z"
          fill="white"
        />
        <path
          d="M869.366 308.11L862.56 304.111L855.79 308.11V316.372L862.56 320.597L869.366 316.372V308.11Z"
          fill="white"
        />
        <path
          d="M147.882 321.687L141.076 317.688L134.306 321.687V329.949L141.076 334.174L147.882 329.949V321.687Z"
          fill="white"
        />
        <path
          d="M163.397 321.687L156.591 317.688L149.821 321.687V329.949L156.591 334.174L163.397 329.949V321.687Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M178.913 321.687L172.107 317.688L165.337 321.687V329.949L172.107 334.174L178.913 329.949V321.687Z"
          fill="#8676FF"
        />
        <path
          d="M194.429 321.687L187.623 317.688L180.853 321.687V329.949L187.623 334.174L194.429 329.949V321.687Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M209.945 321.687L203.139 317.688L196.368 321.687V329.949L203.139 334.174L209.945 329.949V321.687Z"
          fill="#8676FF"
        />
        <path
          d="M225.461 321.687L218.655 317.688L211.885 321.687V329.949L218.655 334.174L225.461 329.949V321.687Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M240.976 321.687L234.17 317.688L227.4 321.687V329.949L234.17 334.174L240.976 329.949V321.687Z"
          fill="#8676FF"
        />
        <path
          d="M256.492 321.687L249.686 317.688L242.916 321.687V329.949L249.686 334.174L256.492 329.949V321.687Z"
          fill="#8676FF"
        />
        <path
          d="M272.008 321.687L265.202 317.688L258.432 321.687V329.949L265.202 334.174L272.008 329.949V321.687Z"
          fill="#8676FF"
        />
        <path
          d="M287.523 321.687L280.717 317.688L273.947 321.687V329.949L280.717 334.174L287.523 329.949V321.687Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M303.04 321.687L296.234 317.688L289.463 321.687V329.949L296.234 334.174L303.04 329.949V321.687Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M318.556 321.687L311.75 317.688L304.979 321.687V329.949L311.75 334.174L318.556 329.949V321.687Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M334.071 321.687L327.265 317.688L320.495 321.687V329.949L327.265 334.174L334.071 329.949V321.687Z"
          fill="#8676FF"
        />
        <path
          d="M659.904 321.687L653.098 317.688L646.327 321.687V329.949L653.098 334.174L659.904 329.949V321.687Z"
          fill="white"
        />
        <path
          d="M675.419 321.687L668.613 317.688L661.843 321.687V329.949L668.613 334.174L675.419 329.949V321.687Z"
          fill="white"
        />
        <path
          d="M690.934 321.687L684.128 317.688L677.358 321.687V329.949L684.128 334.174L690.934 329.949V321.687Z"
          fill="white"
        />
        <path
          d="M706.45 321.687L699.644 317.688L692.874 321.687V329.949L699.644 334.174L706.45 329.949V321.687Z"
          fill="#8676FF"
        />
        <path
          d="M721.966 321.687L715.16 317.688L708.39 321.687V329.949L715.16 334.174L721.966 329.949V321.687Z"
          fill="white"
        />
        <path
          d="M737.482 321.687L730.676 317.688L723.906 321.687V329.949L730.676 334.174L737.482 329.949V321.687Z"
          fill="white"
        />
        <path
          d="M861.609 321.687L854.803 317.688L848.032 321.687V329.949L854.803 334.174L861.609 329.949V321.687Z"
          fill="white"
        />
        <path
          d="M155.64 335.262L148.834 331.264L142.064 335.262V343.524L148.834 347.749L155.64 343.524V335.262Z"
          fill="white"
        />
        <path
          d="M171.155 335.262L164.349 331.264L157.579 335.262V343.524L164.349 347.749L171.155 343.524V335.262Z"
          fill="white"
        />
        <path
          d="M186.671 335.262L179.865 331.264L173.095 335.262V343.524L179.865 347.749L186.671 343.524V335.262Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M202.188 335.262L195.381 331.264L188.611 335.262V343.524L195.381 347.749L202.188 343.524V335.262Z"
          fill="#8676FF"
        />
        <path
          d="M217.703 335.262L210.897 331.264L204.126 335.262V343.524L210.897 347.749L217.703 343.524V335.262Z"
          fill="white"
        />
        <path
          d="M233.218 335.262L226.412 331.264L219.642 335.262V343.524L226.412 347.749L233.218 343.524V335.262Z"
          fill="white"
        />
        <path
          d="M248.735 335.262L241.929 331.264L235.159 335.262V343.524L241.929 347.749L248.735 343.524V335.262Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M264.25 335.262L257.444 331.264L250.674 335.262V343.524L257.444 347.749L264.25 343.524V335.262Z"
          fill="#8676FF"
        />
        <path
          d="M279.765 335.262L272.959 331.264L266.189 335.262V343.524L272.959 347.749L279.765 343.524V335.262Z"
          fill="white"
        />
        <path
          d="M295.282 335.262L288.475 331.264L281.705 335.262V343.524L288.475 347.749L295.282 343.524V335.262Z"
          fill="#8676FF"
        />
        <path
          d="M310.799 335.262L303.993 331.264L297.222 335.262V343.524L303.993 347.749L310.799 343.524V335.262Z"
          fill="#8676FF"
        />
        <path
          d="M652.144 335.262L645.338 331.264L638.568 335.262V343.524L645.338 347.749L652.144 343.524V335.262Z"
          fill="white"
        />
        <path
          d="M667.662 335.262L660.856 331.264L654.085 335.262V343.524L660.856 347.749L667.662 343.524V335.262Z"
          fill="white"
        />
        <path
          d="M683.177 335.262L676.371 331.264L669.601 335.262V343.524L676.371 347.749L683.177 343.524V335.262Z"
          fill="#8676FF"
        />
        <path
          d="M698.693 335.262L691.887 331.264L685.117 335.262V343.524L691.887 347.749L698.693 343.524V335.262Z"
          fill="white"
        />
        <path
          d="M714.209 335.262L707.403 331.264L700.633 335.262V343.524L707.403 347.749L714.209 343.524V335.262Z"
          fill="white"
        />
        <path
          d="M729.724 335.262L722.918 331.264L716.148 335.262V343.524L722.918 347.749L729.724 343.524V335.262Z"
          fill="white"
        />
        <path
          d="M745.24 335.262L738.433 331.264L731.663 335.262V343.524L738.433 347.749L745.24 343.524V335.262Z"
          fill="white"
        />
        <path
          d="M760.756 335.262L753.95 331.264L747.179 335.262V343.524L753.95 347.749L760.756 343.524V335.262Z"
          fill="white"
        />
        <path
          d="M776.272 335.262L769.466 331.264L762.696 335.262V343.524L769.466 347.749L776.272 343.524V335.262Z"
          fill="white"
        />
        <path
          d="M791.788 335.262L784.982 331.264L778.212 335.262V343.524L784.982 347.749L791.788 343.524V335.262Z"
          fill="white"
        />
        <path
          d="M807.303 335.262L800.497 331.264L793.727 335.262V343.524L800.497 347.749L807.303 343.524V335.262Z"
          fill="white"
        />
        <path
          d="M822.818 335.262L816.012 331.264L809.242 335.262V343.524L816.012 347.749L822.818 343.524V335.262Z"
          fill="white"
        />
        <path
          d="M838.336 335.262L831.53 331.264L824.759 335.262V343.524L831.53 347.749L838.336 343.524V335.262Z"
          fill="white"
        />
        <path
          d="M853.851 335.262L847.045 331.264L840.274 335.262V343.524L847.045 347.749L853.851 343.524V335.262Z"
          fill="white"
        />
        <path
          d="M869.366 335.262L862.56 331.264L855.79 335.262V343.524L862.56 347.749L869.366 343.524V335.262Z"
          fill="white"
        />
        <path
          d="M147.882 348.839L141.076 344.84L134.306 348.839V357.1L141.076 361.325L147.882 357.1V348.839Z"
          fill="white"
        />
        <path
          d="M163.397 348.839L156.591 344.84L149.821 348.839V357.1L156.591 361.325L163.397 357.1V348.839Z"
          fill="white"
        />
        <path
          d="M178.913 348.839L172.107 344.84L165.337 348.839V357.1L172.107 361.325L178.913 357.1V348.839Z"
          fill="white"
        />
        <path
          d="M194.429 348.839L187.623 344.84L180.853 348.839V357.1L187.623 361.325L194.429 357.1V348.839Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M209.945 348.839L203.139 344.84L196.368 348.839V357.1L203.139 361.325L209.945 357.1V348.839Z"
          fill="#8676FF"
        />
        <path
          d="M225.461 348.839L218.655 344.84L211.885 348.839V357.1L218.655 361.325L225.461 357.1V348.839Z"
          fill="white"
        />
        <path
          d="M628.871 348.839L622.065 344.84L615.295 348.839V357.1L622.065 361.325L628.871 357.1V348.839Z"
          fill="white"
        />
        <path
          d="M644.386 348.839L637.58 344.84L630.81 348.839V357.1L637.58 361.325L644.386 357.1V348.839Z"
          fill="white"
        />
        <path
          d="M659.904 348.839L653.098 344.84L646.327 348.839V357.1L653.098 361.325L659.904 357.1V348.839Z"
          fill="white"
        />
        <path
          d="M675.419 348.839L668.613 344.84L661.843 348.839V357.1L668.613 361.325L675.419 357.1V348.839Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M690.934 348.839L684.128 344.84L677.358 348.839V357.1L684.128 361.325L690.934 357.1V348.839Z"
          fill="#8676FF"
        />
        <path
          d="M706.45 348.839L699.644 344.84L692.874 348.839V357.1L699.644 361.325L706.45 357.1V348.839Z"
          fill="white"
        />
        <path
          d="M721.966 348.839L715.16 344.84L708.39 348.839V357.1L715.16 361.325L721.966 357.1V348.839Z"
          fill="white"
        />
        <path
          d="M737.482 348.839L730.676 344.84L723.906 348.839V357.1L730.676 361.325L737.482 357.1V348.839Z"
          fill="white"
        />
        <path
          d="M752.998 348.839L746.192 344.84L739.421 348.839V357.1L746.192 361.325L752.998 357.1V348.839Z"
          fill="white"
        />
        <path
          d="M768.514 348.839L761.708 344.84L754.938 348.839V357.1L761.708 361.325L768.514 357.1V348.839Z"
          fill="white"
        />
        <path
          d="M784.03 348.839L777.224 344.84L770.454 348.839V357.1L777.224 361.325L784.03 357.1V348.839Z"
          fill="white"
        />
        <path
          d="M799.545 348.839L792.739 344.84L785.969 348.839V357.1L792.739 361.325L799.545 357.1V348.839Z"
          fill="white"
        />
        <path
          d="M815.061 348.839L808.255 344.84L801.485 348.839V357.1L808.255 361.325L815.061 357.1V348.839Z"
          fill="white"
        />
        <path
          d="M830.577 348.839L823.77 344.84L817 348.839V357.1L823.77 361.325L830.577 357.1V348.839Z"
          fill="white"
        />
        <path
          d="M846.093 348.839L839.287 344.84L832.516 348.839V357.1L839.287 361.325L846.093 357.1V348.839Z"
          fill="white"
        />
        <path
          d="M861.609 348.839L854.803 344.84L848.032 348.839V357.1L854.803 361.325L861.609 357.1V348.839Z"
          fill="white"
        />
        <path
          d="M155.64 362.415L148.834 358.416L142.064 362.415V370.676L148.834 374.902L155.64 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M171.155 362.415L164.349 358.416L157.579 362.415V370.676L164.349 374.902L171.155 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M186.671 362.415L179.865 358.416L173.095 362.415V370.676L179.865 374.902L186.671 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M202.188 362.415L195.381 358.416L188.611 362.415V370.676L195.381 374.902L202.188 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M217.703 362.415L210.897 358.416L204.126 362.415V370.676L210.897 374.902L217.703 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M621.114 362.415L614.308 358.416L607.538 362.415V370.676L614.308 374.902L621.114 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M636.629 362.415L629.823 358.416L623.053 362.415V370.676L629.823 374.902L636.629 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M652.144 362.415L645.338 358.416L638.568 362.415V370.676L645.338 374.902L652.144 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M667.662 362.415L660.856 358.416L654.085 362.415V370.676L660.856 374.902L667.662 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M683.177 362.415L676.371 358.416L669.601 362.415V370.676L676.371 374.902L683.177 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M698.693 362.415L691.887 358.416L685.117 362.415V370.676L691.887 374.902L698.693 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M714.209 362.415L707.403 358.416L700.633 362.415V370.676L707.403 374.902L714.209 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M729.724 362.415L722.918 358.416L716.148 362.415V370.676L722.918 374.902L729.724 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M745.24 362.415L738.433 358.416L731.663 362.415V370.676L738.433 374.902L745.24 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M760.756 362.415L753.95 358.416L747.179 362.415V370.676L753.95 374.902L760.756 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M776.272 362.415L769.466 358.416L762.696 362.415V370.676L769.466 374.902L776.272 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M791.788 362.415L784.982 358.416L778.212 362.415V370.676L784.982 374.902L791.788 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M807.303 362.415L800.497 358.416L793.727 362.415V370.676L800.497 374.902L807.303 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M822.818 362.415L816.012 358.416L809.242 362.415V370.676L816.012 374.902L822.818 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M838.336 362.415L831.53 358.416L824.759 362.415V370.676L831.53 374.902L838.336 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M853.851 362.415L847.045 358.416L840.274 362.415V370.676L847.045 374.902L853.851 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M869.366 362.415L862.56 358.416L855.79 362.415V370.676L862.56 374.902L869.366 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M163.397 375.994L156.591 371.995L149.821 375.994V384.256L156.591 388.481L163.397 384.256V375.994Z"
          fill="white"
        />
        <path
          d="M178.913 375.994L172.107 371.995L165.337 375.994V384.256L172.107 388.481L178.913 384.256V375.994Z"
          fill="white"
        />
        <path
          d="M194.429 375.994L187.623 371.995L180.853 375.994V384.256L187.623 388.481L194.429 384.256V375.994Z"
          fill="white"
        />
        <path
          d="M209.945 375.994L203.139 371.995L196.368 375.994V384.256L203.139 388.481L209.945 384.256V375.994Z"
          fill="white"
        />
        <path
          d="M613.356 375.994L606.55 371.995L599.78 375.994V384.256L606.55 388.481L613.356 384.256V375.994Z"
          fill="white"
        />
        <path
          d="M628.871 375.994L622.065 371.995L615.295 375.994V384.256L622.065 388.481L628.871 384.256V375.994Z"
          fill="#8676FF"
        />
        <path
          d="M644.386 375.994L637.58 371.995L630.81 375.994V384.256L637.58 388.481L644.386 384.256V375.994Z"
          fill="white"
        />
        <path
          d="M659.904 375.994L653.098 371.995L646.327 375.994V384.256L653.098 388.481L659.904 384.256V375.994Z"
          fill="white"
        />
        <path
          d="M675.419 375.994L668.613 371.995L661.843 375.994V384.256L668.613 388.481L675.419 384.256V375.994Z"
          fill="white"
        />
        <path
          d="M690.934 375.994L684.128 371.995L677.358 375.994V384.256L684.128 388.481L690.934 384.256V375.994Z"
          fill="white"
        />
        <path
          d="M706.45 375.994L699.644 371.995L692.874 375.994V384.256L699.644 388.481L706.45 384.256V375.994Z"
          fill="white"
        />
        <path
          d="M721.966 375.994L715.16 371.995L708.39 375.994V384.256L715.16 388.481L721.966 384.256V375.994Z"
          fill="white"
        />
        <path
          d="M737.482 375.994L730.676 371.995L723.906 375.994V384.256L730.676 388.481L737.482 384.256V375.994Z"
          fill="white"
        />
        <path
          d="M752.998 375.994L746.192 371.995L739.421 375.994V384.256L746.192 388.481L752.998 384.256V375.994Z"
          fill="white"
        />
        <path
          d="M768.514 375.994L761.708 371.995L754.938 375.994V384.256L761.708 388.481L768.514 384.256V375.994Z"
          fill="white"
        />
        <path
          d="M784.03 375.994L777.224 371.995L770.454 375.994V384.256L777.224 388.481L784.03 384.256V375.994Z"
          fill="white"
        />
        <path
          d="M799.545 375.994L792.739 371.995L785.969 375.994V384.256L792.739 388.481L799.545 384.256V375.994Z"
          fill="white"
        />
        <path
          d="M815.061 375.994L808.255 371.995L801.485 375.994V384.256L808.255 388.481L815.061 384.256V375.994Z"
          fill="white"
        />
        <path
          d="M830.577 375.994L823.77 371.995L817 375.994V384.256L823.77 388.481L830.577 384.256V375.994Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M846.093 375.994L839.287 371.995L832.516 375.994V384.256L839.287 388.481L846.093 384.256V375.994Z"
          fill="#8676FF"
        />
        <path
          d="M861.609 375.994L854.803 371.995L848.032 375.994V384.256L854.803 388.481L861.609 384.256V375.994Z"
          fill="white"
        />
        <path
          d="M186.671 389.568L179.865 385.569L173.095 389.568V397.83L179.865 402.055L186.671 397.83V389.568Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M202.188 389.568L195.381 385.569L188.611 389.568V397.83L195.381 402.055L202.188 397.83V389.568Z"
          fill="#8676FF"
        />
        <path
          d="M217.703 389.568L210.897 385.569L204.126 389.568V397.83L210.897 402.055L217.703 397.83V389.568Z"
          fill="white"
        />
        <path
          d="M248.735 389.568L241.929 385.569L235.159 389.568V397.83L241.929 402.055L248.735 397.83V389.568Z"
          fill="white"
        />
        <path
          d="M264.25 389.568L257.444 385.569L250.674 389.568V397.83L257.444 402.055L264.25 397.83V389.568Z"
          fill="white"
        />
        <path
          d="M295.282 389.568L288.475 385.569L281.705 389.568V397.83L288.475 402.055L295.282 397.83V389.568Z"
          fill="white"
        />
        <path
          d="M310.799 389.568L303.993 385.569L297.222 389.568V397.83L303.993 402.055L310.799 397.83V389.568Z"
          fill="white"
        />
        <path
          d="M621.114 389.568L614.308 385.569L607.538 389.568V397.83L614.308 402.055L621.114 397.83V389.568Z"
          fill="white"
        />
        <path
          d="M636.629 389.568L629.823 385.569L623.053 389.568V397.83L629.823 402.055L636.629 397.83V389.568Z"
          fill="white"
        />
        <path
          d="M652.144 389.568L645.338 385.569L638.568 389.568V397.83L645.338 402.055L652.144 397.83V389.568Z"
          fill="white"
        />
        <path
          d="M667.662 389.568L660.856 385.569L654.085 389.568V397.83L660.856 402.055L667.662 397.83V389.568Z"
          fill="white"
        />
        <path
          d="M683.177 389.568L676.371 385.569L669.601 389.568V397.83L676.371 402.055L683.177 397.83V389.568Z"
          fill="white"
        />
        <path
          d="M698.693 389.568L691.887 385.569L685.117 389.568V397.83L691.887 402.055L698.693 397.83V389.568Z"
          fill="white"
        />
        <path
          d="M714.209 389.568L707.403 385.569L700.633 389.568V397.83L707.403 402.055L714.209 397.83V389.568Z"
          fill="white"
        />
        <path
          d="M729.724 389.568L722.918 385.569L716.148 389.568V397.83L722.918 402.055L729.724 397.83V389.568Z"
          fill="white"
        />
        <path
          d="M745.24 389.568L738.433 385.569L731.663 389.568V397.83L738.433 402.055L745.24 397.83V389.568Z"
          fill="white"
        />
        <path
          d="M760.756 389.568L753.95 385.569L747.179 389.568V397.83L753.95 402.055L760.756 397.83V389.568Z"
          fill="white"
        />
        <path
          d="M776.272 389.568L769.466 385.569L762.696 389.568V397.83L769.466 402.055L776.272 397.83V389.568Z"
          fill="white"
        />
        <path
          d="M791.788 389.568L784.982 385.569L778.212 389.568V397.83L784.982 402.055L791.788 397.83V389.568Z"
          fill="white"
        />
        <path
          d="M807.303 389.568L800.497 385.569L793.727 389.568V397.83L800.497 402.055L807.303 397.83V389.568Z"
          fill="white"
        />
        <path
          d="M822.818 389.568L816.012 385.569L809.242 389.568V397.83L816.012 402.055L822.818 397.83V389.568Z"
          fill="white"
        />
        <path
          d="M838.336 389.568L831.53 385.569L824.759 389.568V397.83L831.53 402.055L838.336 397.83V389.568Z"
          fill="white"
        />
        <path
          d="M853.851 389.568L847.045 385.569L840.274 389.568V397.83L847.045 402.055L853.851 397.83V389.568Z"
          fill="white"
        />
        <path
          d="M869.366 389.568L862.56 385.569L855.79 389.568V397.83L862.56 402.055L869.366 397.83V389.568Z"
          fill="white"
        />
        <path
          d="M194.429 403.144L187.623 399.146L180.853 403.144V411.406L187.623 415.631L194.429 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M209.945 403.144L203.139 399.146L196.368 403.144V411.406L203.139 415.631L209.945 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M225.461 403.144L218.655 399.146L211.885 403.144V411.406L218.655 415.631L225.461 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M240.976 403.144L234.17 399.146L227.4 403.144V411.406L234.17 415.631L240.976 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M256.492 403.144L249.686 399.146L242.916 403.144V411.406L249.686 415.631L256.492 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M272.008 403.144L265.202 399.146L258.432 403.144V411.406L265.202 415.631L272.008 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M303.04 403.144L296.234 399.146L289.463 403.144V411.406L296.234 415.631L303.04 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M318.556 403.144L311.75 399.146L304.979 403.144V411.406L311.75 415.631L318.556 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M613.356 403.144L606.55 399.146L599.78 403.144V411.406L606.55 415.631L613.356 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M628.871 403.144L622.065 399.146L615.295 403.144V411.406L622.065 415.631L628.871 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M644.386 403.144L637.58 399.146L630.81 403.144V411.406L637.58 415.631L644.386 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M659.904 403.144L653.098 399.146L646.327 403.144V411.406L653.098 415.631L659.904 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M675.419 403.144L668.613 399.146L661.843 403.144V411.406L668.613 415.631L675.419 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M690.934 403.144L684.128 399.146L677.358 403.144V411.406L684.128 415.631L690.934 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M706.45 403.144L699.644 399.146L692.874 403.144V411.406L699.644 415.631L706.45 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M721.966 403.144L715.16 399.146L708.39 403.144V411.406L715.16 415.631L721.966 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M737.482 403.144L730.676 399.146L723.906 403.144V411.406L730.676 415.631L737.482 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M752.998 403.144L746.192 399.146L739.421 403.144V411.406L746.192 415.631L752.998 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M768.514 403.144L761.708 399.146L754.938 403.144V411.406L761.708 415.631L768.514 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M784.03 403.144L777.224 399.146L770.454 403.144V411.406L777.224 415.631L784.03 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M799.545 403.144L792.739 399.146L785.969 403.144V411.406L792.739 415.631L799.545 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M815.061 403.144L808.255 399.146L801.485 403.144V411.406L808.255 415.631L815.061 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M830.577 403.144L823.77 399.146L817 403.144V411.406L823.77 415.631L830.577 411.406V403.144Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M846.093 403.144L839.287 399.146L832.516 403.144V411.406L839.287 415.631L846.093 411.406V403.144Z"
          fill="#8676FF"
        />
        <path
          d="M861.609 403.144L854.803 399.146L848.032 403.144V411.406L854.803 415.631L861.609 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M233.218 416.721L226.412 412.723L219.642 416.721V424.983L226.412 429.208L233.218 424.983V416.721Z"
          fill="white"
        />
        <path
          d="M248.735 416.721L241.929 412.723L235.159 416.721V424.983L241.929 429.208L248.735 424.983V416.721Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M264.25 416.721L257.444 412.723L250.674 416.721V424.983L257.444 429.208L264.25 424.983V416.721Z"
          fill="#8676FF"
        />
        <path
          d="M279.765 416.721L272.959 412.723L266.189 416.721V424.983L272.959 429.208L279.765 424.983V416.721Z"
          fill="white"
        />
        <path
          d="M621.114 416.721L614.308 412.723L607.538 416.721V424.983L614.308 429.208L621.114 424.983V416.721Z"
          fill="white"
        />
        <path
          d="M636.629 416.721L629.823 412.723L623.053 416.721V424.983L629.823 429.208L636.629 424.983V416.721Z"
          fill="white"
        />
        <path
          d="M652.144 416.721L645.338 412.723L638.568 416.721V424.983L645.338 429.208L652.144 424.983V416.721Z"
          fill="white"
        />
        <path
          d="M667.662 416.721L660.856 412.723L654.085 416.721V424.983L660.856 429.208L667.662 424.983V416.721Z"
          fill="white"
        />
        <path
          d="M683.177 416.721L676.371 412.723L669.601 416.721V424.983L676.371 429.208L683.177 424.983V416.721Z"
          fill="white"
        />
        <path
          d="M698.693 416.721L691.887 412.723L685.117 416.721V424.983L691.887 429.208L698.693 424.983V416.721Z"
          fill="white"
        />
        <path
          d="M714.209 416.721L707.403 412.723L700.633 416.721V424.983L707.403 429.208L714.209 424.983V416.721Z"
          fill="white"
        />
        <path
          d="M729.724 416.721L722.918 412.723L716.148 416.721V424.983L722.918 429.208L729.724 424.983V416.721Z"
          fill="white"
        />
        <path
          d="M745.24 416.721L738.433 412.723L731.663 416.721V424.983L738.433 429.208L745.24 424.983V416.721Z"
          fill="white"
        />
        <path
          d="M760.756 416.721L753.95 412.723L747.179 416.721V424.983L753.95 429.208L760.756 424.983V416.721Z"
          fill="white"
        />
        <path
          d="M776.272 416.721L769.466 412.723L762.696 416.721V424.983L769.466 429.208L776.272 424.983V416.721Z"
          fill="white"
        />
        <path
          d="M791.788 416.721L784.982 412.723L778.212 416.721V424.983L784.982 429.208L791.788 424.983V416.721Z"
          fill="white"
        />
        <path
          d="M807.303 416.721L800.497 412.723L793.727 416.721V424.983L800.497 429.208L807.303 424.983V416.721Z"
          fill="white"
        />
        <path
          d="M822.818 416.721L816.012 412.723L809.242 416.721V424.983L816.012 429.208L822.818 424.983V416.721Z"
          fill="white"
        />
        <path
          d="M838.336 416.721L831.53 412.723L824.759 416.721V424.983L831.53 429.208L838.336 424.983V416.721Z"
          fill="white"
        />
        <path
          d="M853.851 416.721L847.045 412.723L840.274 416.721V424.983L847.045 429.208L853.851 424.983V416.721Z"
          fill="white"
        />
        <path
          d="M869.366 416.721L862.56 412.723L855.79 416.721V424.983L862.56 429.208L869.366 424.983V416.721Z"
          fill="white"
        />
        <path
          d="M272.008 430.298L265.202 426.299L258.432 430.298V438.559L265.202 442.784L272.008 438.559V430.298Z"
          fill="white"
        />
        <path
          d="M613.356 430.298L606.55 426.299L599.78 430.298V438.559L606.55 442.784L613.356 438.559V430.298Z"
          fill="white"
        />
        <path
          d="M628.871 430.298L622.065 426.299L615.295 430.298V438.559L622.065 442.784L628.871 438.559V430.298Z"
          fill="white"
        />
        <path
          d="M644.386 430.298L637.58 426.299L630.81 430.298V438.559L637.58 442.784L644.386 438.559V430.298Z"
          fill="white"
        />
        <path
          d="M659.904 430.298L653.098 426.299L646.327 430.298V438.559L653.098 442.784L659.904 438.559V430.298Z"
          fill="white"
        />
        <path
          d="M675.419 430.298L668.613 426.299L661.843 430.298V438.559L668.613 442.784L675.419 438.559V430.298Z"
          fill="white"
        />
        <path
          d="M690.934 430.298L684.128 426.299L677.358 430.298V438.559L684.128 442.784L690.934 438.559V430.298Z"
          fill="white"
        />
        <path
          d="M706.45 430.298L699.644 426.299L692.874 430.298V438.559L699.644 442.784L706.45 438.559V430.298Z"
          fill="white"
        />
        <path
          d="M721.966 430.298L715.16 426.299L708.39 430.298V438.559L715.16 442.784L721.966 438.559V430.298Z"
          fill="white"
        />
        <path
          d="M737.482 430.298L730.676 426.299L723.906 430.298V438.559L730.676 442.784L737.482 438.559V430.298Z"
          fill="white"
        />
        <path
          d="M752.998 430.298L746.192 426.299L739.421 430.298V438.559L746.192 442.784L752.998 438.559V430.298Z"
          fill="white"
        />
        <path
          d="M768.514 430.298L761.708 426.299L754.938 430.298V438.559L761.708 442.784L768.514 438.559V430.298Z"
          fill="white"
        />
        <path
          d="M784.03 430.298L777.224 426.299L770.454 430.298V438.559L777.224 442.784L784.03 438.559V430.298Z"
          fill="white"
        />
        <path
          d="M799.545 430.298L792.739 426.299L785.969 430.298V438.559L792.739 442.784L799.545 438.559V430.298Z"
          fill="white"
        />
        <path
          d="M815.061 430.298L808.255 426.299L801.485 430.298V438.559L808.255 442.784L815.061 438.559V430.298Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M830.577 430.298L823.77 426.299L817 430.298V438.559L823.77 442.784L830.577 438.559V430.298Z"
          fill="#8676FF"
        />
        <path
          d="M846.093 430.298L839.287 426.299L832.516 430.298V438.559L839.287 442.784L846.093 438.559V430.298Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M861.609 430.298L854.803 426.299L848.032 430.298V438.559L854.803 442.784L861.609 438.559V430.298Z"
          fill="#8676FF"
        />
        <path
          d="M279.765 443.873L272.959 439.874L266.189 443.873V452.134L272.959 456.36L279.765 452.134V443.873Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M310.799 443.873L303.993 439.874L297.222 443.873V452.134L303.993 456.36L310.799 452.134V443.873Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M326.313 443.873L319.507 439.874L312.737 443.873V452.134L319.507 456.36L326.313 452.134V443.873Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M341.829 443.873L335.023 439.874L328.253 443.873V452.134L335.023 456.36L341.829 452.134V443.873Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M357.345 443.873L350.539 439.874L343.769 443.873V452.134L350.539 456.36L357.345 452.134V443.873Z"
          fill="#8676FF"
        />
        <path
          d="M372.861 443.873L366.055 439.874L359.285 443.873V452.134L366.055 456.36L372.861 452.134V443.873Z"
          fill="#8676FF"
        />
        <path
          d="M621.114 443.873L614.308 439.874L607.538 443.873V452.134L614.308 456.36L621.114 452.134V443.873Z"
          fill="white"
        />
        <path
          d="M636.629 443.873L629.823 439.874L623.053 443.873V452.134L629.823 456.36L636.629 452.134V443.873Z"
          fill="white"
        />
        <path
          d="M652.144 443.873L645.338 439.874L638.568 443.873V452.134L645.338 456.36L652.144 452.134V443.873Z"
          fill="white"
        />
        <path
          d="M667.662 443.873L660.856 439.874L654.085 443.873V452.134L660.856 456.36L667.662 452.134V443.873Z"
          fill="white"
        />
        <path
          d="M683.177 443.873L676.371 439.874L669.601 443.873V452.134L676.371 456.36L683.177 452.134V443.873Z"
          fill="white"
        />
        <path
          d="M698.693 443.873L691.887 439.874L685.117 443.873V452.134L691.887 456.36L698.693 452.134V443.873Z"
          fill="white"
        />
        <path
          d="M714.209 443.873L707.403 439.874L700.633 443.873V452.134L707.403 456.36L714.209 452.134V443.873Z"
          fill="white"
        />
        <path
          d="M729.724 443.873L722.918 439.874L716.148 443.873V452.134L722.918 456.36L729.724 452.134V443.873Z"
          fill="white"
        />
        <path
          d="M745.24 443.873L738.433 439.874L731.663 443.873V452.134L738.433 456.36L745.24 452.134V443.873Z"
          fill="white"
        />
        <path
          d="M760.756 443.873L753.95 439.874L747.179 443.873V452.134L753.95 456.36L760.756 452.134V443.873Z"
          fill="white"
        />
        <path
          d="M776.272 443.873L769.466 439.874L762.696 443.873V452.134L769.466 456.36L776.272 452.134V443.873Z"
          fill="white"
        />
        <path
          d="M791.788 443.873L784.982 439.874L778.212 443.873V452.134L784.982 456.36L791.788 452.134V443.873Z"
          fill="white"
        />
        <path
          d="M807.303 443.873L800.497 439.874L793.727 443.873V452.134L800.497 456.36L807.303 452.134V443.873Z"
          fill="white"
        />
        <path
          d="M822.818 443.873L816.012 439.874L809.242 443.873V452.134L816.012 456.36L822.818 452.134V443.873Z"
          fill="white"
        />
        <path
          d="M838.336 443.873L831.53 439.874L824.759 443.873V452.134L831.53 456.36L838.336 452.134V443.873Z"
          fill="white"
        />
        <path
          d="M853.851 443.873L847.045 439.874L840.274 443.873V452.134L847.045 456.36L853.851 452.134V443.873Z"
          fill="white"
        />
        <path
          d="M869.366 443.873L862.56 439.874L855.79 443.873V452.134L862.56 456.36L869.366 452.134V443.873Z"
          fill="white"
        />
        <path
          d="M884.73 4.64315L877.423 0.349609L870.153 4.64315V13.5138L877.423 18.0503L884.73 13.5138V4.64315Z"
          fill="white"
        />
        <path
          d="M901.39 4.64315L894.082 0.349609L886.813 4.64315V13.5138L894.082 18.0503L901.39 13.5138V4.64315Z"
          fill="white"
        />
        <path
          d="M970.411 77.3123L963.604 73.3135L956.834 77.3123V85.5739L963.604 89.799L970.411 85.5739V77.3123Z"
          fill="white"
        />
        <path
          d="M985.927 77.3123L979.121 73.3135L972.35 77.3123V85.5739L979.121 89.799L985.927 85.5739V77.3123Z"
          fill="white"
        />
        <path
          d="M931.622 90.8884L924.816 86.8896L918.046 90.8884V99.1501L924.816 103.375L931.622 99.1501V90.8884Z"
          fill="white"
        />
        <path
          d="M947.137 90.8884L940.331 86.8896L933.561 90.8884V99.1501L940.331 103.375L947.137 99.1501V90.8884Z"
          fill="#8676FF"
        />
        <path
          d="M962.652 90.8884L955.846 86.8896L949.076 90.8884V99.1501L955.846 103.375L962.652 99.1501V90.8884Z"
          fill="white"
        />
        <path
          d="M978.169 90.8884L971.363 86.8896L964.592 90.8884V99.1501L971.363 103.375L978.169 99.1501V90.8884Z"
          fill="white"
        />
        <path
          d="M939.379 104.465L932.573 100.466L925.803 104.465V112.726L932.573 116.951L939.379 112.726V104.465Z"
          fill="white"
        />
        <path
          d="M954.895 104.465L948.089 100.466L941.319 104.465V112.726L948.089 116.951L954.895 112.726V104.465Z"
          fill="white"
        />
        <path
          d="M970.411 104.465L963.604 100.466L956.834 104.465V112.726L963.604 116.951L970.411 112.726V104.465Z"
          fill="white"
        />
        <path
          d="M985.927 104.465L979.121 100.466L972.35 104.465V112.726L979.121 116.951L985.927 112.726V104.465Z"
          fill="white"
        />
        <path
          d="M931.622 118.042L924.816 114.043L918.046 118.042V126.303L924.816 130.529L931.622 126.303V118.042Z"
          fill="white"
        />
        <path
          d="M947.137 118.042L940.331 114.043L933.561 118.042V126.303L940.331 130.529L947.137 126.303V118.042Z"
          fill="white"
        />
        <path
          d="M962.652 118.042L955.846 114.043L949.076 118.042V126.303L955.846 130.529L962.652 126.303V118.042Z"
          fill="white"
        />
        <path
          d="M978.169 118.042L971.363 114.043L964.592 118.042V126.303L971.363 130.529L978.169 126.303V118.042Z"
          fill="white"
        />
        <path
          d="M877.317 131.618L870.51 127.619L863.74 131.618V139.88L870.51 144.105L877.317 139.88V131.618Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M892.832 131.618L886.026 127.619L879.255 131.618V139.88L886.026 144.105L892.832 139.88V131.618Z"
          fill="#8676FF"
        />
        <path
          d="M908.347 131.618L901.541 127.619L894.771 131.618V139.88L901.541 144.105L908.347 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M923.863 131.618L917.057 127.619L910.287 131.618V139.88L917.057 144.105L923.863 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M939.379 131.618L932.573 127.619L925.803 131.618V139.88L932.573 144.105L939.379 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M954.895 131.618L948.089 127.619L941.319 131.618V139.88L948.089 144.105L954.895 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M970.411 131.618L963.604 127.619L956.834 131.618V139.88L963.604 144.105L970.411 139.88V131.618Z"
          fill="white"
        />
        <path
          d="M985.927 131.618L979.121 127.619L972.35 131.618V139.88L979.121 144.105L985.927 139.88V131.618Z"
          fill="#8676FF"
        />
        <path
          d="M885.074 145.194L878.268 141.195L871.497 145.194V153.456L878.268 157.681L885.074 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M900.59 145.194L893.784 141.195L887.013 145.194V153.456L893.784 157.681L900.59 153.456V145.194Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M916.105 145.194L909.299 141.195L902.529 145.194V153.456L909.299 157.681L916.105 153.456V145.194Z"
          fill="#8676FF"
        />
        <path
          d="M931.622 145.194L924.816 141.195L918.046 145.194V153.456L924.816 157.681L931.622 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M947.137 145.194L940.331 141.195L933.561 145.194V153.456L940.331 157.681L947.137 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M962.652 145.194L955.846 141.195L949.076 145.194V153.456L955.846 157.681L962.652 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M978.169 145.194L971.363 141.195L964.592 145.194V153.456L971.363 157.681L978.169 153.456V145.194Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M877.317 158.771L870.51 154.772L863.74 158.771V167.033L870.51 171.258L877.317 167.033V158.771Z"
          fill="#8676FF"
        />
        <path
          d="M892.832 158.771L886.026 154.772L879.255 158.771V167.033L886.026 171.258L892.832 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M908.347 158.771L901.541 154.772L894.771 158.771V167.033L901.541 171.258L908.347 167.033V158.771Z"
          fill="#8676FF"
        />
        <path
          d="M923.863 158.771L917.057 154.772L910.287 158.771V167.033L917.057 171.258L923.863 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M939.379 158.771L932.573 154.772L925.803 158.771V167.033L932.573 171.258L939.379 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M954.895 158.771L948.089 154.772L941.319 158.771V167.033L948.089 171.258L954.895 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M970.411 158.771L963.604 154.772L956.834 158.771V167.033L963.604 171.258L970.411 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M985.927 158.771L979.121 154.772L972.35 158.771V167.033L979.121 171.258L985.927 167.033V158.771Z"
          fill="white"
        />
        <path
          d="M885.074 172.346L878.268 168.348L871.497 172.346V180.608L878.268 184.833L885.074 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M900.59 172.346L893.784 168.348L887.013 172.346V180.608L893.784 184.833L900.59 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M916.105 172.346L909.299 168.348L902.529 172.346V180.608L909.299 184.833L916.105 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M931.622 172.346L924.816 168.348L918.046 172.346V180.608L924.816 184.833L931.622 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M947.137 172.346L940.331 168.348L933.561 172.346V180.608L940.331 184.833L947.137 180.608V172.346Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M962.652 172.346L955.846 168.348L949.076 172.346V180.608L955.846 184.833L962.652 180.608V172.346Z"
          fill="#8676FF"
        />
        <path
          d="M978.169 172.346L971.363 168.348L964.592 172.346V180.608L971.363 184.833L978.169 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M877.317 185.922L870.51 181.923L863.74 185.922V194.183L870.51 198.408L877.317 194.183V185.922Z"
          fill="#D45AFF"
        />
        <path
          d="M892.832 185.922L886.026 181.923L879.255 185.922V194.183L886.026 198.408L892.832 194.183V185.922Z"
          fill="white"
        />
        <path
          d="M908.347 185.922L901.541 181.923L894.771 185.922V194.183L901.541 198.408L908.347 194.183V185.922Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M923.863 185.922L917.057 181.923L910.287 185.922V194.183L917.057 198.408L923.863 194.183V185.922Z"
          fill="#8676FF"
        />
        <path
          d="M939.379 185.922L932.573 181.923L925.803 185.922V194.183L932.573 198.408L939.379 194.183V185.922Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M954.895 185.922L948.089 181.923L941.319 185.922V194.183L948.089 198.408L954.895 194.183V185.922Z"
          fill="#8676FF"
        />
        <path
          d="M970.411 185.922L963.604 181.923L956.834 185.922V194.183L963.604 198.408L970.411 194.183V185.922Z"
          fill="white"
        />
        <path
          d="M985.927 185.922L979.121 181.923L972.35 185.922V194.183L979.121 198.408L985.927 194.183V185.922Z"
          fill="#8676FF"
        />
        <path
          d="M885.074 199.501L878.268 195.502L871.497 199.501V207.762L878.268 211.987L885.074 207.762V199.501Z"
          fill="white"
        />
        <path
          d="M900.59 199.501L893.784 195.502L887.013 199.501V207.762L893.784 211.987L900.59 207.762V199.501Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M916.105 199.501L909.299 195.502L902.529 199.501V207.762L909.299 211.987L916.105 207.762V199.501Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M931.622 199.501L924.816 195.502L918.046 199.501V207.762L924.816 211.987L931.622 207.762V199.501Z"
          fill="#8676FF"
        />
        <path
          d="M947.137 199.501L940.331 195.502L933.561 199.501V207.762L940.331 211.987L947.137 207.762V199.501Z"
          fill="white"
        />
        <path
          d="M962.652 199.501L955.846 195.502L949.076 199.501V207.762L955.846 211.987L962.652 207.762V199.501Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M978.169 199.501L971.363 195.502L964.592 199.501V207.762L971.363 211.987L978.169 207.762V199.501Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M877.317 213.077L870.51 209.078L863.74 213.077V221.339L870.51 225.564L877.317 221.339V213.077Z"
          fill="#8676FF"
        />
        <path
          d="M892.832 213.077L886.026 209.078L879.255 213.077V221.339L886.026 225.564L892.832 221.339V213.077Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M908.347 213.077L901.541 209.078L894.771 213.077V221.339L901.541 225.564L908.347 221.339V213.077Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M923.863 213.077L917.057 209.078L910.287 213.077V221.339L917.057 225.564L923.863 221.339V213.077Z"
          fill="#8676FF"
        />
        <path
          d="M939.379 213.077L932.573 209.078L925.803 213.077V221.339L932.573 225.564L939.379 221.339V213.077Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M954.895 213.077L948.089 209.078L941.319 213.077V221.339L948.089 225.564L954.895 221.339V213.077Z"
          fill="#8676FF"
        />
        <path
          d="M970.411 213.077L963.604 209.078L956.834 213.077V221.339L963.604 225.564L970.411 221.339V213.077Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M985.927 213.077L979.121 209.078L972.35 213.077V221.339L979.121 225.564L985.927 221.339V213.077Z"
          fill="#8676FF"
        />
        <path
          d="M885.074 226.653L878.268 222.654L871.497 226.653V234.915L878.268 239.14L885.074 234.915V226.653Z"
          fill="white"
        />
        <path
          d="M900.59 226.653L893.784 222.654L887.013 226.653V234.915L893.784 239.14L900.59 234.915V226.653Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M916.105 226.653L909.299 222.654L902.529 226.653V234.915L909.299 239.14L916.105 234.915V226.653Z"
          fill="#8676FF"
        />
        <path
          d="M931.622 226.653L924.816 222.654L918.046 226.653V234.915L924.816 239.14L931.622 234.915V226.653Z"
          fill="#8676FF"
        />
        <path
          d="M947.137 226.653L940.331 222.654L933.561 226.653V234.915L940.331 239.14L947.137 234.915V226.653Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M962.652 226.653L955.846 222.654L949.076 226.653V234.915L955.846 239.14L962.652 234.915V226.653Z"
          fill="#8676FF"
        />
        <path
          d="M978.169 226.653L971.363 222.654L964.592 226.653V234.915L971.363 239.14L978.169 234.915V226.653Z"
          fill="white"
        />
        <path
          d="M877.317 240.228L870.51 236.229L863.74 240.228V248.49L870.51 252.715L877.317 248.49V240.228Z"
          fill="white"
        />
        <path
          d="M892.832 240.228L886.026 236.229L879.255 240.228V248.49L886.026 252.715L892.832 248.49V240.228Z"
          fill="white"
        />
        <path
          d="M923.863 240.228L917.057 236.229L910.287 240.228V248.49L917.057 252.715L923.863 248.49V240.228Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M939.379 240.228L932.573 236.229L925.803 240.228V248.49L932.573 252.715L939.379 248.49V240.228Z"
          fill="#8676FF"
        />
        <path
          d="M954.895 240.228L948.089 236.229L941.319 240.228V248.49L948.089 252.715L954.895 248.49V240.228Z"
          fill="white"
        />
        <path
          d="M970.411 240.228L963.604 236.229L956.834 240.228V248.49L963.604 252.715L970.411 248.49V240.228Z"
          fill="white"
        />
        <path
          d="M985.927 240.228L979.121 236.229L972.35 240.228V248.49L979.121 252.715L985.927 248.49V240.228Z"
          fill="white"
        />
        <path
          d="M885.074 253.804L878.268 249.806L871.497 253.804V262.066L878.268 266.291L885.074 262.066V253.804Z"
          fill="white"
        />
        <path
          d="M931.622 253.804L924.816 249.806L918.046 253.804V262.066L924.816 266.291L931.622 262.066V253.804Z"
          fill="white"
        />
        <path
          d="M947.137 253.804L940.331 249.806L933.561 253.804V262.066L940.331 266.291L947.137 262.066V253.804Z"
          fill="white"
        />
        <path
          d="M962.652 253.804L955.846 249.806L949.076 253.804V262.066L955.846 266.291L962.652 262.066V253.804Z"
          fill="white"
        />
        <path
          d="M978.169 253.804L971.363 249.806L964.592 253.804V262.066L971.363 266.291L978.169 262.066V253.804Z"
          fill="white"
        />
        <path
          d="M877.317 267.382L870.51 263.383L863.74 267.382V275.643L870.51 279.868L877.317 275.643V267.382Z"
          fill="white"
        />
        <path
          d="M892.832 267.382L886.026 263.383L879.255 267.382V275.643L886.026 279.868L892.832 275.643V267.382Z"
          fill="white"
        />
        <path
          d="M939.379 267.382L932.573 263.383L925.803 267.382V275.643L932.573 279.868L939.379 275.643V267.382Z"
          fill="white"
        />
        <path
          d="M954.895 267.382L948.089 263.383L941.319 267.382V275.643L948.089 279.868L954.895 275.643V267.382Z"
          fill="white"
        />
        <path
          d="M970.411 267.382L963.604 263.383L956.834 267.382V275.643L963.604 279.868L970.411 275.643V267.382Z"
          fill="white"
        />
        <path
          d="M985.927 267.382L979.121 263.383L972.35 267.382V275.643L979.121 279.868L985.927 275.643V267.382Z"
          fill="white"
        />
        <path
          d="M885.074 280.957L878.268 276.958L871.497 280.957V289.218L878.268 293.444L885.074 289.218V280.957Z"
          fill="white"
        />
        <path
          d="M900.59 280.957L893.784 276.958L887.013 280.957V289.218L893.784 293.444L900.59 289.218V280.957Z"
          fill="white"
        />
        <path
          d="M931.622 280.957L924.816 276.958L918.046 280.957V289.218L924.816 293.444L931.622 289.218V280.957Z"
          fill="white"
        />
        <path
          d="M947.137 280.957L940.331 276.958L933.561 280.957V289.218L940.331 293.444L947.137 289.218V280.957Z"
          fill="white"
        />
        <path
          d="M962.652 280.957L955.846 276.958L949.076 280.957V289.218L955.846 293.444L962.652 289.218V280.957Z"
          fill="white"
        />
        <path
          d="M978.169 280.957L971.363 276.958L964.592 280.957V289.218L971.363 293.444L978.169 289.218V280.957Z"
          fill="white"
        />
        <path
          d="M877.317 294.534L870.51 290.535L863.74 294.534V302.796L870.51 307.021L877.317 302.796V294.534Z"
          fill="white"
        />
        <path
          d="M892.832 294.534L886.026 290.535L879.255 294.534V302.796L886.026 307.021L892.832 302.796V294.534Z"
          fill="white"
        />
        <path
          d="M908.347 294.534L901.541 290.535L894.771 294.534V302.796L901.541 307.021L908.347 302.796V294.534Z"
          fill="white"
        />
        <path
          d="M939.379 294.534L932.573 290.535L925.803 294.534V302.796L932.573 307.021L939.379 302.796V294.534Z"
          fill="white"
        />
        <path
          d="M954.895 294.534L948.089 290.535L941.319 294.534V302.796L948.089 307.021L954.895 302.796V294.534Z"
          fill="white"
        />
        <path
          d="M970.411 294.534L963.604 290.535L956.834 294.534V302.796L963.604 307.021L970.411 302.796V294.534Z"
          fill="white"
        />
        <path
          d="M985.927 294.534L979.121 290.535L972.35 294.534V302.796L979.121 307.021L985.927 302.796V294.534Z"
          fill="white"
        />
        <path
          d="M885.074 308.11L878.268 304.111L871.497 308.11V316.372L878.268 320.597L885.074 316.372V308.11Z"
          fill="#D45AFF"
        />
        <path
          d="M900.59 308.11L893.784 304.111L887.013 308.11V316.372L893.784 320.597L900.59 316.372V308.11Z"
          fill="white"
        />
        <path
          d="M916.105 308.11L909.299 304.111L902.529 308.11V316.372L909.299 320.597L916.105 316.372V308.11Z"
          fill="white"
        />
        <path
          d="M931.622 308.11L924.816 304.111L918.046 308.11V316.372L924.816 320.597L931.622 316.372V308.11Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M947.137 308.11L940.331 304.111L933.561 308.11V316.372L940.331 320.597L947.137 316.372V308.11Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M962.652 308.11L955.846 304.111L949.076 308.11V316.372L955.846 320.597L962.652 316.372V308.11Z"
          fill="#8676FF"
        />
        <path
          d="M978.169 308.11L971.363 304.111L964.592 308.11V316.372L971.363 320.597L978.169 316.372V308.11Z"
          fill="white"
        />
        <path
          d="M877.317 321.687L870.51 317.688L863.74 321.687V329.949L870.51 334.174L877.317 329.949V321.687Z"
          fill="white"
        />
        <path
          d="M892.832 321.687L886.026 317.688L879.255 321.687V329.949L886.026 334.174L892.832 329.949V321.687Z"
          fill="white"
        />
        <path
          d="M908.347 321.687L901.541 317.688L894.771 321.687V329.949L901.541 334.174L908.347 329.949V321.687Z"
          fill="white"
        />
        <path
          d="M923.863 321.687L917.057 317.688L910.287 321.687V329.949L917.057 334.174L923.863 329.949V321.687Z"
          fill="white"
        />
        <path
          d="M939.379 321.687L932.573 317.688L925.803 321.687V329.949L932.573 334.174L939.379 329.949V321.687Z"
          fill="white"
        />
        <path
          d="M954.895 321.687L948.089 317.688L941.319 321.687V329.949L948.089 334.174L954.895 329.949V321.687Z"
          fill="white"
        />
        <path
          d="M970.411 321.687L963.604 317.688L956.834 321.687V329.949L963.604 334.174L970.411 329.949V321.687Z"
          fill="white"
        />
        <path
          d="M985.927 321.687L979.121 317.688L972.35 321.687V329.949L979.121 334.174L985.927 329.949V321.687Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M885.074 335.262L878.268 331.264L871.497 335.262V343.524L878.268 347.749L885.074 343.524V335.262Z"
          fill="#8676FF"
        />
        <path
          d="M900.59 335.262L893.784 331.264L887.013 335.262V343.524L893.784 347.749L900.59 343.524V335.262Z"
          fill="white"
        />
        <path
          d="M931.622 335.262L924.816 331.264L918.046 335.262V343.524L924.816 347.749L931.622 343.524V335.262Z"
          fill="white"
        />
        <path
          d="M947.137 335.262L940.331 331.264L933.561 335.262V343.524L940.331 347.749L947.137 343.524V335.262Z"
          fill="white"
        />
        <path
          d="M962.652 335.262L955.846 331.264L949.076 335.262V343.524L955.846 347.749L962.652 343.524V335.262Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M978.169 335.262L971.363 331.264L964.592 335.262V343.524L971.363 347.749L978.169 343.524V335.262Z"
          fill="#8676FF"
        />
        <path
          d="M877.317 348.839L870.51 344.84L863.74 348.839V357.1L870.51 361.325L877.317 357.1V348.839Z"
          fill="white"
        />
        <path
          d="M892.832 348.839L886.026 344.84L879.255 348.839V357.1L886.026 361.325L892.832 357.1V348.839Z"
          fill="white"
        />
        <path
          d="M908.347 348.839L901.541 344.84L894.771 348.839V357.1L901.541 361.325L908.347 357.1V348.839Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M939.379 348.839L932.573 344.84L925.803 348.839V357.1L932.573 361.325L939.379 357.1V348.839Z"
          fill="#8676FF"
        />
        <path
          d="M954.895 348.839L948.089 344.84L941.319 348.839V357.1L948.089 361.325L954.895 357.1V348.839Z"
          fill="white"
        />
        <path
          d="M970.411 348.839L963.604 344.84L956.834 348.839V357.1L963.604 361.325L970.411 357.1V348.839Z"
          fill="white"
        />
        <path
          d="M985.927 348.839L979.121 344.84L972.35 348.839V357.1L979.121 361.325L985.927 357.1V348.839Z"
          fill="white"
        />
        <path
          d="M885.074 362.415L878.268 358.416L871.497 362.415V370.676L878.268 374.902L885.074 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M900.59 362.415L893.784 358.416L887.013 362.415V370.676L893.784 374.902L900.59 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M916.105 362.415L909.299 358.416L902.529 362.415V370.676L909.299 374.902L916.105 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M947.137 362.415L940.331 358.416L933.561 362.415V370.676L940.331 374.902L947.137 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M962.652 362.415L955.846 358.416L949.076 362.415V370.676L955.846 374.902L962.652 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M978.169 362.415L971.363 358.416L964.592 362.415V370.676L971.363 374.902L978.169 370.676V362.415Z"
          fill="white"
        />
        <path
          d="M877.317 375.994L870.51 371.995L863.74 375.994V384.256L870.51 388.481L877.317 384.256V375.994Z"
          fill="white"
        />
        <path
          d="M892.832 375.994L886.026 371.995L879.255 375.994V384.256L886.026 388.481L892.832 384.256V375.994Z"
          fill="white"
        />
        <path
          d="M908.347 375.994L901.541 371.995L894.771 375.994V384.256L901.541 388.481L908.347 384.256V375.994Z"
          fill="white"
        />
        <path
          d="M923.863 375.994L917.057 371.995L910.287 375.994V384.256L917.057 388.481L923.863 384.256V375.994Z"
          fill="white"
        />
        <path
          d="M939.379 375.994L932.573 371.995L925.803 375.994V384.256L932.573 388.481L939.379 384.256V375.994Z"
          fill="white"
        />
        <path
          d="M954.895 375.994L948.089 371.995L941.319 375.994V384.256L948.089 388.481L954.895 384.256V375.994Z"
          fill="white"
        />
        <path
          d="M970.411 375.994L963.604 371.995L956.834 375.994V384.256L963.604 388.481L970.411 384.256V375.994Z"
          fill="white"
        />
        <path
          d="M885.074 389.568L878.268 385.569L871.497 389.568V397.83L878.268 402.055L885.074 397.83V389.568Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M900.59 389.568L893.784 385.569L887.013 389.568V397.83L893.784 402.055L900.59 397.83V389.568Z"
          fill="#8676FF"
        />
        <path
          d="M916.105 389.568L909.299 385.569L902.529 389.568V397.83L909.299 402.055L916.105 397.83V389.568Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M931.622 389.568L924.816 385.569L918.046 389.568V397.83L924.816 402.055L931.622 397.83V389.568Z"
          fill="#8676FF"
        />
        <path
          d="M947.137 389.568L940.331 385.569L933.561 389.568V397.83L940.331 402.055L947.137 397.83V389.568Z"
          fill="white"
        />
        <path
          d="M962.652 389.568L955.846 385.569L949.076 389.568V397.83L955.846 402.055L962.652 397.83V389.568Z"
          fill="white"
        />
        <path
          d="M877.317 403.144L870.51 399.146L863.74 403.144V411.406L870.51 415.631L877.317 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M892.832 403.144L886.026 399.146L879.255 403.144V411.406L886.026 415.631L892.832 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M908.347 403.144L901.541 399.146L894.771 403.144V411.406L901.541 415.631L908.347 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M923.863 403.144L917.057 399.146L910.287 403.144V411.406L917.057 415.631L923.863 411.406V403.144Z"
          fill="white"
        />
        <path
          d="M939.379 403.144L932.573 399.146L925.803 403.144V411.406L932.573 415.631L939.379 411.406V403.144Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M885.074 416.721L878.268 412.723L871.497 416.721V424.983L878.268 429.208L885.074 424.983V416.721Z"
          fill="#8676FF"
        />
        <path
          d="M900.59 416.721L893.784 412.723L887.013 416.721V424.983L893.784 429.208L900.59 424.983V416.721Z"
          fill="white"
        />
        <path
          d="M916.105 416.721L909.299 412.723L902.529 416.721V424.983L909.299 429.208L916.105 424.983V416.721Z"
          fill="white"
        />
        <path
          d="M931.622 416.721L924.816 412.723L918.046 416.721V424.983L924.816 429.208L931.622 424.983V416.721Z"
          fill="white"
        />
        <path
          d="M877.317 430.298L870.51 426.299L863.74 430.298V438.559L870.51 442.784L877.317 438.559V430.298Z"
          fill="white"
        />
        <path
          d="M892.832 430.298L886.026 426.299L879.255 430.298V438.559L886.026 442.784L892.832 438.559V430.298Z"
          fill="white"
        />
        <path
          d="M908.347 430.298L901.541 426.299L894.771 430.298V438.559L901.541 442.784L908.347 438.559V430.298Z"
          fill="white"
        />
        <path
          d="M923.863 430.298L917.057 426.299L910.287 430.298V438.559L917.057 442.784L923.863 438.559V430.298Z"
          fill="white"
        />
        <path
          d="M885.074 443.873L878.268 439.874L871.497 443.873V452.134L878.268 456.36L885.074 452.134V443.873Z"
          fill="white"
        />
        <path
          d="M900.59 443.873L893.784 439.874L887.013 443.873V452.134L893.784 456.36L900.59 452.134V443.873Z"
          fill="white"
        />
        <path
          d="M916.105 443.873L909.299 439.874L902.529 443.873V452.134L909.299 456.36L916.105 452.134V443.873Z"
          fill="white"
        />
        <path
          d="M931.622 443.873L924.816 439.874L918.046 443.873V452.134L924.816 456.36L931.622 452.134V443.873Z"
          fill="white"
        />
        <path
          d="M994.07 63.7361L987.264 59.7373L980.494 63.7361V71.9977L987.264 76.2228L994.07 71.9977V63.7361Z"
          fill="white"
        />
        <path
          d="M994.07 90.8884L987.264 86.8896L980.494 90.8884V99.1501L987.264 103.375L994.07 99.1501V90.8884Z"
          fill="white"
        />
        <path
          d="M994.07 118.042L987.264 114.043L980.494 118.042V126.303L987.264 130.529L994.07 126.303V118.042Z"
          fill="white"
        />
        <path
          d="M994.07 145.194L987.264 141.195L980.494 145.194V153.456L987.264 157.681L994.07 153.456V145.194Z"
          fill="white"
        />
        <path
          d="M994.07 172.346L987.264 168.348L980.494 172.346V180.608L987.264 184.833L994.07 180.608V172.346Z"
          fill="white"
        />
        <path
          d="M994.07 199.501L987.264 195.502L980.494 199.501V207.762L987.264 211.987L994.07 207.762V199.501Z"
          fill="white"
        />
        <path
          d="M994.07 226.653L987.264 222.654L980.494 226.653V234.915L987.264 239.14L994.07 234.915V226.653Z"
          fill="#8676FF"
        />
        <path
          d="M994.07 253.804L987.264 249.806L980.494 253.804V262.066L987.264 266.291L994.07 262.066V253.804Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M994.07 280.957L987.264 276.958L980.494 280.957V289.218L987.264 293.444L994.07 289.218V280.957Z"
          fill="#8676FF"
        />
        <path
          d="M994.07 308.11L987.264 304.111L980.494 308.11V316.372L987.264 320.597L994.07 316.372V308.11Z"
          fill="white"
        />
        <path
          d="M994.07 335.262L987.264 331.264L980.494 335.262V343.524L987.264 347.749L994.07 343.524V335.262Z"
          fill="white"
        />
        <path
          d="M994.07 362.415L987.264 358.416L980.494 362.415V370.676L987.264 374.902L994.07 370.676V362.415Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M287.523 457.8L280.717 453.801L273.947 457.8V466.061L280.717 470.286L287.523 466.061V457.8Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M303.04 457.8L296.234 453.801L289.463 457.8V466.061L296.234 470.286L303.04 466.061V457.8Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M318.556 457.8L311.75 453.801L304.979 457.8V466.061L311.75 470.286L318.556 466.061V457.8Z"
          fill="#8676FF"
        />
        <path
          d="M334.071 457.8L327.265 453.801L320.495 457.8V466.061L327.265 470.286L334.071 466.061V457.8Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M349.587 457.8L342.781 453.801L336.011 457.8V466.061L342.781 470.286L349.587 466.061V457.8Z"
          fill="#8676FF"
        />
        <path
          d="M365.103 457.8L358.297 453.801L351.527 457.8V466.061L358.297 470.286L365.103 466.061V457.8Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M380.619 457.8L373.812 453.801L367.042 457.8V466.061L373.812 470.286L380.619 466.061V457.8Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M396.135 457.8L389.329 453.801L382.558 457.8V466.061L389.329 470.286L396.135 466.061V457.8Z"
          fill="#8676FF"
        />
        <path
          d="M628.871 457.8L622.065 453.801L615.295 457.8V466.061L622.065 470.286L628.871 466.061V457.8Z"
          fill="white"
        />
        <path
          d="M644.386 457.8L637.58 453.801L630.81 457.8V466.061L637.58 470.286L644.386 466.061V457.8Z"
          fill="white"
        />
        <path
          d="M659.904 457.8L653.098 453.801L646.327 457.8V466.061L653.098 470.286L659.904 466.061V457.8Z"
          fill="white"
        />
        <path
          d="M675.419 457.8L668.613 453.801L661.843 457.8V466.061L668.613 470.286L675.419 466.061V457.8Z"
          fill="white"
        />
        <path
          d="M690.934 457.8L684.128 453.801L677.358 457.8V466.061L684.128 470.286L690.934 466.061V457.8Z"
          fill="white"
        />
        <path
          d="M706.45 457.8L699.644 453.801L692.874 457.8V466.061L699.644 470.286L706.45 466.061V457.8Z"
          fill="white"
        />
        <path
          d="M721.966 457.8L715.16 453.801L708.39 457.8V466.061L715.16 470.286L721.966 466.061V457.8Z"
          fill="white"
        />
        <path
          d="M737.482 457.8L730.676 453.801L723.906 457.8V466.061L730.676 470.286L737.482 466.061V457.8Z"
          fill="white"
        />
        <path
          d="M752.998 457.8L746.192 453.801L739.421 457.8V466.061L746.192 470.286L752.998 466.061V457.8Z"
          fill="white"
        />
        <path
          d="M768.514 457.8L761.708 453.801L754.938 457.8V466.061L761.708 470.286L768.514 466.061V457.8Z"
          fill="white"
        />
        <path
          d="M784.03 457.8L777.224 453.801L770.454 457.8V466.061L777.224 470.286L784.03 466.061V457.8Z"
          fill="white"
        />
        <path
          d="M799.545 457.8L792.739 453.801L785.969 457.8V466.061L792.739 470.286L799.545 466.061V457.8Z"
          fill="white"
        />
        <path
          d="M815.061 457.8L808.255 453.801L801.485 457.8V466.061L808.255 470.286L815.061 466.061V457.8Z"
          fill="white"
        />
        <path
          d="M830.577 457.8L823.77 453.801L817 457.8V466.061L823.77 470.286L830.577 466.061V457.8Z"
          fill="white"
        />
        <path
          d="M846.093 457.8L839.287 453.801L832.516 457.8V466.061L839.287 470.286L846.093 466.061V457.8Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M861.609 457.8L854.803 453.801L848.032 457.8V466.061L854.803 470.286L861.609 466.061V457.8Z"
          fill="#8676FF"
        />
        <path
          d="M877.317 457.8L870.51 453.801L863.74 457.8V466.061L870.51 470.286L877.317 466.061V457.8Z"
          fill="white"
        />
        <path
          d="M892.832 457.8L886.026 453.801L879.255 457.8V466.061L886.026 470.286L892.832 466.061V457.8Z"
          fill="white"
        />
        <path
          d="M908.347 457.8L901.541 453.801L894.771 457.8V466.061L901.541 470.286L908.347 466.061V457.8Z"
          fill="white"
        />
        <path
          d="M923.863 457.8L917.057 453.801L910.287 457.8V466.061L917.057 470.286L923.863 466.061V457.8Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M310.799 471.934L303.993 467.936L297.222 471.934V480.196L303.993 484.421L310.799 480.196V471.934Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M326.313 471.934L319.507 467.936L312.737 471.934V480.196L319.507 484.421L326.313 480.196V471.934Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M341.829 471.934L335.023 467.936L328.253 471.934V480.196L335.023 484.421L341.829 480.196V471.934Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M357.345 471.934L350.539 467.936L343.769 471.934V480.196L350.539 484.421L357.345 480.196V471.934Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M372.861 471.934L366.055 467.936L359.285 471.934V480.196L366.055 484.421L372.861 480.196V471.934Z"
          fill="#8676FF"
        />
        <path
          d="M388.377 471.934L381.571 467.936L374.8 471.934V480.196L381.571 484.421L388.377 480.196V471.934Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M403.893 471.934L397.087 467.936L390.316 471.934V480.196L397.087 484.421L403.893 480.196V471.934Z"
          fill="#8676FF"
        />
        <path
          d="M419.408 471.934L412.602 467.936L405.832 471.934V480.196L412.602 484.421L419.408 480.196V471.934Z"
          fill="white"
        />
        <path
          d="M636.629 471.934L629.823 467.936L623.053 471.934V480.196L629.823 484.421L636.629 480.196V471.934Z"
          fill="white"
        />
        <path
          d="M652.144 471.934L645.338 467.936L638.568 471.934V480.196L645.338 484.421L652.144 480.196V471.934Z"
          fill="white"
        />
        <path
          d="M667.662 471.934L660.856 467.936L654.085 471.934V480.196L660.856 484.421L667.662 480.196V471.934Z"
          fill="white"
        />
        <path
          d="M729.724 471.934L722.918 467.936L716.148 471.934V480.196L722.918 484.421L729.724 480.196V471.934Z"
          fill="white"
        />
        <path
          d="M745.24 471.934L738.433 467.936L731.663 471.934V480.196L738.433 484.421L745.24 480.196V471.934Z"
          fill="white"
        />
        <path
          d="M760.756 471.934L753.95 467.936L747.179 471.934V480.196L753.95 484.421L760.756 480.196V471.934Z"
          fill="white"
        />
        <path
          d="M776.272 471.934L769.466 467.936L762.696 471.934V480.196L769.466 484.421L776.272 480.196V471.934Z"
          fill="white"
        />
        <path
          d="M791.788 471.934L784.982 467.936L778.212 471.934V480.196L784.982 484.421L791.788 480.196V471.934Z"
          fill="white"
        />
        <path
          d="M807.303 471.934L800.497 467.936L793.727 471.934V480.196L800.497 484.421L807.303 480.196V471.934Z"
          fill="white"
        />
        <path
          d="M822.818 471.934L816.012 467.936L809.242 471.934V480.196L816.012 484.421L822.818 480.196V471.934Z"
          fill="white"
        />
        <path
          d="M838.336 471.934L831.53 467.936L824.759 471.934V480.196L831.53 484.421L838.336 480.196V471.934Z"
          fill="white"
        />
        <path
          d="M853.851 471.934L847.045 467.936L840.274 471.934V480.196L847.045 484.421L853.851 480.196V471.934Z"
          fill="white"
        />
        <path
          d="M869.366 471.934L862.56 467.936L855.79 471.934V480.196L862.56 484.421L869.366 480.196V471.934Z"
          fill="white"
        />
        <path
          d="M303.04 485.51L296.234 481.512L289.463 485.51V493.772L296.234 497.997L303.04 493.772V485.51Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M318.556 485.51L311.75 481.512L304.979 485.51V493.772L311.75 497.997L318.556 493.772V485.51Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M334.071 485.51L327.265 481.512L320.495 485.51V493.772L327.265 497.997L334.071 493.772V485.51Z"
          fill="#8676FF"
        />
        <path
          d="M349.587 485.51L342.781 481.512L336.011 485.51V493.772L342.781 497.997L349.587 493.772V485.51Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M365.103 485.51L358.297 481.512L351.527 485.51V493.772L358.297 497.997L365.103 493.772V485.51Z"
          fill="#8676FF"
        />
        <path
          d="M380.619 485.51L373.812 481.512L367.042 485.51V493.772L373.812 497.997L380.619 493.772V485.51Z"
          fill="#8676FF"
        />
        <path
          d="M396.135 485.51L389.329 481.512L382.558 485.51V493.772L389.329 497.997L396.135 493.772V485.51Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M411.65 485.51L404.844 481.512L398.073 485.51V493.772L404.844 497.997L411.65 493.772V485.51Z"
          fill="#8676FF"
        />
        <path
          d="M427.166 485.51L420.36 481.512L413.59 485.51V493.772L420.36 497.997L427.166 493.772V485.51Z"
          fill="white"
        />
        <path
          d="M721.966 485.51L715.16 481.512L708.39 485.51V493.772L715.16 497.997L721.966 493.772V485.51Z"
          fill="white"
        />
        <path
          d="M737.482 485.51L730.676 481.512L723.906 485.51V493.772L730.676 497.997L737.482 493.772V485.51Z"
          fill="white"
        />
        <path
          d="M752.998 485.51L746.192 481.512L739.421 485.51V493.772L746.192 497.997L752.998 493.772V485.51Z"
          fill="white"
        />
        <path
          d="M768.514 485.51L761.708 481.512L754.938 485.51V493.772L761.708 497.997L768.514 493.772V485.51Z"
          fill="white"
        />
        <path
          d="M784.03 485.51L777.224 481.512L770.454 485.51V493.772L777.224 497.997L784.03 493.772V485.51Z"
          fill="white"
        />
        <path
          d="M799.545 485.51L792.739 481.512L785.969 485.51V493.772L792.739 497.997L799.545 493.772V485.51Z"
          fill="white"
        />
        <path
          d="M815.061 485.51L808.255 481.512L801.485 485.51V493.772L808.255 497.997L815.061 493.772V485.51Z"
          fill="white"
        />
        <path
          d="M830.577 485.51L823.77 481.512L817 485.51V493.772L823.77 497.997L830.577 493.772V485.51Z"
          fill="white"
        />
        <path
          d="M846.093 485.51L839.287 481.512L832.516 485.51V493.772L839.287 497.997L846.093 493.772V485.51Z"
          fill="white"
        />
        <path
          d="M861.609 485.51L854.803 481.512L848.032 485.51V493.772L854.803 497.997L861.609 493.772V485.51Z"
          fill="white"
        />
        <path
          d="M295.282 499.087L288.475 495.088L281.705 499.087V507.348L288.475 511.573L295.282 507.348V499.087Z"
          fill="white"
        />
        <path
          d="M310.799 499.087L303.993 495.088L297.222 499.087V507.348L303.993 511.573L310.799 507.348V499.087Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M326.313 499.087L319.507 495.088L312.737 499.087V507.348L319.507 511.573L326.313 507.348V499.087Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M341.829 499.087L335.023 495.088L328.253 499.087V507.348L335.023 511.573L341.829 507.348V499.087Z"
          fill="#8676FF"
        />
        <path
          d="M357.345 499.087L350.539 495.088L343.769 499.087V507.348L350.539 511.573L357.345 507.348V499.087Z"
          fill="white"
        />
        <path
          d="M372.861 499.087L366.055 495.088L359.285 499.087V507.348L366.055 511.573L372.861 507.348V499.087Z"
          fill="white"
        />
        <path
          d="M388.377 499.087L381.571 495.088L374.8 499.087V507.348L381.571 511.573L388.377 507.348V499.087Z"
          fill="#8676FF"
        />
        <path
          d="M403.893 499.087L397.087 495.088L390.316 499.087V507.348L397.087 511.573L403.893 507.348V499.087Z"
          fill="white"
        />
        <path
          d="M419.408 499.087L412.602 495.088L405.832 499.087V507.348L412.602 511.573L419.408 507.348V499.087Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M434.924 499.087L428.118 495.088L421.348 499.087V507.348L428.118 511.573L434.924 507.348V499.087Z"
          fill="#8676FF"
        />
        <path
          d="M729.724 499.087L722.918 495.088L716.148 499.087V507.348L722.918 511.573L729.724 507.348V499.087Z"
          fill="white"
        />
        <path
          d="M745.24 499.087L738.433 495.088L731.663 499.087V507.348L738.433 511.573L745.24 507.348V499.087Z"
          fill="white"
        />
        <path
          d="M760.756 499.087L753.95 495.088L747.179 499.087V507.348L753.95 511.573L760.756 507.348V499.087Z"
          fill="white"
        />
        <path
          d="M776.272 499.087L769.466 495.088L762.696 499.087V507.348L769.466 511.573L776.272 507.348V499.087Z"
          fill="white"
        />
        <path
          d="M791.788 499.087L784.982 495.088L778.212 499.087V507.348L784.982 511.573L791.788 507.348V499.087Z"
          fill="white"
        />
        <path
          d="M807.303 499.087L800.497 495.088L793.727 499.087V507.348L800.497 511.573L807.303 507.348V499.087Z"
          fill="white"
        />
        <path
          d="M822.818 499.087L816.012 495.088L809.242 499.087V507.348L816.012 511.573L822.818 507.348V499.087Z"
          fill="white"
        />
        <path
          d="M838.336 499.087L831.53 495.088L824.759 499.087V507.348L831.53 511.573L838.336 507.348V499.087Z"
          fill="white"
        />
        <path
          d="M853.851 499.087L847.045 495.088L840.274 499.087V507.348L847.045 511.573L853.851 507.348V499.087Z"
          fill="white"
        />
        <path
          d="M869.366 499.087L862.56 495.088L855.79 499.087V507.348L862.56 511.573L869.366 507.348V499.087Z"
          fill="white"
        />
        <path
          d="M287.523 512.664L280.717 508.665L273.947 512.664V520.925L280.717 525.151L287.523 520.925V512.664Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M303.04 512.664L296.234 508.665L289.463 512.664V520.925L296.234 525.151L303.04 520.925V512.664Z"
          fill="#8676FF"
        />
        <path
          d="M318.556 512.664L311.75 508.665L304.979 512.664V520.925L311.75 525.151L318.556 520.925V512.664Z"
          fill="white"
        />
        <path
          d="M334.071 512.664L327.265 508.665L320.495 512.664V520.925L327.265 525.151L334.071 520.925V512.664Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M349.587 512.664L342.781 508.665L336.011 512.664V520.925L342.781 525.151L349.587 520.925V512.664Z"
          fill="#8676FF"
        />
        <path
          d="M365.103 512.664L358.297 508.665L351.527 512.664V520.925L358.297 525.151L365.103 520.925V512.664Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M380.619 512.664L373.812 508.665L367.042 512.664V520.925L373.812 525.151L380.619 520.925V512.664Z"
          fill="#8676FF"
        />
        <path
          d="M396.135 512.664L389.329 508.665L382.558 512.664V520.925L389.329 525.151L396.135 520.925V512.664Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M411.65 512.664L404.844 508.665L398.073 512.664V520.925L404.844 525.151L411.65 520.925V512.664Z"
          fill="#8676FF"
        />
        <path
          d="M427.166 512.664L420.36 508.665L413.59 512.664V520.925L420.36 525.151L427.166 520.925V512.664Z"
          fill="#8676FF"
        />
        <path
          d="M442.682 512.664L435.876 508.665L429.106 512.664V520.925L435.876 525.151L442.682 520.925V512.664Z"
          fill="white"
        />
        <path
          d="M458.197 512.664L451.391 508.665L444.621 512.664V520.925L451.391 525.151L458.197 520.925V512.664Z"
          fill="#8676FF"
        />
        <path
          d="M737.482 512.664L730.676 508.665L723.906 512.664V520.925L730.676 525.151L737.482 520.925V512.664Z"
          fill="white"
        />
        <path
          d="M752.998 512.664L746.192 508.665L739.421 512.664V520.925L746.192 525.151L752.998 520.925V512.664Z"
          fill="white"
        />
        <path
          d="M768.514 512.664L761.708 508.665L754.938 512.664V520.925L761.708 525.151L768.514 520.925V512.664Z"
          fill="white"
        />
        <path
          d="M784.03 512.664L777.224 508.665L770.454 512.664V520.925L777.224 525.151L784.03 520.925V512.664Z"
          fill="white"
        />
        <path
          d="M799.545 512.664L792.739 508.665L785.969 512.664V520.925L792.739 525.151L799.545 520.925V512.664Z"
          fill="white"
        />
        <path
          d="M815.061 512.664L808.255 508.665L801.485 512.664V520.925L808.255 525.151L815.061 520.925V512.664Z"
          fill="white"
        />
        <path
          d="M830.577 512.664L823.77 508.665L817 512.664V520.925L823.77 525.151L830.577 520.925V512.664Z"
          fill="white"
        />
        <path
          d="M846.093 512.664L839.287 508.665L832.516 512.664V520.925L839.287 525.151L846.093 520.925V512.664Z"
          fill="white"
        />
        <path
          d="M861.609 512.664L854.803 508.665L848.032 512.664V520.925L854.803 525.151L861.609 520.925V512.664Z"
          fill="white"
        />
        <path
          d="M295.282 526.24L288.475 522.241L281.705 526.24V534.502L288.475 538.727L295.282 534.502V526.24Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M310.799 526.24L303.993 522.241L297.222 526.24V534.502L303.993 538.727L310.799 534.502V526.24Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M326.313 526.24L319.507 522.241L312.737 526.24V534.502L319.507 538.727L326.313 534.502V526.24Z"
          fill="#8676FF"
        />
        <path
          d="M341.829 526.24L335.023 522.241L328.253 526.24V534.502L335.023 538.727L341.829 534.502V526.24Z"
          fill="white"
        />
        <path
          d="M357.345 526.24L350.539 522.241L343.769 526.24V534.502L350.539 538.727L357.345 534.502V526.24Z"
          fill="white"
        />
        <path
          d="M372.861 526.24L366.055 522.241L359.285 526.24V534.502L366.055 538.727L372.861 534.502V526.24Z"
          fill="#8676FF"
        />
        <path
          d="M388.377 526.24L381.571 522.241L374.8 526.24V534.502L381.571 538.727L388.377 534.502V526.24Z"
          fill="white"
        />
        <path
          d="M403.893 526.24L397.087 522.241L390.316 526.24V534.502L397.087 538.727L403.893 534.502V526.24Z"
          fill="white"
        />
        <path
          d="M419.408 526.24L412.602 522.241L405.832 526.24V534.502L412.602 538.727L419.408 534.502V526.24Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M434.924 526.24L428.118 522.241L421.348 526.24V534.502L428.118 538.727L434.924 534.502V526.24Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M450.44 526.24L443.634 522.241L436.864 526.24V534.502L443.634 538.727L450.44 534.502V526.24Z"
          fill="#8676FF"
        />
        <path
          d="M465.955 526.24L459.149 522.241L452.379 526.24V534.502L459.149 538.727L465.955 534.502V526.24Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M481.472 526.24L474.666 522.241L467.895 526.24V534.502L474.666 538.727L481.472 534.502V526.24Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M496.988 526.24L490.182 522.241L483.411 526.24V534.502L490.182 538.727L496.988 534.502V526.24Z"
          fill="#8676FF"
        />
        <path
          d="M729.724 526.24L722.918 522.241L716.148 526.24V534.502L722.918 538.727L729.724 534.502V526.24Z"
          fill="white"
        />
        <path
          d="M745.24 526.24L738.433 522.241L731.663 526.24V534.502L738.433 538.727L745.24 534.502V526.24Z"
          fill="white"
        />
        <path
          d="M760.756 526.24L753.95 522.241L747.179 526.24V534.502L753.95 538.727L760.756 534.502V526.24Z"
          fill="white"
        />
        <path
          d="M776.272 526.24L769.466 522.241L762.696 526.24V534.502L769.466 538.727L776.272 534.502V526.24Z"
          fill="white"
        />
        <path
          d="M791.788 526.24L784.982 522.241L778.212 526.24V534.502L784.982 538.727L791.788 534.502V526.24Z"
          fill="white"
        />
        <path
          d="M807.303 526.24L800.497 522.241L793.727 526.24V534.502L800.497 538.727L807.303 534.502V526.24Z"
          fill="white"
        />
        <path
          d="M822.818 526.24L816.012 522.241L809.242 526.24V534.502L816.012 538.727L822.818 534.502V526.24Z"
          fill="white"
        />
        <path
          d="M838.336 526.24L831.53 522.241L824.759 526.24V534.502L831.53 538.727L838.336 534.502V526.24Z"
          fill="white"
        />
        <path
          d="M853.851 526.24L847.045 522.241L840.274 526.24V534.502L847.045 538.727L853.851 534.502V526.24Z"
          fill="white"
        />
        <path
          d="M869.366 526.24L862.56 522.241L855.79 526.24V534.502L862.56 538.727L869.366 534.502V526.24Z"
          fill="white"
        />
        <path
          d="M303.04 539.815L296.234 535.816L289.463 539.815V548.077L296.234 552.302L303.04 548.077V539.815Z"
          fill="white"
        />
        <path
          d="M318.556 539.815L311.75 535.816L304.979 539.815V548.077L311.75 552.302L318.556 548.077V539.815Z"
          fill="white"
        />
        <path
          d="M334.071 539.815L327.265 535.816L320.495 539.815V548.077L327.265 552.302L334.071 548.077V539.815Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M349.587 539.815L342.781 535.816L336.011 539.815V548.077L342.781 552.302L349.587 548.077V539.815Z"
          fill="#8676FF"
        />
        <path
          d="M365.103 539.815L358.297 535.816L351.527 539.815V548.077L358.297 552.302L365.103 548.077V539.815Z"
          fill="white"
        />
        <path
          d="M380.619 539.815L373.812 535.816L367.042 539.815V548.077L373.812 552.302L380.619 548.077V539.815Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M396.135 539.815L389.329 535.816L382.558 539.815V548.077L389.329 552.302L396.135 548.077V539.815Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M411.65 539.815L404.844 535.816L398.073 539.815V548.077L404.844 552.302L411.65 548.077V539.815Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M427.166 539.815L420.36 535.816L413.59 539.815V548.077L420.36 552.302L427.166 548.077V539.815Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M442.682 539.815L435.876 535.816L429.106 539.815V548.077L435.876 552.302L442.682 548.077V539.815Z"
          fill="#8676FF"
        />
        <path
          d="M458.197 539.815L451.391 535.816L444.621 539.815V548.077L451.391 552.302L458.197 548.077V539.815Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M473.714 539.815L466.907 535.816L460.137 539.815V548.077L466.907 552.302L473.714 548.077V539.815Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M489.23 539.815L482.424 535.816L475.653 539.815V548.077L482.424 552.302L489.23 548.077V539.815Z"
          fill="#8676FF"
        />
        <path
          d="M504.745 539.815L497.939 535.816L491.169 539.815V548.077L497.939 552.302L504.745 548.077V539.815Z"
          fill="white"
        />
        <path
          d="M752.998 539.815L746.192 535.816L739.421 539.815V548.077L746.192 552.302L752.998 548.077V539.815Z"
          fill="white"
        />
        <path
          d="M768.514 539.815L761.708 535.816L754.938 539.815V548.077L761.708 552.302L768.514 548.077V539.815Z"
          fill="white"
        />
        <path
          d="M784.03 539.815L777.224 535.816L770.454 539.815V548.077L777.224 552.302L784.03 548.077V539.815Z"
          fill="white"
        />
        <path
          d="M799.545 539.815L792.739 535.816L785.969 539.815V548.077L792.739 552.302L799.545 548.077V539.815Z"
          fill="white"
        />
        <path
          d="M815.061 539.815L808.255 535.816L801.485 539.815V548.077L808.255 552.302L815.061 548.077V539.815Z"
          fill="white"
        />
        <path
          d="M830.577 539.815L823.77 535.816L817 539.815V548.077L823.77 552.302L830.577 548.077V539.815Z"
          fill="white"
        />
        <path
          d="M846.093 539.815L839.287 535.816L832.516 539.815V548.077L839.287 552.302L846.093 548.077V539.815Z"
          fill="white"
        />
        <path
          d="M861.609 539.815L854.803 535.816L848.032 539.815V548.077L854.803 552.302L861.609 548.077V539.815Z"
          fill="white"
        />
        <path
          d="M310.799 553.393L303.993 549.395L297.222 553.393V561.655L303.993 565.88L310.799 561.655V553.393Z"
          fill="white"
        />
        <path
          d="M326.313 553.393L319.507 549.395L312.737 553.393V561.655L319.507 565.88L326.313 561.655V553.393Z"
          fill="white"
        />
        <path
          d="M341.829 553.393L335.023 549.395L328.253 553.393V561.655L335.023 565.88L341.829 561.655V553.393Z"
          fill="white"
        />
        <path
          d="M357.345 553.393L350.539 549.395L343.769 553.393V561.655L350.539 565.88L357.345 561.655V553.393Z"
          fill="white"
        />
        <path
          d="M372.861 553.393L366.055 549.395L359.285 553.393V561.655L366.055 565.88L372.861 561.655V553.393Z"
          fill="#8676FF"
        />
        <path
          d="M388.377 553.393L381.571 549.395L374.8 553.393V561.655L381.571 565.88L388.377 561.655V553.393Z"
          fill="white"
        />
        <path
          d="M403.893 553.393L397.087 549.395L390.316 553.393V561.655L397.087 565.88L403.893 561.655V553.393Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M419.408 553.393L412.602 549.395L405.832 553.393V561.655L412.602 565.88L419.408 561.655V553.393Z"
          fill="#8676FF"
        />
        <path
          d="M434.924 553.393L428.118 549.395L421.348 553.393V561.655L428.118 565.88L434.924 561.655V553.393Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M450.44 553.393L443.634 549.395L436.864 553.393V561.655L443.634 565.88L450.44 561.655V553.393Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M465.955 553.393L459.149 549.395L452.379 553.393V561.655L459.149 565.88L465.955 561.655V553.393Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M481.472 553.393L474.666 549.395L467.895 553.393V561.655L474.666 565.88L481.472 561.655V553.393Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M496.988 553.393L490.182 549.395L483.411 553.393V561.655L490.182 565.88L496.988 561.655V553.393Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M512.503 553.393L505.697 549.395L498.927 553.393V561.655L505.697 565.88L512.503 561.655V553.393Z"
          fill="#8676FF"
        />
        <path
          d="M760.756 553.393L753.95 549.395L747.179 553.393V561.655L753.95 565.88L760.756 561.655V553.393Z"
          fill="white"
        />
        <path
          d="M776.272 553.393L769.466 549.395L762.696 553.393V561.655L769.466 565.88L776.272 561.655V553.393Z"
          fill="white"
        />
        <path
          d="M791.788 553.393L784.982 549.395L778.212 553.393V561.655L784.982 565.88L791.788 561.655V553.393Z"
          fill="white"
        />
        <path
          d="M807.303 553.393L800.497 549.395L793.727 553.393V561.655L800.497 565.88L807.303 561.655V553.393Z"
          fill="white"
        />
        <path
          d="M822.818 553.393L816.012 549.395L809.242 553.393V561.655L816.012 565.88L822.818 561.655V553.393Z"
          fill="white"
        />
        <path
          d="M838.336 553.393L831.53 549.395L824.759 553.393V561.655L831.53 565.88L838.336 561.655V553.393Z"
          fill="white"
        />
        <path
          d="M853.851 553.393L847.045 549.395L840.274 553.393V561.655L847.045 565.88L853.851 561.655V553.393Z"
          fill="white"
        />
        <path
          d="M869.366 553.393L862.56 549.395L855.79 553.393V561.655L862.56 565.88L869.366 561.655V553.393Z"
          fill="white"
        />
        <path
          d="M318.556 566.969L311.75 562.971L304.979 566.969V575.231L311.75 579.456L318.556 575.231V566.969Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M334.071 566.969L327.265 562.971L320.495 566.969V575.231L327.265 579.456L334.071 575.231V566.969Z"
          fill="#8676FF"
        />
        <path
          d="M349.587 566.969L342.781 562.971L336.011 566.969V575.231L342.781 579.456L349.587 575.231V566.969Z"
          fill="white"
        />
        <path
          d="M365.103 566.969L358.297 562.971L351.527 566.969V575.231L358.297 579.456L365.103 575.231V566.969Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M380.619 566.969L373.812 562.971L367.042 566.969V575.231L373.812 579.456L380.619 575.231V566.969Z"
          fill="#8676FF"
        />
        <path
          d="M396.135 566.969L389.329 562.971L382.558 566.969V575.231L389.329 579.456L396.135 575.231V566.969Z"
          fill="white"
        />
        <path
          d="M411.65 566.969L404.844 562.971L398.073 566.969V575.231L404.844 579.456L411.65 575.231V566.969Z"
          fill="white"
        />
        <path
          d="M427.166 566.969L420.36 562.971L413.59 566.969V575.231L420.36 579.456L427.166 575.231V566.969Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M442.682 566.969L435.876 562.971L429.106 566.969V575.231L435.876 579.456L442.682 575.231V566.969Z"
          fill="#8676FF"
        />
        <path
          d="M458.197 566.969L451.391 562.971L444.621 566.969V575.231L451.391 579.456L458.197 575.231V566.969Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M473.714 566.969L466.907 562.971L460.137 566.969V575.231L466.907 579.456L473.714 575.231V566.969Z"
          fill="#8676FF"
        />
        <path
          d="M489.23 566.969L482.424 562.971L475.653 566.969V575.231L482.424 579.456L489.23 575.231V566.969Z"
          fill="#8676FF"
        />
        <path
          d="M504.745 566.969L497.939 562.971L491.169 566.969V575.231L497.939 579.456L504.745 575.231V566.969Z"
          fill="white"
        />
        <path
          d="M752.998 566.969L746.192 562.971L739.421 566.969V575.231L746.192 579.456L752.998 575.231V566.969Z"
          fill="white"
        />
        <path
          d="M768.514 566.969L761.708 562.971L754.938 566.969V575.231L761.708 579.456L768.514 575.231V566.969Z"
          fill="white"
        />
        <path
          d="M784.03 566.969L777.224 562.971L770.454 566.969V575.231L777.224 579.456L784.03 575.231V566.969Z"
          fill="white"
        />
        <path
          d="M799.545 566.969L792.739 562.971L785.969 566.969V575.231L792.739 579.456L799.545 575.231V566.969Z"
          fill="white"
        />
        <path
          d="M815.061 566.969L808.255 562.971L801.485 566.969V575.231L808.255 579.456L815.061 575.231V566.969Z"
          fill="white"
        />
        <path
          d="M830.577 566.969L823.77 562.971L817 566.969V575.231L823.77 579.456L830.577 575.231V566.969Z"
          fill="white"
        />
        <path
          d="M846.093 566.969L839.287 562.971L832.516 566.969V575.231L839.287 579.456L846.093 575.231V566.969Z"
          fill="white"
        />
        <path
          d="M861.609 566.969L854.803 562.971L848.032 566.969V575.231L854.803 579.456L861.609 575.231V566.969Z"
          fill="white"
        />
        <path
          d="M326.313 580.546L319.507 576.547L312.737 580.546V588.807L319.507 593.032L326.313 588.807V580.546Z"
          fill="white"
        />
        <path
          d="M341.829 580.546L335.023 576.547L328.253 580.546V588.807L335.023 593.032L341.829 588.807V580.546Z"
          fill="white"
        />
        <path
          d="M357.345 580.546L350.539 576.547L343.769 580.546V588.807L350.539 593.032L357.345 588.807V580.546Z"
          fill="white"
        />
        <path
          d="M372.861 580.546L366.055 576.547L359.285 580.546V588.807L366.055 593.032L372.861 588.807V580.546Z"
          fill="white"
        />
        <path
          d="M388.377 580.546L381.571 576.547L374.8 580.546V588.807L381.571 593.032L388.377 588.807V580.546Z"
          fill="white"
        />
        <path
          d="M403.893 580.546L397.087 576.547L390.316 580.546V588.807L397.087 593.032L403.893 588.807V580.546Z"
          fill="white"
        />
        <path
          d="M419.408 580.546L412.602 576.547L405.832 580.546V588.807L412.602 593.032L419.408 588.807V580.546Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M434.924 580.546L428.118 576.547L421.348 580.546V588.807L428.118 593.032L434.924 588.807V580.546Z"
          fill="#8676FF"
        />
        <path
          d="M450.44 580.546L443.634 576.547L436.864 580.546V588.807L443.634 593.032L450.44 588.807V580.546Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M465.955 580.546L459.149 576.547L452.379 580.546V588.807L459.149 593.032L465.955 588.807V580.546Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M481.472 580.546L474.666 576.547L467.895 580.546V588.807L474.666 593.032L481.472 588.807V580.546Z"
          fill="#8676FF"
        />
        <path
          d="M745.24 580.546L738.433 576.547L731.663 580.546V588.807L738.433 593.032L745.24 588.807V580.546Z"
          fill="white"
        />
        <path
          d="M760.756 580.546L753.95 576.547L747.179 580.546V588.807L753.95 593.032L760.756 588.807V580.546Z"
          fill="white"
        />
        <path
          d="M776.272 580.546L769.466 576.547L762.696 580.546V588.807L769.466 593.032L776.272 588.807V580.546Z"
          fill="white"
        />
        <path
          d="M791.788 580.546L784.982 576.547L778.212 580.546V588.807L784.982 593.032L791.788 588.807V580.546Z"
          fill="white"
        />
        <path
          d="M807.303 580.546L800.497 576.547L793.727 580.546V588.807L800.497 593.032L807.303 588.807V580.546Z"
          fill="white"
        />
        <path
          d="M822.818 580.546L816.012 576.547L809.242 580.546V588.807L816.012 593.032L822.818 588.807V580.546Z"
          fill="white"
        />
        <path
          d="M838.336 580.546L831.53 576.547L824.759 580.546V588.807L831.53 593.032L838.336 588.807V580.546Z"
          fill="white"
        />
        <path
          d="M853.851 580.546L847.045 576.547L840.274 580.546V588.807L847.045 593.032L853.851 588.807V580.546Z"
          fill="white"
        />
        <path
          d="M869.366 580.546L862.56 576.547L855.79 580.546V588.807L862.56 593.032L869.366 588.807V580.546Z"
          fill="white"
        />
        <path
          d="M334.071 594.122L327.265 590.123L320.495 594.122V602.383L327.265 606.609L334.071 602.383V594.122Z"
          fill="white"
        />
        <path
          d="M349.587 594.122L342.781 590.123L336.011 594.122V602.383L342.781 606.609L349.587 602.383V594.122Z"
          fill="white"
        />
        <path
          d="M365.103 594.122L358.297 590.123L351.527 594.122V602.383L358.297 606.609L365.103 602.383V594.122Z"
          fill="white"
        />
        <path
          d="M380.619 594.122L373.812 590.123L367.042 594.122V602.383L373.812 606.609L380.619 602.383V594.122Z"
          fill="white"
        />
        <path
          d="M396.135 594.122L389.329 590.123L382.558 594.122V602.383L389.329 606.609L396.135 602.383V594.122Z"
          fill="white"
        />
        <path
          d="M411.65 594.122L404.844 590.123L398.073 594.122V602.383L404.844 606.609L411.65 602.383V594.122Z"
          fill="white"
        />
        <path
          d="M427.166 594.122L420.36 590.123L413.59 594.122V602.383L420.36 606.609L427.166 602.383V594.122Z"
          fill="white"
        />
        <path
          d="M442.682 594.122L435.876 590.123L429.106 594.122V602.383L435.876 606.609L442.682 602.383V594.122Z"
          fill="white"
        />
        <path
          d="M458.197 594.122L451.391 590.123L444.621 594.122V602.383L451.391 606.609L458.197 602.383V594.122Z"
          fill="white"
        />
        <path
          d="M473.714 594.122L466.907 590.123L460.137 594.122V602.383L466.907 606.609L473.714 602.383V594.122Z"
          fill="white"
        />
        <path
          d="M489.23 594.122L482.424 590.123L475.653 594.122V602.383L482.424 606.609L489.23 602.383V594.122Z"
          fill="white"
        />
        <path
          d="M752.998 594.122L746.192 590.123L739.421 594.122V602.383L746.192 606.609L752.998 602.383V594.122Z"
          fill="white"
        />
        <path
          d="M768.514 594.122L761.708 590.123L754.938 594.122V602.383L761.708 606.609L768.514 602.383V594.122Z"
          fill="white"
        />
        <path
          d="M784.03 594.122L777.224 590.123L770.454 594.122V602.383L777.224 606.609L784.03 602.383V594.122Z"
          fill="white"
        />
        <path
          d="M799.545 594.122L792.739 590.123L785.969 594.122V602.383L792.739 606.609L799.545 602.383V594.122Z"
          fill="white"
        />
        <path
          d="M815.061 594.122L808.255 590.123L801.485 594.122V602.383L808.255 606.609L815.061 602.383V594.122Z"
          fill="white"
        />
        <path
          d="M830.577 594.122L823.77 590.123L817 594.122V602.383L823.77 606.609L830.577 602.383V594.122Z"
          fill="white"
        />
        <path
          d="M846.093 594.122L839.287 590.123L832.516 594.122V602.383L839.287 606.609L846.093 602.383V594.122Z"
          fill="white"
        />
        <path
          d="M861.609 594.122L854.803 590.123L848.032 594.122V602.383L854.803 606.609L861.609 602.383V594.122Z"
          fill="white"
        />
        <path
          d="M357.345 607.698L350.539 603.699L343.769 607.698V615.96L350.539 620.185L357.345 615.96V607.698Z"
          fill="white"
        />
        <path
          d="M372.861 607.698L366.055 603.699L359.285 607.698V615.96L366.055 620.185L372.861 615.96V607.698Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M388.377 607.698L381.571 603.699L374.8 607.698V615.96L381.571 620.185L388.377 615.96V607.698Z"
          fill="#8676FF"
        />
        <path
          d="M403.893 607.698L397.087 603.699L390.316 607.698V615.96L397.087 620.185L403.893 615.96V607.698Z"
          fill="white"
        />
        <path
          d="M419.408 607.698L412.602 603.699L405.832 607.698V615.96L412.602 620.185L419.408 615.96V607.698Z"
          fill="white"
        />
        <path
          d="M434.924 607.698L428.118 603.699L421.348 607.698V615.96L428.118 620.185L434.924 615.96V607.698Z"
          fill="white"
        />
        <path
          d="M450.44 607.698L443.634 603.699L436.864 607.698V615.96L443.634 620.185L450.44 615.96V607.698Z"
          fill="white"
        />
        <path
          d="M465.955 607.698L459.149 603.699L452.379 607.698V615.96L459.149 620.185L465.955 615.96V607.698Z"
          fill="white"
        />
        <path
          d="M481.472 607.698L474.666 603.699L467.895 607.698V615.96L474.666 620.185L481.472 615.96V607.698Z"
          fill="white"
        />
        <path
          d="M745.24 607.698L738.433 603.699L731.663 607.698V615.96L738.433 620.185L745.24 615.96V607.698Z"
          fill="white"
        />
        <path
          d="M760.756 607.698L753.95 603.699L747.179 607.698V615.96L753.95 620.185L760.756 615.96V607.698Z"
          fill="white"
        />
        <path
          d="M776.272 607.698L769.466 603.699L762.696 607.698V615.96L769.466 620.185L776.272 615.96V607.698Z"
          fill="white"
        />
        <path
          d="M791.788 607.698L784.982 603.699L778.212 607.698V615.96L784.982 620.185L791.788 615.96V607.698Z"
          fill="white"
        />
        <path
          d="M807.303 607.698L800.497 603.699L793.727 607.698V615.96L800.497 620.185L807.303 615.96V607.698Z"
          fill="white"
        />
        <path
          d="M822.818 607.698L816.012 603.699L809.242 607.698V615.96L816.012 620.185L822.818 615.96V607.698Z"
          fill="white"
        />
        <path
          d="M838.336 607.698L831.53 603.699L824.759 607.698V615.96L831.53 620.185L838.336 615.96V607.698Z"
          fill="white"
        />
        <path
          d="M853.851 607.698L847.045 603.699L840.274 607.698V615.96L847.045 620.185L853.851 615.96V607.698Z"
          fill="white"
        />
        <path
          d="M349.587 621.275L342.781 617.276L336.011 621.275V629.537L342.781 633.762L349.587 629.537V621.275Z"
          fill="white"
        />
        <path
          d="M365.103 621.275L358.297 617.276L351.527 621.275V629.537L358.297 633.762L365.103 629.537V621.275Z"
          fill="white"
        />
        <path
          d="M380.619 621.275L373.812 617.276L367.042 621.275V629.537L373.812 633.762L380.619 629.537V621.275Z"
          fill="white"
        />
        <path
          d="M396.135 621.275L389.329 617.276L382.558 621.275V629.537L389.329 633.762L396.135 629.537V621.275Z"
          fill="white"
        />
        <path
          d="M411.65 621.275L404.844 617.276L398.073 621.275V629.537L404.844 633.762L411.65 629.537V621.275Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M427.166 621.275L420.36 617.276L413.59 621.275V629.537L420.36 633.762L427.166 629.537V621.275Z"
          fill="#8676FF"
        />
        <path
          d="M442.682 621.275L435.876 617.276L429.106 621.275V629.537L435.876 633.762L442.682 629.537V621.275Z"
          fill="white"
        />
        <path
          d="M458.197 621.275L451.391 617.276L444.621 621.275V629.537L451.391 633.762L458.197 629.537V621.275Z"
          fill="white"
        />
        <path
          d="M473.714 621.275L466.907 617.276L460.137 621.275V629.537L466.907 633.762L473.714 629.537V621.275Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M489.23 621.275L482.424 617.276L475.653 621.275V629.537L482.424 633.762L489.23 629.537V621.275Z"
          fill="#8676FF"
        />
        <path
          d="M752.998 621.275L746.192 617.276L739.421 621.275V629.537L746.192 633.762L752.998 629.537V621.275Z"
          fill="white"
        />
        <path
          d="M768.514 621.275L761.708 617.276L754.938 621.275V629.537L761.708 633.762L768.514 629.537V621.275Z"
          fill="white"
        />
        <path
          d="M784.03 621.275L777.224 617.276L770.454 621.275V629.537L777.224 633.762L784.03 629.537V621.275Z"
          fill="white"
        />
        <path
          d="M799.545 621.275L792.739 617.276L785.969 621.275V629.537L792.739 633.762L799.545 629.537V621.275Z"
          fill="white"
        />
        <path
          d="M815.061 621.275L808.255 617.276L801.485 621.275V629.537L808.255 633.762L815.061 629.537V621.275Z"
          fill="white"
        />
        <path
          d="M830.577 621.275L823.77 617.276L817 621.275V629.537L823.77 633.762L830.577 629.537V621.275Z"
          fill="white"
        />
        <path
          d="M846.093 621.275L839.287 617.276L832.516 621.275V629.537L839.287 633.762L846.093 629.537V621.275Z"
          fill="white"
        />
        <path
          d="M357.345 634.851L350.539 630.853L343.769 634.851V643.113L350.539 647.338L357.345 643.113V634.851Z"
          fill="white"
        />
        <path
          d="M372.861 634.851L366.055 630.853L359.285 634.851V643.113L366.055 647.338L372.861 643.113V634.851Z"
          fill="white"
        />
        <path
          d="M388.377 634.851L381.571 630.853L374.8 634.851V643.113L381.571 647.338L388.377 643.113V634.851Z"
          fill="white"
        />
        <path
          d="M403.893 634.851L397.087 630.853L390.316 634.851V643.113L397.087 647.338L403.893 643.113V634.851Z"
          fill="white"
        />
        <path
          d="M419.408 634.851L412.602 630.853L405.832 634.851V643.113L412.602 647.338L419.408 643.113V634.851Z"
          fill="white"
        />
        <path
          d="M434.924 634.851L428.118 630.853L421.348 634.851V643.113L428.118 647.338L434.924 643.113V634.851Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M450.44 634.851L443.634 630.853L436.864 634.851V643.113L443.634 647.338L450.44 643.113V634.851Z"
          fill="#8676FF"
        />
        <path
          d="M760.756 634.851L753.95 630.853L747.179 634.851V643.113L753.95 647.338L760.756 643.113V634.851Z"
          fill="white"
        />
        <path
          d="M776.272 634.851L769.466 630.853L762.696 634.851V643.113L769.466 647.338L776.272 643.113V634.851Z"
          fill="white"
        />
        <path
          d="M791.788 634.851L784.982 630.853L778.212 634.851V643.113L784.982 647.338L791.788 643.113V634.851Z"
          fill="white"
        />
        <path
          d="M807.303 634.851L800.497 630.853L793.727 634.851V643.113L800.497 647.338L807.303 643.113V634.851Z"
          fill="white"
        />
        <path
          d="M822.818 634.851L816.012 630.853L809.242 634.851V643.113L816.012 647.338L822.818 643.113V634.851Z"
          fill="white"
        />
        <path
          d="M838.336 634.851L831.53 630.853L824.759 634.851V643.113L831.53 647.338L838.336 643.113V634.851Z"
          fill="white"
        />
        <path
          d="M853.851 634.851L847.045 630.853L840.274 634.851V643.113L847.045 647.338L853.851 643.113V634.851Z"
          fill="white"
        />
        <path
          d="M349.587 648.427L342.781 644.428L336.011 648.427V656.688L342.781 660.913L349.587 656.688V648.427Z"
          fill="white"
        />
        <path
          d="M365.103 648.427L358.297 644.428L351.527 648.427V656.688L358.297 660.913L365.103 656.688V648.427Z"
          fill="white"
        />
        <path
          d="M380.619 648.427L373.812 644.428L367.042 648.427V656.688L373.812 660.913L380.619 656.688V648.427Z"
          fill="white"
        />
        <path
          d="M396.135 648.427L389.329 644.428L382.558 648.427V656.688L389.329 660.913L396.135 656.688V648.427Z"
          fill="white"
        />
        <path
          d="M411.65 648.427L404.844 644.428L398.073 648.427V656.688L404.844 660.913L411.65 656.688V648.427Z"
          fill="white"
        />
        <path
          d="M427.166 648.427L420.36 644.428L413.59 648.427V656.688L420.36 660.913L427.166 656.688V648.427Z"
          fill="white"
        />
        <path
          d="M442.682 648.427L435.876 644.428L429.106 648.427V656.688L435.876 660.913L442.682 656.688V648.427Z"
          fill="white"
        />
        <path
          d="M458.197 648.427L451.391 644.428L444.621 648.427V656.688L451.391 660.913L458.197 656.688V648.427Z"
          fill="white"
        />
        <path
          d="M768.514 648.427L761.708 644.428L754.938 648.427V656.688L761.708 660.913L768.514 656.688V648.427Z"
          fill="white"
        />
        <path
          d="M784.03 648.427L777.224 644.428L770.454 648.427V656.688L777.224 660.913L784.03 656.688V648.427Z"
          fill="white"
        />
        <path
          d="M799.545 648.427L792.739 644.428L785.969 648.427V656.688L792.739 660.913L799.545 656.688V648.427Z"
          fill="white"
        />
        <path
          d="M815.061 648.427L808.255 644.428L801.485 648.427V656.688L808.255 660.913L815.061 656.688V648.427Z"
          fill="white"
        />
        <path
          d="M830.577 648.427L823.77 644.428L817 648.427V656.688L823.77 660.913L830.577 656.688V648.427Z"
          fill="white"
        />
        <path
          d="M357.345 662.004L350.539 658.005L343.769 662.004V670.265L350.539 674.49L357.345 670.265V662.004Z"
          fill="white"
        />
        <path
          d="M372.861 662.004L366.055 658.005L359.285 662.004V670.265L366.055 674.49L372.861 670.265V662.004Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M388.377 662.004L381.571 658.005L374.8 662.004V670.265L381.571 674.49L388.377 670.265V662.004Z"
          fill="#8676FF"
        />
        <path
          d="M403.893 662.004L397.087 658.005L390.316 662.004V670.265L397.087 674.49L403.893 670.265V662.004Z"
          fill="white"
        />
        <path
          d="M419.408 662.004L412.602 658.005L405.832 662.004V670.265L412.602 674.49L419.408 670.265V662.004Z"
          fill="white"
        />
        <path
          d="M434.924 662.004L428.118 658.005L421.348 662.004V670.265L428.118 674.49L434.924 670.265V662.004Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M450.44 662.004L443.634 658.005L436.864 662.004V670.265L443.634 674.49L450.44 670.265V662.004Z"
          fill="#8676FF"
        />
        <path
          d="M776.272 662.004L769.466 658.005L762.696 662.004V670.265L769.466 674.49L776.272 670.265V662.004Z"
          fill="white"
        />
        <path
          d="M791.788 662.004L784.982 658.005L778.212 662.004V670.265L784.982 674.49L791.788 670.265V662.004Z"
          fill="white"
        />
        <path
          d="M807.303 662.004L800.497 658.005L793.727 662.004V670.265L800.497 674.49L807.303 670.265V662.004Z"
          fill="white"
        />
        <path
          d="M822.818 662.004L816.012 658.005L809.242 662.004V670.265L816.012 674.49L822.818 670.265V662.004Z"
          fill="white"
        />
        <path
          d="M365.103 675.58L358.297 671.581L351.527 675.58V683.841L358.297 688.067L365.103 683.841V675.58Z"
          fill="white"
        />
        <path
          d="M380.619 675.58L373.812 671.581L367.042 675.58V683.841L373.812 688.067L380.619 683.841V675.58Z"
          fill="white"
        />
        <path
          d="M396.135 675.58L389.329 671.581L382.558 675.58V683.841L389.329 688.067L396.135 683.841V675.58Z"
          fill="white"
        />
        <path
          d="M411.65 675.58L404.844 671.581L398.073 675.58V683.841L404.844 688.067L411.65 683.841V675.58Z"
          fill="white"
        />
        <path
          d="M427.166 675.58L420.36 671.581L413.59 675.58V683.841L420.36 688.067L427.166 683.841V675.58Z"
          fill="white"
        />
        <path
          d="M442.682 675.58L435.876 671.581L429.106 675.58V683.841L435.876 688.067L442.682 683.841V675.58Z"
          fill="white"
        />
        <path
          d="M784.03 675.58L777.224 671.581L770.454 675.58V683.841L777.224 688.067L784.03 683.841V675.58Z"
          fill="white"
        />
        <path
          d="M799.545 675.58L792.739 671.581L785.969 675.58V683.841L792.739 688.067L799.545 683.841V675.58Z"
          fill="white"
        />
        <path
          d="M815.061 675.58L808.255 671.581L801.485 675.58V683.841L808.255 688.067L815.061 683.841V675.58Z"
          fill="white"
        />
        <path
          d="M357.345 689.156L350.539 685.157L343.769 689.156V697.418L350.539 701.643L357.345 697.418V689.156Z"
          fill="white"
        />
        <path
          d="M372.861 689.156L366.055 685.157L359.285 689.156V697.418L366.055 701.643L372.861 697.418V689.156Z"
          fill="white"
        />
        <path
          d="M388.377 689.156L381.571 685.157L374.8 689.156V697.418L381.571 701.643L388.377 697.418V689.156Z"
          fill="white"
        />
        <path
          d="M403.893 689.156L397.087 685.157L390.316 689.156V697.418L397.087 701.643L403.893 697.418V689.156Z"
          fill="white"
        />
        <path
          d="M419.408 689.156L412.602 685.157L405.832 689.156V697.418L412.602 701.643L419.408 697.418V689.156Z"
          fill="white"
        />
        <path
          d="M434.924 689.156L428.118 685.157L421.348 689.156V697.418L428.118 701.643L434.924 697.418V689.156Z"
          fill="white"
        />
        <path
          d="M776.272 689.156L769.466 685.157L762.696 689.156V697.418L769.466 701.643L776.272 697.418V689.156Z"
          fill="white"
        />
        <path
          d="M791.788 689.156L784.982 685.157L778.212 689.156V697.418L784.982 701.643L791.788 697.418V689.156Z"
          fill="white"
        />
        <path
          d="M365.103 702.732L358.297 698.733L351.527 702.732V710.994L358.297 715.219L365.103 710.994V702.732Z"
          fill="white"
        />
        <path
          d="M380.619 702.732L373.812 698.733L367.042 702.732V710.994L373.812 715.219L380.619 710.994V702.732Z"
          fill="white"
        />
        <path
          d="M396.135 702.732L389.329 698.733L382.558 702.732V710.994L389.329 715.219L396.135 710.994V702.732Z"
          fill="white"
        />
        <path
          d="M411.65 702.732L404.844 698.733L398.073 702.732V710.994L404.844 715.219L411.65 710.994V702.732Z"
          fill="white"
        />
        <path
          d="M427.166 702.732L420.36 698.733L413.59 702.732V710.994L420.36 715.219L427.166 710.994V702.732Z"
          fill="white"
        />
        <path
          d="M357.345 716.309L350.539 712.311L343.769 716.309V724.571L350.539 728.796L357.345 724.571V716.309Z"
          fill="white"
        />
        <path
          d="M372.861 716.309L366.055 712.311L359.285 716.309V724.571L366.055 728.796L372.861 724.571V716.309Z"
          fill="white"
        />
        <path
          d="M388.377 716.309L381.571 712.311L374.8 716.309V724.571L381.571 728.796L388.377 724.571V716.309Z"
          fill="white"
        />
        <path
          d="M403.893 716.309L397.087 712.311L390.316 716.309V724.571L397.087 728.796L403.893 724.571V716.309Z"
          fill="white"
        />
        <path
          d="M419.408 716.309L412.602 712.311L405.832 716.309V724.571L412.602 728.796L419.408 724.571V716.309Z"
          fill="white"
        />
        <path
          d="M365.103 729.885L358.297 725.887L351.527 729.885V738.147L358.297 742.372L365.103 738.147V729.885Z"
          fill="white"
        />
        <path
          d="M380.619 729.885L373.812 725.887L367.042 729.885V738.147L373.812 742.372L380.619 738.147V729.885Z"
          fill="white"
        />
        <path
          d="M396.135 729.885L389.329 725.887L382.558 729.885V738.147L389.329 742.372L396.135 738.147V729.885Z"
          fill="white"
        />
        <path
          d="M372.861 743.462L366.055 739.463L359.285 743.462V751.723L366.055 755.948L372.861 751.723V743.462Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M388.377 743.462L381.571 739.463L374.8 743.462V751.723L381.571 755.948L388.377 751.723V743.462Z"
          fill="#8676FF"
        />
        <path
          d="M403.893 743.462L397.087 739.463L390.316 743.462V751.723L397.087 755.948L403.893 751.723V743.462Z"
          fill="white"
        />
        <path
          d="M885.074 471.934L878.268 467.936L871.497 471.934V480.196L878.268 484.421L885.074 480.196V471.934Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M900.59 471.934L893.784 467.936L887.013 471.934V480.196L893.784 484.421L900.59 480.196V471.934Z"
          fill="#8676FF"
        />
        <path
          d="M916.105 471.934L909.299 467.936L902.529 471.934V480.196L909.299 484.421L916.105 480.196V471.934Z"
          fill="white"
        />
        <path
          d="M877.317 485.51L870.51 481.512L863.74 485.51V493.772L870.51 497.997L877.317 493.772V485.51Z"
          fill="white"
        />
        <path
          d="M892.832 485.51L886.026 481.512L879.255 485.51V493.772L886.026 497.997L892.832 493.772V485.51Z"
          fill="white"
        />
        <path
          d="M908.347 485.51L901.541 481.512L894.771 485.51V493.772L901.541 497.997L908.347 493.772V485.51Z"
          fill="white"
        />
        <path
          d="M885.074 499.087L878.268 495.088L871.497 499.087V507.348L878.268 511.573L885.074 507.348V499.087Z"
          fill="white"
        />
        <path
          d="M877.317 512.664L870.51 508.665L863.74 512.664V520.925L870.51 525.151L877.317 520.925V512.664Z"
          fill="white"
        />
        <path
          d="M877.317 566.969L870.51 562.971L863.74 566.969V575.231L870.51 579.456L877.317 575.231V566.969Z"
          fill="white"
        />
        <path
          d="M916.105 580.546L909.299 576.547L902.529 580.546V588.807L909.299 593.032L916.105 588.807V580.546Z"
          fill="white"
        />
        <path
          d="M931.622 580.546L924.816 576.547L918.046 580.546V588.807L924.816 593.032L931.622 588.807V580.546Z"
          fill="white"
        />
        <path
          d="M908.347 594.122L901.541 590.123L894.771 594.122V602.383L901.541 606.609L908.347 602.383V594.122Z"
          fill="white"
        />
        <path
          d="M923.863 594.122L917.057 590.123L910.287 594.122V602.383L917.057 606.609L923.863 602.383V594.122Z"
          fill="white"
        />
        <path
          d="M900.59 607.698L893.784 603.699L887.013 607.698V615.96L893.784 620.185L900.59 615.96V607.698Z"
          fill="white"
        />
        <path
          d="M916.105 607.698L909.299 603.699L902.529 607.698V615.96L909.299 620.185L916.105 615.96V607.698Z"
          fill="white"
        />
        <path
          d="M908.347 621.275L901.541 617.276L894.771 621.275V629.537L901.541 633.762L908.347 629.537V621.275Z"
          fill="white"
        />
        <path
          d="M900.59 634.851L893.784 630.853L887.013 634.851V643.113L893.784 647.338L900.59 643.113V634.851Z"
          fill="white"
        />
        <path
          d="M918.726 4.29354L911.419 0L904.149 4.29354V13.1642L911.419 17.7007L918.726 13.1642V4.29354Z"
          fill="white"
        />
        <path
          d="M935.386 4.29354L928.078 0L920.809 4.29354V13.1642L928.078 17.7007L935.386 13.1642V4.29354Z"
          fill="white"
        />
        <path
          d="M1101.98 4.29354L1094.67 0L1087.4 4.29354V13.1642L1094.67 17.7007L1101.98 13.1642V4.29354Z"
          fill="white"
        />
        <path
          d="M1118.64 4.29354L1111.33 0L1104.06 4.29354V13.1642L1111.33 17.7007L1118.64 13.1642V4.29354Z"
          fill="white"
        />
        <path
          d="M1135.3 4.29354L1127.99 0L1120.72 4.29354V13.1642L1127.99 17.7007L1135.3 13.1642V4.29354Z"
          fill="white"
        />
        <path
          d="M1025.35 36.2585L1018.54 32.2598L1011.77 36.2585V44.5202L1018.54 48.7453L1025.35 44.5202V36.2585Z"
          fill="white"
        />
        <path
          d="M1164.99 36.2585L1158.18 32.2598L1151.41 36.2585V44.5202L1158.18 48.7453L1164.99 44.5202V36.2585Z"
          fill="white"
        />
        <path
          d="M1180.5 36.2585L1173.7 32.2598L1166.93 36.2585V44.5202L1173.7 48.7453L1180.5 44.5202V36.2585Z"
          fill="white"
        />
        <path
          d="M1196.02 36.2585L1189.21 32.2598L1182.44 36.2585V44.5202L1189.21 48.7453L1196.02 44.5202V36.2585Z"
          fill="white"
        />
        <path
          d="M1211.54 36.2585L1204.73 32.2598L1197.96 36.2585V44.5202L1204.73 48.7453L1211.54 44.5202V36.2585Z"
          fill="white"
        />
        <path
          d="M1017.59 49.8347L1010.78 45.8359L1004.01 49.8347V58.0964L1010.78 62.3215L1017.59 58.0964V49.8347Z"
          fill="white"
        />
        <path
          d="M1033.1 49.8347L1026.3 45.8359L1019.53 49.8347V58.0964L1026.3 62.3215L1033.1 58.0964V49.8347Z"
          fill="white"
        />
        <path
          d="M1048.62 49.8347L1041.81 45.8359L1035.04 49.8347V58.0964L1041.81 62.3215L1048.62 58.0964V49.8347Z"
          fill="white"
        />
        <path
          d="M1064.14 49.8347L1057.33 45.8359L1050.56 49.8347V58.0964L1057.33 62.3215L1064.14 58.0964V49.8347Z"
          fill="white"
        />
        <path
          d="M1009.83 63.4119L1003.03 59.4131L996.255 63.4119V71.6735L1003.03 75.8986L1009.83 71.6735V63.4119Z"
          fill="white"
        />
        <path
          d="M1025.35 63.4119L1018.54 59.4131L1011.77 63.4119V71.6735L1018.54 75.8986L1025.35 71.6735V63.4119Z"
          fill="white"
        />
        <path
          d="M1040.86 63.4119L1034.06 59.4131L1027.29 63.4119V71.6735L1034.06 75.8986L1040.86 71.6735V63.4119Z"
          fill="white"
        />
        <path
          d="M1056.38 63.4119L1049.57 59.4131L1042.8 63.4119V71.6735L1049.57 75.8986L1056.38 71.6735V63.4119Z"
          fill="white"
        />
        <path
          d="M1071.89 63.4119L1065.09 59.4131L1058.32 63.4119V71.6735L1065.09 75.8986L1071.89 71.6735V63.4119Z"
          fill="white"
        />
        <path
          d="M1002.07 76.988L995.267 72.9893L988.497 76.988V85.2497L995.267 89.4748L1002.07 85.2497V76.988Z"
          fill="white"
        />
        <path
          d="M1017.59 76.988L1010.78 72.9893L1004.01 76.988V85.2497L1010.78 89.4748L1017.59 85.2497V76.988Z"
          fill="white"
        />
        <path
          d="M1033.1 76.988L1026.3 72.9893L1019.53 76.988V85.2497L1026.3 89.4748L1033.1 85.2497V76.988Z"
          fill="white"
        />
        <path
          d="M1048.62 76.988L1041.81 72.9893L1035.04 76.988V85.2497L1041.81 89.4748L1048.62 85.2497V76.988Z"
          fill="white"
        />
        <path
          d="M1064.14 76.988L1057.33 72.9893L1050.56 76.988V85.2497L1057.33 89.4748L1064.14 85.2497V76.988Z"
          fill="white"
        />
        <path
          d="M1079.65 76.988L1072.85 72.9893L1066.08 76.988V85.2497L1072.85 89.4748L1079.65 85.2497V76.988Z"
          fill="white"
        />
        <path
          d="M1095.17 76.988L1088.36 72.9893L1081.59 76.988V85.2497L1088.36 89.4748L1095.17 85.2497V76.988Z"
          fill="white"
        />
        <path
          d="M1110.68 76.988L1103.88 72.9893L1097.11 76.988V85.2497L1103.88 89.4748L1110.68 85.2497V76.988Z"
          fill="white"
        />
        <path
          d="M1126.2 76.988L1119.39 72.9893L1112.62 76.988V85.2497L1119.39 89.4748L1126.2 85.2497V76.988Z"
          fill="white"
        />
        <path
          d="M1141.71 76.988L1134.91 72.9893L1128.14 76.988V85.2497L1134.91 89.4748L1141.71 85.2497V76.988Z"
          fill="white"
        />
        <path
          d="M1157.23 76.988L1150.42 72.9893L1143.65 76.988V85.2497L1150.42 89.4748L1157.23 85.2497V76.988Z"
          fill="white"
        />
        <path
          d="M1172.75 76.988L1165.94 72.9893L1159.17 76.988V85.2497L1165.94 89.4748L1172.75 85.2497V76.988Z"
          fill="white"
        />
        <path
          d="M1188.26 76.988L1181.46 72.9893L1174.69 76.988V85.2497L1181.46 89.4748L1188.26 85.2497V76.988Z"
          fill="white"
        />
        <path
          d="M1203.78 76.988L1196.97 72.9893L1190.2 76.988V85.2497L1196.97 89.4748L1203.78 85.2497V76.988Z"
          fill="white"
        />
        <path
          d="M1009.83 90.5642L1003.03 86.5654L996.255 90.5642V98.8258L1003.03 103.051L1009.83 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1025.35 90.5642L1018.54 86.5654L1011.77 90.5642V98.8258L1018.54 103.051L1025.35 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1040.86 90.5642L1034.06 86.5654L1027.29 90.5642V98.8258L1034.06 103.051L1040.86 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1056.38 90.5642L1049.57 86.5654L1042.8 90.5642V98.8258L1049.57 103.051L1056.38 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1071.89 90.5642L1065.09 86.5654L1058.32 90.5642V98.8258L1065.09 103.051L1071.89 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1087.41 90.5642L1080.6 86.5654L1073.83 90.5642V98.8258L1080.6 103.051L1087.41 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1102.93 90.5642L1096.12 86.5654L1089.35 90.5642V98.8258L1096.12 103.051L1102.93 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1118.44 90.5642L1111.64 86.5654L1104.87 90.5642V98.8258L1111.64 103.051L1118.44 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1133.96 90.5642L1127.15 86.5654L1120.38 90.5642V98.8258L1127.15 103.051L1133.96 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1149.47 90.5642L1142.67 86.5654L1135.9 90.5642V98.8258L1142.67 103.051L1149.47 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1164.99 90.5642L1158.18 86.5654L1151.41 90.5642V98.8258L1158.18 103.051L1164.99 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1180.5 90.5642L1173.7 86.5654L1166.93 90.5642V98.8258L1173.7 103.051L1180.5 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1196.02 90.5642L1189.21 86.5654L1182.44 90.5642V98.8258L1189.21 103.051L1196.02 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1211.54 90.5642L1204.73 86.5654L1197.96 90.5642V98.8258L1204.73 103.051L1211.54 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1227.05 90.5642L1220.25 86.5654L1213.48 90.5642V98.8258L1220.25 103.051L1227.05 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1242.57 90.5642L1235.76 86.5654L1228.99 90.5642V98.8258L1235.76 103.051L1242.57 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1258.08 90.5642L1251.28 86.5654L1244.51 90.5642V98.8258L1251.28 103.051L1258.08 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1273.6 90.5642L1266.79 86.5654L1260.02 90.5642V98.8258L1266.79 103.051L1273.6 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1289.12 90.5642L1282.31 86.5654L1275.54 90.5642V98.8258L1282.31 103.051L1289.12 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1304.63 90.5642L1297.83 86.5654L1291.06 90.5642V98.8258L1297.83 103.051L1304.63 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1320.15 90.5642L1313.34 86.5654L1306.57 90.5642V98.8258L1313.34 103.051L1320.15 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1335.66 90.5642L1328.86 86.5654L1322.09 90.5642V98.8258L1328.86 103.051L1335.66 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1351.18 90.5642L1344.37 86.5654L1337.6 90.5642V98.8258L1344.37 103.051L1351.18 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1366.69 90.5642L1359.89 86.5654L1353.12 90.5642V98.8258L1359.89 103.051L1366.69 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1382.21 90.5642L1375.4 86.5654L1368.63 90.5642V98.8258L1375.4 103.051L1382.21 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1397.73 90.5642L1390.92 86.5654L1384.15 90.5642V98.8258L1390.92 103.051L1397.73 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1413.24 90.5642L1406.44 86.5654L1399.67 90.5642V98.8258L1406.44 103.051L1413.24 98.8258V90.5642Z"
          fill="white"
        />
        <path
          d="M1002.07 104.14L995.267 100.142L988.497 104.14V112.402L995.267 116.627L1002.07 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1017.59 104.14L1010.78 100.142L1004.01 104.14V112.402L1010.78 116.627L1017.59 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1033.1 104.14L1026.3 100.142L1019.53 104.14V112.402L1026.3 116.627L1033.1 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1048.62 104.14L1041.81 100.142L1035.04 104.14V112.402L1041.81 116.627L1048.62 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1064.14 104.14L1057.33 100.142L1050.56 104.14V112.402L1057.33 116.627L1064.14 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1079.65 104.14L1072.85 100.142L1066.08 104.14V112.402L1072.85 116.627L1079.65 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1095.17 104.14L1088.36 100.142L1081.59 104.14V112.402L1088.36 116.627L1095.17 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1110.68 104.14L1103.88 100.142L1097.11 104.14V112.402L1103.88 116.627L1110.68 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1126.2 104.14L1119.39 100.142L1112.62 104.14V112.402L1119.39 116.627L1126.2 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1141.71 104.14L1134.91 100.142L1128.14 104.14V112.402L1134.91 116.627L1141.71 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1157.23 104.14L1150.42 100.142L1143.65 104.14V112.402L1150.42 116.627L1157.23 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1172.75 104.14L1165.94 100.142L1159.17 104.14V112.402L1165.94 116.627L1172.75 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1188.26 104.14L1181.46 100.142L1174.69 104.14V112.402L1181.46 116.627L1188.26 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1203.78 104.14L1196.97 100.142L1190.2 104.14V112.402L1196.97 116.627L1203.78 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1219.29 104.14L1212.49 100.142L1205.72 104.14V112.402L1212.49 116.627L1219.29 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1234.81 104.14L1228 100.142L1221.23 104.14V112.402L1228 116.627L1234.81 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1250.33 104.14L1243.52 100.142L1236.75 104.14V112.402L1243.52 116.627L1250.33 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1265.84 104.14L1259.04 100.142L1252.27 104.14V112.402L1259.04 116.627L1265.84 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1281.36 104.14L1274.55 100.142L1267.78 104.14V112.402L1274.55 116.627L1281.36 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1296.87 104.14L1290.07 100.142L1283.3 104.14V112.402L1290.07 116.627L1296.87 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1312.39 104.14L1305.58 100.142L1298.81 104.14V112.402L1305.58 116.627L1312.39 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1327.9 104.14L1321.1 100.142L1314.33 104.14V112.402L1321.1 116.627L1327.9 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1343.42 104.14L1336.61 100.142L1329.84 104.14V112.402L1336.61 116.627L1343.42 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1358.94 104.14L1352.13 100.142L1345.36 104.14V112.402L1352.13 116.627L1358.94 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1374.45 104.14L1367.65 100.142L1360.88 104.14V112.402L1367.65 116.627L1374.45 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1389.97 104.14L1383.16 100.142L1376.39 104.14V112.402L1383.16 116.627L1389.97 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1405.48 104.14L1398.68 100.142L1391.91 104.14V112.402L1398.68 116.627L1405.48 112.402V104.14Z"
          fill="white"
        />
        <path
          d="M1009.83 117.718L1003.03 113.719L996.255 117.718V125.979L1003.03 130.204L1009.83 125.979V117.718Z"
          fill="white"
        />
        <path
          d="M1025.35 117.718L1018.54 113.719L1011.77 117.718V125.979L1018.54 130.204L1025.35 125.979V117.718Z"
          fill="white"
        />
        <path
          d="M1040.86 117.718L1034.06 113.719L1027.29 117.718V125.979L1034.06 130.204L1040.86 125.979V117.718Z"
          fill="white"
        />
        <path
          d="M1056.38 117.718L1049.57 113.719L1042.8 117.718V125.979L1049.57 130.204L1056.38 125.979V117.718Z"
          fill="white"
        />
        <path
          d="M1071.89 117.718L1065.09 113.719L1058.32 117.718V125.979L1065.09 130.204L1071.89 125.979V117.718Z"
          fill="white"
        />
        <path
          d="M1087.41 117.718L1080.6 113.719L1073.83 117.718V125.979L1080.6 130.204L1087.41 125.979V117.718Z"
          fill="white"
        />
        <path
          d="M1102.93 117.718L1096.12 113.719L1089.35 117.718V125.979L1096.12 130.204L1102.93 125.979V117.718Z"
          fill="white"
        />
        <path
          d="M1118.44 117.718L1111.64 113.719L1104.87 117.718V125.979L1111.64 130.204L1118.44 125.979V117.718Z"
          fill="white"
        />
        <path
          d="M1133.96 117.718L1127.15 113.719L1120.38 117.718V125.979L1127.15 130.204L1133.96 125.979V117.718Z"
          fill="white"
        />
        <path
          d="M1149.47 117.718L1142.67 113.719L1135.9 117.718V125.979L1142.67 130.204L1149.47 125.979V117.718Z"
          fill="white"
        />
        <path
          d="M1164.99 117.718L1158.18 113.719L1151.41 117.718V125.979L1158.18 130.204L1164.99 125.979V117.718Z"
          fill="white"
        />
        <path
          d="M1180.5 117.718L1173.7 113.719L1166.93 117.718V125.979L1173.7 130.204L1180.5 125.979V117.718Z"
          fill="white"
        />
        <path
          d="M1196.02 117.718L1189.21 113.719L1182.44 117.718V125.979L1189.21 130.204L1196.02 125.979V117.718Z"
          fill="white"
        />
        <path
          d="M1211.54 117.718L1204.73 113.719L1197.96 117.718V125.979L1204.73 130.204L1211.54 125.979V117.718Z"
          fill="white"
        />
        <path
          d="M1227.05 117.718L1220.25 113.719L1213.48 117.718V125.979L1220.25 130.204L1227.05 125.979V117.718Z"
          fill="white"
        />
        <path
          d="M1242.57 117.718L1235.76 113.719L1228.99 117.718V125.979L1235.76 130.204L1242.57 125.979V117.718Z"
          fill="white"
        />
        <path
          d="M1258.08 117.718L1251.28 113.719L1244.51 117.718V125.979L1251.28 130.204L1258.08 125.979V117.718Z"
          fill="white"
        />
        <path
          d="M1273.6 117.718L1266.79 113.719L1260.02 117.718V125.979L1266.79 130.204L1273.6 125.979V117.718Z"
          fill="white"
        />
        <path
          d="M1289.12 117.718L1282.31 113.719L1275.54 117.718V125.979L1282.31 130.204L1289.12 125.979V117.718Z"
          fill="white"
        />
        <path
          d="M1304.63 117.718L1297.83 113.719L1291.06 117.718V125.979L1297.83 130.204L1304.63 125.979V117.718Z"
          fill="white"
        />
        <path
          d="M1320.15 117.718L1313.34 113.719L1306.57 117.718V125.979L1313.34 130.204L1320.15 125.979V117.718Z"
          fill="white"
        />
        <path
          d="M1335.66 117.718L1328.86 113.719L1322.09 117.718V125.979L1328.86 130.204L1335.66 125.979V117.718Z"
          fill="white"
        />
        <path
          d="M1351.18 117.718L1344.37 113.719L1337.6 117.718V125.979L1344.37 130.204L1351.18 125.979V117.718Z"
          fill="white"
        />
        <path
          d="M1366.69 117.718L1359.89 113.719L1353.12 117.718V125.979L1359.89 130.204L1366.69 125.979V117.718Z"
          fill="white"
        />
        <path
          d="M1397.73 117.718L1390.92 113.719L1384.15 117.718V125.979L1390.92 130.204L1397.73 125.979V117.718Z"
          fill="white"
        />
        <path
          d="M1002.07 131.294L995.267 127.295L988.497 131.294V139.555L995.267 143.78L1002.07 139.555V131.294Z"
          fill="white"
        />
        <path
          d="M1017.59 131.294L1010.78 127.295L1004.01 131.294V139.555L1010.78 143.78L1017.59 139.555V131.294Z"
          fill="white"
        />
        <path
          d="M1033.1 131.294L1026.3 127.295L1019.53 131.294V139.555L1026.3 143.78L1033.1 139.555V131.294Z"
          fill="white"
        />
        <path
          d="M1048.62 131.294L1041.81 127.295L1035.04 131.294V139.555L1041.81 143.78L1048.62 139.555V131.294Z"
          fill="white"
        />
        <path
          d="M1064.14 131.294L1057.33 127.295L1050.56 131.294V139.555L1057.33 143.78L1064.14 139.555V131.294Z"
          fill="white"
        />
        <path
          d="M1079.65 131.294L1072.85 127.295L1066.08 131.294V139.555L1072.85 143.78L1079.65 139.555V131.294Z"
          fill="white"
        />
        <path
          d="M1095.17 131.294L1088.36 127.295L1081.59 131.294V139.555L1088.36 143.78L1095.17 139.555V131.294Z"
          fill="white"
        />
        <path
          d="M1110.68 131.294L1103.88 127.295L1097.11 131.294V139.555L1103.88 143.78L1110.68 139.555V131.294Z"
          fill="white"
        />
        <path
          d="M1126.2 131.294L1119.39 127.295L1112.62 131.294V139.555L1119.39 143.78L1126.2 139.555V131.294Z"
          fill="white"
        />
        <path
          d="M1141.71 131.294L1134.91 127.295L1128.14 131.294V139.555L1134.91 143.78L1141.71 139.555V131.294Z"
          fill="white"
        />
        <path
          d="M1157.23 131.294L1150.42 127.295L1143.65 131.294V139.555L1150.42 143.78L1157.23 139.555V131.294Z"
          fill="white"
        />
        <path
          d="M1172.75 131.294L1165.94 127.295L1159.17 131.294V139.555L1165.94 143.78L1172.75 139.555V131.294Z"
          fill="white"
        />
        <path
          d="M1188.26 131.294L1181.46 127.295L1174.69 131.294V139.555L1181.46 143.78L1188.26 139.555V131.294Z"
          fill="white"
        />
        <path
          d="M1203.78 131.294L1196.97 127.295L1190.2 131.294V139.555L1196.97 143.78L1203.78 139.555V131.294Z"
          fill="white"
        />
        <path
          d="M1219.29 131.294L1212.49 127.295L1205.72 131.294V139.555L1212.49 143.78L1219.29 139.555V131.294Z"
          fill="white"
        />
        <path
          d="M1234.81 131.294L1228 127.295L1221.23 131.294V139.555L1228 143.78L1234.81 139.555V131.294Z"
          fill="white"
        />
        <path
          d="M1250.33 131.294L1243.52 127.295L1236.75 131.294V139.555L1243.52 143.78L1250.33 139.555V131.294Z"
          fill="white"
        />
        <path
          d="M1265.84 131.294L1259.04 127.295L1252.27 131.294V139.555L1259.04 143.78L1265.84 139.555V131.294Z"
          fill="white"
        />
        <path
          d="M1281.36 131.294L1274.55 127.295L1267.78 131.294V139.555L1274.55 143.78L1281.36 139.555V131.294Z"
          fill="white"
        />
        <path
          d="M1296.87 131.294L1290.07 127.295L1283.3 131.294V139.555L1290.07 143.78L1296.87 139.555V131.294Z"
          fill="white"
        />
        <path
          d="M1312.39 131.294L1305.58 127.295L1298.81 131.294V139.555L1305.58 143.78L1312.39 139.555V131.294Z"
          fill="white"
        />
        <path
          d="M1327.9 131.294L1321.1 127.295L1314.33 131.294V139.555L1321.1 143.78L1327.9 139.555V131.294Z"
          fill="white"
        />
        <path
          d="M1343.42 131.294L1336.61 127.295L1329.84 131.294V139.555L1336.61 143.78L1343.42 139.555V131.294Z"
          fill="white"
        />
        <path
          d="M1358.94 131.294L1352.13 127.295L1345.36 131.294V139.555L1352.13 143.78L1358.94 139.555V131.294Z"
          fill="white"
        />
        <path
          d="M1374.45 131.294L1367.65 127.295L1360.88 131.294V139.555L1367.65 143.78L1374.45 139.555V131.294Z"
          fill="white"
        />
        <path
          d="M1009.83 144.869L1003.03 140.87L996.255 144.869V153.131L1003.03 157.356L1009.83 153.131V144.869Z"
          fill="white"
        />
        <path
          d="M1025.35 144.869L1018.54 140.87L1011.77 144.869V153.131L1018.54 157.356L1025.35 153.131V144.869Z"
          fill="white"
        />
        <path
          d="M1040.86 144.869L1034.06 140.87L1027.29 144.869V153.131L1034.06 157.356L1040.86 153.131V144.869Z"
          fill="white"
        />
        <path
          d="M1056.38 144.869L1049.57 140.87L1042.8 144.869V153.131L1049.57 157.356L1056.38 153.131V144.869Z"
          fill="white"
        />
        <path
          d="M1071.89 144.869L1065.09 140.87L1058.32 144.869V153.131L1065.09 157.356L1071.89 153.131V144.869Z"
          fill="white"
        />
        <path
          d="M1087.41 144.869L1080.6 140.87L1073.83 144.869V153.131L1080.6 157.356L1087.41 153.131V144.869Z"
          fill="white"
        />
        <path
          d="M1102.93 144.869L1096.12 140.87L1089.35 144.869V153.131L1096.12 157.356L1102.93 153.131V144.869Z"
          fill="white"
        />
        <path
          d="M1118.44 144.869L1111.64 140.87L1104.87 144.869V153.131L1111.64 157.356L1118.44 153.131V144.869Z"
          fill="white"
        />
        <path
          d="M1133.96 144.869L1127.15 140.87L1120.38 144.869V153.131L1127.15 157.356L1133.96 153.131V144.869Z"
          fill="white"
        />
        <path
          d="M1149.47 144.869L1142.67 140.87L1135.9 144.869V153.131L1142.67 157.356L1149.47 153.131V144.869Z"
          fill="white"
        />
        <path
          d="M1164.99 144.869L1158.18 140.87L1151.41 144.869V153.131L1158.18 157.356L1164.99 153.131V144.869Z"
          fill="white"
        />
        <path
          d="M1180.5 144.869L1173.7 140.87L1166.93 144.869V153.131L1173.7 157.356L1180.5 153.131V144.869Z"
          fill="white"
        />
        <path
          d="M1196.02 144.869L1189.21 140.87L1182.44 144.869V153.131L1189.21 157.356L1196.02 153.131V144.869Z"
          fill="white"
        />
        <path
          d="M1211.54 144.869L1204.73 140.87L1197.96 144.869V153.131L1204.73 157.356L1211.54 153.131V144.869Z"
          fill="white"
        />
        <path
          d="M1227.05 144.869L1220.25 140.87L1213.48 144.869V153.131L1220.25 157.356L1227.05 153.131V144.869Z"
          fill="white"
        />
        <path
          d="M1242.57 144.869L1235.76 140.87L1228.99 144.869V153.131L1235.76 157.356L1242.57 153.131V144.869Z"
          fill="white"
        />
        <path
          d="M1258.08 144.869L1251.28 140.87L1244.51 144.869V153.131L1251.28 157.356L1258.08 153.131V144.869Z"
          fill="white"
        />
        <path
          d="M1273.6 144.869L1266.79 140.87L1260.02 144.869V153.131L1266.79 157.356L1273.6 153.131V144.869Z"
          fill="white"
        />
        <path
          d="M1289.12 144.869L1282.31 140.87L1275.54 144.869V153.131L1282.31 157.356L1289.12 153.131V144.869Z"
          fill="white"
        />
        <path
          d="M1304.63 144.869L1297.83 140.87L1291.06 144.869V153.131L1297.83 157.356L1304.63 153.131V144.869Z"
          fill="white"
        />
        <path
          d="M1320.15 144.869L1313.34 140.87L1306.57 144.869V153.131L1313.34 157.356L1320.15 153.131V144.869Z"
          fill="white"
        />
        <path
          d="M1335.66 144.869L1328.86 140.87L1322.09 144.869V153.131L1328.86 157.356L1335.66 153.131V144.869Z"
          fill="white"
        />
        <path
          d="M1351.18 144.869L1344.37 140.87L1337.6 144.869V153.131L1344.37 157.356L1351.18 153.131V144.869Z"
          fill="white"
        />
        <path
          d="M1366.69 144.869L1359.89 140.87L1353.12 144.869V153.131L1359.89 157.356L1366.69 153.131V144.869Z"
          fill="white"
        />
        <path
          d="M1002.07 158.446L995.267 154.447L988.497 158.446V166.708L995.267 170.933L1002.07 166.708V158.446Z"
          fill="white"
        />
        <path
          d="M1017.59 158.446L1010.78 154.447L1004.01 158.446V166.708L1010.78 170.933L1017.59 166.708V158.446Z"
          fill="white"
        />
        <path
          d="M1033.1 158.446L1026.3 154.447L1019.53 158.446V166.708L1026.3 170.933L1033.1 166.708V158.446Z"
          fill="white"
        />
        <path
          d="M1048.62 158.446L1041.81 154.447L1035.04 158.446V166.708L1041.81 170.933L1048.62 166.708V158.446Z"
          fill="white"
        />
        <path
          d="M1064.14 158.446L1057.33 154.447L1050.56 158.446V166.708L1057.33 170.933L1064.14 166.708V158.446Z"
          fill="white"
        />
        <path
          d="M1079.65 158.446L1072.85 154.447L1066.08 158.446V166.708L1072.85 170.933L1079.65 166.708V158.446Z"
          fill="white"
        />
        <path
          d="M1095.17 158.446L1088.36 154.447L1081.59 158.446V166.708L1088.36 170.933L1095.17 166.708V158.446Z"
          fill="white"
        />
        <path
          d="M1110.68 158.446L1103.88 154.447L1097.11 158.446V166.708L1103.88 170.933L1110.68 166.708V158.446Z"
          fill="white"
        />
        <path
          d="M1126.2 158.446L1119.39 154.447L1112.62 158.446V166.708L1119.39 170.933L1126.2 166.708V158.446Z"
          fill="white"
        />
        <path
          d="M1141.71 158.446L1134.91 154.447L1128.14 158.446V166.708L1134.91 170.933L1141.71 166.708V158.446Z"
          fill="white"
        />
        <path
          d="M1157.23 158.446L1150.42 154.447L1143.65 158.446V166.708L1150.42 170.933L1157.23 166.708V158.446Z"
          fill="white"
        />
        <path
          d="M1172.75 158.446L1165.94 154.447L1159.17 158.446V166.708L1165.94 170.933L1172.75 166.708V158.446Z"
          fill="white"
        />
        <path
          d="M1188.26 158.446L1181.46 154.447L1174.69 158.446V166.708L1181.46 170.933L1188.26 166.708V158.446Z"
          fill="white"
        />
        <path
          d="M1203.78 158.446L1196.97 154.447L1190.2 158.446V166.708L1196.97 170.933L1203.78 166.708V158.446Z"
          fill="white"
        />
        <path
          d="M1219.29 158.446L1212.49 154.447L1205.72 158.446V166.708L1212.49 170.933L1219.29 166.708V158.446Z"
          fill="white"
        />
        <path
          d="M1234.81 158.446L1228 154.447L1221.23 158.446V166.708L1228 170.933L1234.81 166.708V158.446Z"
          fill="white"
        />
        <path
          d="M1250.33 158.446L1243.52 154.447L1236.75 158.446V166.708L1243.52 170.933L1250.33 166.708V158.446Z"
          fill="white"
        />
        <path
          d="M1265.84 158.446L1259.04 154.447L1252.27 158.446V166.708L1259.04 170.933L1265.84 166.708V158.446Z"
          fill="white"
        />
        <path
          d="M1281.36 158.446L1274.55 154.447L1267.78 158.446V166.708L1274.55 170.933L1281.36 166.708V158.446Z"
          fill="white"
        />
        <path
          d="M1296.87 158.446L1290.07 154.447L1283.3 158.446V166.708L1290.07 170.933L1296.87 166.708V158.446Z"
          fill="white"
        />
        <path
          d="M1312.39 158.446L1305.58 154.447L1298.81 158.446V166.708L1305.58 170.933L1312.39 166.708V158.446Z"
          fill="white"
        />
        <path
          d="M1327.9 158.446L1321.1 154.447L1314.33 158.446V166.708L1321.1 170.933L1327.9 166.708V158.446Z"
          fill="white"
        />
        <path
          d="M1343.42 158.446L1336.61 154.447L1329.84 158.446V166.708L1336.61 170.933L1343.42 166.708V158.446Z"
          fill="white"
        />
        <path
          d="M1358.94 158.446L1352.13 154.447L1345.36 158.446V166.708L1352.13 170.933L1358.94 166.708V158.446Z"
          fill="white"
        />
        <path
          d="M1009.83 172.023L1003.03 168.024L996.255 172.023V180.285L1003.03 184.51L1009.83 180.285V172.023Z"
          fill="white"
        />
        <path
          d="M1025.35 172.023L1018.54 168.024L1011.77 172.023V180.285L1018.54 184.51L1025.35 180.285V172.023Z"
          fill="white"
        />
        <path
          d="M1056.38 172.023L1049.57 168.024L1042.8 172.023V180.285L1049.57 184.51L1056.38 180.285V172.023Z"
          fill="white"
        />
        <path
          d="M1071.89 172.023L1065.09 168.024L1058.32 172.023V180.285L1065.09 184.51L1071.89 180.285V172.023Z"
          fill="white"
        />
        <path
          d="M1087.41 172.023L1080.6 168.024L1073.83 172.023V180.285L1080.6 184.51L1087.41 180.285V172.023Z"
          fill="white"
        />
        <path
          d="M1102.93 172.023L1096.12 168.024L1089.35 172.023V180.285L1096.12 184.51L1102.93 180.285V172.023Z"
          fill="white"
        />
        <path
          d="M1118.44 172.023L1111.64 168.024L1104.87 172.023V180.285L1111.64 184.51L1118.44 180.285V172.023Z"
          fill="white"
        />
        <path
          d="M1133.96 172.023L1127.15 168.024L1120.38 172.023V180.285L1127.15 184.51L1133.96 180.285V172.023Z"
          fill="white"
        />
        <path
          d="M1149.47 172.023L1142.67 168.024L1135.9 172.023V180.285L1142.67 184.51L1149.47 180.285V172.023Z"
          fill="white"
        />
        <path
          d="M1164.99 172.023L1158.18 168.024L1151.41 172.023V180.285L1158.18 184.51L1164.99 180.285V172.023Z"
          fill="white"
        />
        <path
          d="M1180.5 172.023L1173.7 168.024L1166.93 172.023V180.285L1173.7 184.51L1180.5 180.285V172.023Z"
          fill="white"
        />
        <path
          d="M1196.02 172.023L1189.21 168.024L1182.44 172.023V180.285L1189.21 184.51L1196.02 180.285V172.023Z"
          fill="white"
        />
        <path
          d="M1211.54 172.023L1204.73 168.024L1197.96 172.023V180.285L1204.73 184.51L1211.54 180.285V172.023Z"
          fill="white"
        />
        <path
          d="M1227.05 172.023L1220.25 168.024L1213.48 172.023V180.285L1220.25 184.51L1227.05 180.285V172.023Z"
          fill="white"
        />
        <path
          d="M1242.57 172.023L1235.76 168.024L1228.99 172.023V180.285L1235.76 184.51L1242.57 180.285V172.023Z"
          fill="white"
        />
        <path
          d="M1258.08 172.023L1251.28 168.024L1244.51 172.023V180.285L1251.28 184.51L1258.08 180.285V172.023Z"
          fill="white"
        />
        <path
          d="M1273.6 172.023L1266.79 168.024L1260.02 172.023V180.285L1266.79 184.51L1273.6 180.285V172.023Z"
          fill="white"
        />
        <path
          d="M1289.12 172.023L1282.31 168.024L1275.54 172.023V180.285L1282.31 184.51L1289.12 180.285V172.023Z"
          fill="white"
        />
        <path
          d="M1320.15 172.023L1313.34 168.024L1306.57 172.023V180.285L1313.34 184.51L1320.15 180.285V172.023Z"
          fill="white"
        />
        <path
          d="M1335.66 172.023L1328.86 168.024L1322.09 172.023V180.285L1328.86 184.51L1335.66 180.285V172.023Z"
          fill="white"
        />
        <path
          d="M1002.07 185.598L995.267 181.6L988.497 185.598V193.86L995.267 198.085L1002.07 193.86V185.598Z"
          fill="white"
        />
        <path
          d="M1017.59 185.598L1010.78 181.6L1004.01 185.598V193.86L1010.78 198.085L1017.59 193.86V185.598Z"
          fill="white"
        />
        <path
          d="M1033.1 185.598L1026.3 181.6L1019.53 185.598V193.86L1026.3 198.085L1033.1 193.86V185.598Z"
          fill="white"
        />
        <path
          d="M1048.62 185.598L1041.81 181.6L1035.04 185.598V193.86L1041.81 198.085L1048.62 193.86V185.598Z"
          fill="white"
        />
        <path
          d="M1064.14 185.598L1057.33 181.6L1050.56 185.598V193.86L1057.33 198.085L1064.14 193.86V185.598Z"
          fill="white"
        />
        <path
          d="M1079.65 185.598L1072.85 181.6L1066.08 185.598V193.86L1072.85 198.085L1079.65 193.86V185.598Z"
          fill="white"
        />
        <path
          d="M1095.17 185.598L1088.36 181.6L1081.59 185.598V193.86L1088.36 198.085L1095.17 193.86V185.598Z"
          fill="white"
        />
        <path
          d="M1110.68 185.598L1103.88 181.6L1097.11 185.598V193.86L1103.88 198.085L1110.68 193.86V185.598Z"
          fill="white"
        />
        <path
          d="M1126.2 185.598L1119.39 181.6L1112.62 185.598V193.86L1119.39 198.085L1126.2 193.86V185.598Z"
          fill="white"
        />
        <path
          d="M1141.71 185.598L1134.91 181.6L1128.14 185.598V193.86L1134.91 198.085L1141.71 193.86V185.598Z"
          fill="white"
        />
        <path
          d="M1157.23 185.598L1150.42 181.6L1143.65 185.598V193.86L1150.42 198.085L1157.23 193.86V185.598Z"
          fill="white"
        />
        <path
          d="M1172.75 185.598L1165.94 181.6L1159.17 185.598V193.86L1165.94 198.085L1172.75 193.86V185.598Z"
          fill="white"
        />
        <path
          d="M1188.26 185.598L1181.46 181.6L1174.69 185.598V193.86L1181.46 198.085L1188.26 193.86V185.598Z"
          fill="white"
        />
        <path
          d="M1203.78 185.598L1196.97 181.6L1190.2 185.598V193.86L1196.97 198.085L1203.78 193.86V185.598Z"
          fill="white"
        />
        <path
          d="M1219.29 185.598L1212.49 181.6L1205.72 185.598V193.86L1212.49 198.085L1219.29 193.86V185.598Z"
          fill="white"
        />
        <path
          d="M1234.81 185.598L1228 181.6L1221.23 185.598V193.86L1228 198.085L1234.81 193.86V185.598Z"
          fill="white"
        />
        <path
          d="M1327.9 185.598L1321.1 181.6L1314.33 185.598V193.86L1321.1 198.085L1327.9 193.86V185.598Z"
          fill="white"
        />
        <path
          d="M1343.42 185.598L1336.61 181.6L1329.84 185.598V193.86L1336.61 198.085L1343.42 193.86V185.598Z"
          fill="white"
        />
        <path
          d="M1056.38 199.175L1049.57 195.176L1042.8 199.175V207.436L1049.57 211.661L1056.38 207.436V199.175Z"
          fill="white"
        />
        <path
          d="M1071.89 199.175L1065.09 195.176L1058.32 199.175V207.436L1065.09 211.661L1071.89 207.436V199.175Z"
          fill="white"
        />
        <path
          d="M1087.41 199.175L1080.6 195.176L1073.83 199.175V207.436L1080.6 211.661L1087.41 207.436V199.175Z"
          fill="white"
        />
        <path
          d="M1102.93 199.175L1096.12 195.176L1089.35 199.175V207.436L1096.12 211.661L1102.93 207.436V199.175Z"
          fill="white"
        />
        <path
          d="M1118.44 199.175L1111.64 195.176L1104.87 199.175V207.436L1111.64 211.661L1118.44 207.436V199.175Z"
          fill="white"
        />
        <path
          d="M1133.96 199.175L1127.15 195.176L1120.38 199.175V207.436L1127.15 211.661L1133.96 207.436V199.175Z"
          fill="white"
        />
        <path
          d="M1149.47 199.175L1142.67 195.176L1135.9 199.175V207.436L1142.67 211.661L1149.47 207.436V199.175Z"
          fill="white"
        />
        <path
          d="M1164.99 199.175L1158.18 195.176L1151.41 199.175V207.436L1158.18 211.661L1164.99 207.436V199.175Z"
          fill="white"
        />
        <path
          d="M1180.5 199.175L1173.7 195.176L1166.93 199.175V207.436L1173.7 211.661L1180.5 207.436V199.175Z"
          fill="white"
        />
        <path
          d="M1196.02 199.175L1189.21 195.176L1182.44 199.175V207.436L1189.21 211.661L1196.02 207.436V199.175Z"
          fill="white"
        />
        <path
          d="M1211.54 199.175L1204.73 195.176L1197.96 199.175V207.436L1204.73 211.661L1211.54 207.436V199.175Z"
          fill="white"
        />
        <path
          d="M1227.05 199.175L1220.25 195.176L1213.48 199.175V207.436L1220.25 211.661L1227.05 207.436V199.175Z"
          fill="white"
        />
        <path
          d="M1242.57 199.175L1235.76 195.176L1228.99 199.175V207.436L1235.76 211.661L1242.57 207.436V199.175Z"
          fill="white"
        />
        <path
          d="M1320.15 199.175L1313.34 195.176L1306.57 199.175V207.436L1313.34 211.661L1320.15 207.436V199.175Z"
          fill="white"
        />
        <path
          d="M1335.66 199.175L1328.86 195.176L1322.09 199.175V207.436L1328.86 211.661L1335.66 207.436V199.175Z"
          fill="white"
        />
        <path
          d="M1064.14 212.751L1057.33 208.752L1050.56 212.751V221.012L1057.33 225.237L1064.14 221.012V212.751Z"
          fill="white"
        />
        <path
          d="M1079.65 212.751L1072.85 208.752L1066.08 212.751V221.012L1072.85 225.237L1079.65 221.012V212.751Z"
          fill="white"
        />
        <path
          d="M1095.17 212.751L1088.36 208.752L1081.59 212.751V221.012L1088.36 225.237L1095.17 221.012V212.751Z"
          fill="white"
        />
        <path
          d="M1110.68 212.751L1103.88 208.752L1097.11 212.751V221.012L1103.88 225.237L1110.68 221.012V212.751Z"
          fill="white"
        />
        <path
          d="M1126.2 212.751L1119.39 208.752L1112.62 212.751V221.012L1119.39 225.237L1126.2 221.012V212.751Z"
          fill="white"
        />
        <path
          d="M1141.71 212.751L1134.91 208.752L1128.14 212.751V221.012L1134.91 225.237L1141.71 221.012V212.751Z"
          fill="white"
        />
        <path
          d="M1157.23 212.751L1150.42 208.752L1143.65 212.751V221.012L1150.42 225.237L1157.23 221.012V212.751Z"
          fill="white"
        />
        <path
          d="M1172.75 212.751L1165.94 208.752L1159.17 212.751V221.012L1165.94 225.237L1172.75 221.012V212.751Z"
          fill="white"
        />
        <path
          d="M1188.26 212.751L1181.46 208.752L1174.69 212.751V221.012L1181.46 225.237L1188.26 221.012V212.751Z"
          fill="white"
        />
        <path
          d="M1203.78 212.751L1196.97 208.752L1190.2 212.751V221.012L1196.97 225.237L1203.78 221.012V212.751Z"
          fill="white"
        />
        <path
          d="M1219.29 212.751L1212.49 208.752L1205.72 212.751V221.012L1212.49 225.237L1219.29 221.012V212.751Z"
          fill="white"
        />
        <path
          d="M1234.81 212.751L1228 208.752L1221.23 212.751V221.012L1228 225.237L1234.81 221.012V212.751Z"
          fill="white"
        />
        <path
          d="M1250.33 212.751L1243.52 208.752L1236.75 212.751V221.012L1243.52 225.237L1250.33 221.012V212.751Z"
          fill="white"
        />
        <path
          d="M1265.84 212.751L1259.04 208.752L1252.27 212.751V221.012L1259.04 225.237L1265.84 221.012V212.751Z"
          fill="white"
        />
        <path
          d="M1327.9 212.751L1321.1 208.752L1314.33 212.751V221.012L1321.1 225.237L1327.9 221.012V212.751Z"
          fill="white"
        />
        <path
          d="M1343.42 212.751L1336.61 208.752L1329.84 212.751V221.012L1336.61 225.237L1343.42 221.012V212.751Z"
          fill="white"
        />
        <path
          d="M1056.38 226.328L1049.57 222.329L1042.8 226.328V234.59L1049.57 238.815L1056.38 234.59V226.328Z"
          fill="white"
        />
        <path
          d="M1071.89 226.328L1065.09 222.329L1058.32 226.328V234.59L1065.09 238.815L1071.89 234.59V226.328Z"
          fill="white"
        />
        <path
          d="M1087.41 226.328L1080.6 222.329L1073.83 226.328V234.59L1080.6 238.815L1087.41 234.59V226.328Z"
          fill="white"
        />
        <path
          d="M1102.93 226.328L1096.12 222.329L1089.35 226.328V234.59L1096.12 238.815L1102.93 234.59V226.328Z"
          fill="white"
        />
        <path
          d="M1118.44 226.328L1111.64 222.329L1104.87 226.328V234.59L1111.64 238.815L1118.44 234.59V226.328Z"
          fill="white"
        />
        <path
          d="M1133.96 226.328L1127.15 222.329L1120.38 226.328V234.59L1127.15 238.815L1133.96 234.59V226.328Z"
          fill="white"
        />
        <path
          d="M1149.47 226.328L1142.67 222.329L1135.9 226.328V234.59L1142.67 238.815L1149.47 234.59V226.328Z"
          fill="white"
        />
        <path
          d="M1164.99 226.328L1158.18 222.329L1151.41 226.328V234.59L1158.18 238.815L1164.99 234.59V226.328Z"
          fill="white"
        />
        <path
          d="M1180.5 226.328L1173.7 222.329L1166.93 226.328V234.59L1173.7 238.815L1180.5 234.59V226.328Z"
          fill="white"
        />
        <path
          d="M1196.02 226.328L1189.21 222.329L1182.44 226.328V234.59L1189.21 238.815L1196.02 234.59V226.328Z"
          fill="white"
        />
        <path
          d="M1211.54 226.328L1204.73 222.329L1197.96 226.328V234.59L1204.73 238.815L1211.54 234.59V226.328Z"
          fill="white"
        />
        <path
          d="M1227.05 226.328L1220.25 222.329L1213.48 226.328V234.59L1220.25 238.815L1227.05 234.59V226.328Z"
          fill="white"
        />
        <path
          d="M1242.57 226.328L1235.76 222.329L1228.99 226.328V234.59L1235.76 238.815L1242.57 234.59V226.328Z"
          fill="white"
        />
        <path
          d="M1258.08 226.328L1251.28 222.329L1244.51 226.328V234.59L1251.28 238.815L1258.08 234.59V226.328Z"
          fill="white"
        />
        <path
          d="M1273.6 226.328L1266.79 222.329L1260.02 226.328V234.59L1266.79 238.815L1273.6 234.59V226.328Z"
          fill="white"
        />
        <path
          d="M1289.12 226.328L1282.31 222.329L1275.54 226.328V234.59L1282.31 238.815L1289.12 234.59V226.328Z"
          fill="white"
        />
        <path
          d="M1064.14 239.903L1057.33 235.904L1050.56 239.903V248.165L1057.33 252.39L1064.14 248.165V239.903Z"
          fill="white"
        />
        <path
          d="M1079.65 239.903L1072.85 235.904L1066.08 239.903V248.165L1072.85 252.39L1079.65 248.165V239.903Z"
          fill="white"
        />
        <path
          d="M1095.17 239.903L1088.36 235.904L1081.59 239.903V248.165L1088.36 252.39L1095.17 248.165V239.903Z"
          fill="white"
        />
        <path
          d="M1110.68 239.903L1103.88 235.904L1097.11 239.903V248.165L1103.88 252.39L1110.68 248.165V239.903Z"
          fill="white"
        />
        <path
          d="M1126.2 239.903L1119.39 235.904L1112.62 239.903V248.165L1119.39 252.39L1126.2 248.165V239.903Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M1141.71 239.903L1134.91 235.904L1128.14 239.903V248.165L1134.91 252.39L1141.71 248.165V239.903Z"
          fill="#8676FF"
        />
        <path
          d="M1157.23 239.903L1150.42 235.904L1143.65 239.903V248.165L1150.42 252.39L1157.23 248.165V239.903Z"
          fill="white"
        />
        <path
          d="M1172.75 239.903L1165.94 235.904L1159.17 239.903V248.165L1165.94 252.39L1172.75 248.165V239.903Z"
          fill="white"
        />
        <path
          d="M1188.26 239.903L1181.46 235.904L1174.69 239.903V248.165L1181.46 252.39L1188.26 248.165V239.903Z"
          fill="white"
        />
        <path
          d="M1203.78 239.903L1196.97 235.904L1190.2 239.903V248.165L1196.97 252.39L1203.78 248.165V239.903Z"
          fill="white"
        />
        <path
          d="M1219.29 239.903L1212.49 235.904L1205.72 239.903V248.165L1212.49 252.39L1219.29 248.165V239.903Z"
          fill="white"
        />
        <path
          d="M1234.81 239.903L1228 235.904L1221.23 239.903V248.165L1228 252.39L1234.81 248.165V239.903Z"
          fill="white"
        />
        <path
          d="M1250.33 239.903L1243.52 235.904L1236.75 239.903V248.165L1243.52 252.39L1250.33 248.165V239.903Z"
          fill="white"
        />
        <path
          d="M1265.84 239.903L1259.04 235.904L1252.27 239.903V248.165L1259.04 252.39L1265.84 248.165V239.903Z"
          fill="white"
        />
        <path
          d="M1281.36 239.903L1274.55 235.904L1267.78 239.903V248.165L1274.55 252.39L1281.36 248.165V239.903Z"
          fill="white"
        />
        <path
          d="M1296.87 239.903L1290.07 235.904L1283.3 239.903V248.165L1290.07 252.39L1296.87 248.165V239.903Z"
          fill="white"
        />
        <path
          d="M1056.38 253.48L1049.57 249.481L1042.8 253.48V261.742L1049.57 265.967L1056.38 261.742V253.48Z"
          fill="white"
        />
        <path
          d="M1071.89 253.48L1065.09 249.481L1058.32 253.48V261.742L1065.09 265.967L1071.89 261.742V253.48Z"
          fill="white"
        />
        <path
          d="M1087.41 253.48L1080.6 249.481L1073.83 253.48V261.742L1080.6 265.967L1087.41 261.742V253.48Z"
          fill="white"
        />
        <path
          d="M1102.93 253.48L1096.12 249.481L1089.35 253.48V261.742L1096.12 265.967L1102.93 261.742V253.48Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M1118.44 253.48L1111.64 249.481L1104.87 253.48V261.742L1111.64 265.967L1118.44 261.742V253.48Z"
          fill="#8676FF"
        />
        <path
          d="M1133.96 253.48L1127.15 249.481L1120.38 253.48V261.742L1127.15 265.967L1133.96 261.742V253.48Z"
          fill="white"
        />
        <path
          d="M1149.47 253.48L1142.67 249.481L1135.9 253.48V261.742L1142.67 265.967L1149.47 261.742V253.48Z"
          fill="white"
        />
        <path
          d="M1164.99 253.48L1158.18 249.481L1151.41 253.48V261.742L1158.18 265.967L1164.99 261.742V253.48Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M1180.5 253.48L1173.7 249.481L1166.93 253.48V261.742L1173.7 265.967L1180.5 261.742V253.48Z"
          fill="#8676FF"
        />
        <path
          d="M1196.02 253.48L1189.21 249.481L1182.44 253.48V261.742L1189.21 265.967L1196.02 261.742V253.48Z"
          fill="white"
        />
        <path
          d="M1211.54 253.48L1204.73 249.481L1197.96 253.48V261.742L1204.73 265.967L1211.54 261.742V253.48Z"
          fill="white"
        />
        <path
          d="M1227.05 253.48L1220.25 249.481L1213.48 253.48V261.742L1220.25 265.967L1227.05 261.742V253.48Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M1242.57 253.48L1235.76 249.481L1228.99 253.48V261.742L1235.76 265.967L1242.57 261.742V253.48Z"
          fill="#8676FF"
        />
        <path
          d="M1258.08 253.48L1251.28 249.481L1244.51 253.48V261.742L1251.28 265.967L1258.08 261.742V253.48Z"
          fill="white"
        />
        <path
          d="M1273.6 253.48L1266.79 249.481L1260.02 253.48V261.742L1266.79 265.967L1273.6 261.742V253.48Z"
          fill="white"
        />
        <path
          d="M1289.12 253.48L1282.31 249.481L1275.54 253.48V261.742L1282.31 265.967L1289.12 261.742V253.48Z"
          fill="white"
        />
        <path
          d="M1064.14 267.055L1057.33 263.057L1050.56 267.055V275.317L1057.33 279.542L1064.14 275.317V267.055Z"
          fill="white"
        />
        <path
          d="M1079.65 267.055L1072.85 263.057L1066.08 267.055V275.317L1072.85 279.542L1079.65 275.317V267.055Z"
          fill="white"
        />
        <path
          d="M1095.17 267.055L1088.36 263.057L1081.59 267.055V275.317L1088.36 279.542L1095.17 275.317V267.055Z"
          fill="white"
        />
        <path
          d="M1110.68 267.055L1103.88 263.057L1097.11 267.055V275.317L1103.88 279.542L1110.68 275.317V267.055Z"
          fill="white"
        />
        <path
          d="M1126.2 267.055L1119.39 263.057L1112.62 267.055V275.317L1119.39 279.542L1126.2 275.317V267.055Z"
          fill="white"
        />
        <path
          d="M1141.71 267.055L1134.91 263.057L1128.14 267.055V275.317L1134.91 279.542L1141.71 275.317V267.055Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M1157.23 267.055L1150.42 263.057L1143.65 267.055V275.317L1150.42 279.542L1157.23 275.317V267.055Z"
          fill="#8676FF"
        />
        <path
          d="M1172.75 267.055L1165.94 263.057L1159.17 267.055V275.317L1165.94 279.542L1172.75 275.317V267.055Z"
          fill="white"
        />
        <path
          d="M1188.26 267.055L1181.46 263.057L1174.69 267.055V275.317L1181.46 279.542L1188.26 275.317V267.055Z"
          fill="white"
        />
        <path
          d="M1203.78 267.055L1196.97 263.057L1190.2 267.055V275.317L1196.97 279.542L1203.78 275.317V267.055Z"
          fill="white"
        />
        <path
          d="M1219.29 267.055L1212.49 263.057L1205.72 267.055V275.317L1212.49 279.542L1219.29 275.317V267.055Z"
          fill="#8676FF"
        />
        <path
          d="M1234.81 267.055L1228 263.057L1221.23 267.055V275.317L1228 279.542L1234.81 275.317V267.055Z"
          fill="white"
        />
        <path
          d="M1250.33 267.055L1243.52 263.057L1236.75 267.055V275.317L1243.52 279.542L1250.33 275.317V267.055Z"
          fill="white"
        />
        <path
          d="M1265.84 267.055L1259.04 263.057L1252.27 267.055V275.317L1259.04 279.542L1265.84 275.317V267.055Z"
          fill="white"
        />
        <path
          d="M1056.38 280.635L1049.57 276.636L1042.8 280.635V288.896L1049.57 293.121L1056.38 288.896V280.635Z"
          fill="white"
        />
        <path
          d="M1071.89 280.635L1065.09 276.636L1058.32 280.635V288.896L1065.09 293.121L1071.89 288.896V280.635Z"
          fill="white"
        />
        <path
          d="M1087.41 280.635L1080.6 276.636L1073.83 280.635V288.896L1080.6 293.121L1087.41 288.896V280.635Z"
          fill="white"
        />
        <path
          d="M1102.93 280.635L1096.12 276.636L1089.35 280.635V288.896L1096.12 293.121L1102.93 288.896V280.635Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M1118.44 280.635L1111.64 276.636L1104.87 280.635V288.896L1111.64 293.121L1118.44 288.896V280.635Z"
          fill="#8676FF"
        />
        <path
          d="M1133.96 280.635L1127.15 276.636L1120.38 280.635V288.896L1127.15 293.121L1133.96 288.896V280.635Z"
          fill="white"
        />
        <path
          d="M1149.47 280.635L1142.67 276.636L1135.9 280.635V288.896L1142.67 293.121L1149.47 288.896V280.635Z"
          fill="#8676FF"
        />
        <path
          d="M1164.99 280.635L1158.18 276.636L1151.41 280.635V288.896L1158.18 293.121L1164.99 288.896V280.635Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M1180.5 280.635L1173.7 276.636L1166.93 280.635V288.896L1173.7 293.121L1180.5 288.896V280.635Z"
          fill="#8676FF"
        />
        <path
          d="M1196.02 280.635L1189.21 276.636L1182.44 280.635V288.896L1189.21 293.121L1196.02 288.896V280.635Z"
          fill="white"
        />
        <path
          d="M1211.54 280.635L1204.73 276.636L1197.96 280.635V288.896L1204.73 293.121L1211.54 288.896V280.635Z"
          fill="white"
        />
        <path
          d="M1227.05 280.635L1220.25 276.636L1213.48 280.635V288.896L1220.25 293.121L1227.05 288.896V280.635Z"
          fill="white"
        />
        <path
          d="M1242.57 280.635L1235.76 276.636L1228.99 280.635V288.896L1235.76 293.121L1242.57 288.896V280.635Z"
          fill="white"
        />
        <path
          d="M1258.08 280.635L1251.28 276.636L1244.51 280.635V288.896L1251.28 293.121L1258.08 288.896V280.635Z"
          fill="#8676FF"
        />
        <path
          d="M1064.14 294.208L1057.33 290.209L1050.56 294.208V302.469L1057.33 306.695L1064.14 302.469V294.208Z"
          fill="white"
        />
        <path
          d="M1079.65 294.208L1072.85 290.209L1066.08 294.208V302.469L1072.85 306.695L1079.65 302.469V294.208Z"
          fill="white"
        />
        <path
          d="M1095.17 294.208L1088.36 290.209L1081.59 294.208V302.469L1088.36 306.695L1095.17 302.469V294.208Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M1110.68 294.208L1103.88 290.209L1097.11 294.208V302.469L1103.88 306.695L1110.68 302.469V294.208Z"
          fill="#8676FF"
        />
        <path
          d="M1126.2 294.208L1119.39 290.209L1112.62 294.208V302.469L1119.39 306.695L1126.2 302.469V294.208Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M1141.71 294.208L1134.91 290.209L1128.14 294.208V302.469L1134.91 306.695L1141.71 302.469V294.208Z"
          fill="#8676FF"
        />
        <path
          d="M1157.23 294.208L1150.42 290.209L1143.65 294.208V302.469L1150.42 306.695L1157.23 302.469V294.208Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M1172.75 294.208L1165.94 290.209L1159.17 294.208V302.469L1165.94 306.695L1172.75 302.469V294.208Z"
          fill="#8676FF"
        />
        <path
          d="M1188.26 294.208L1181.46 290.209L1174.69 294.208V302.469L1181.46 306.695L1188.26 302.469V294.208Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M1203.78 294.208L1196.97 290.209L1190.2 294.208V302.469L1196.97 306.695L1203.78 302.469V294.208Z"
          fill="#8676FF"
        />
        <path
          d="M1219.29 294.208L1212.49 290.209L1205.72 294.208V302.469L1212.49 306.695L1219.29 302.469V294.208Z"
          fill="#8676FF"
        />
        <path
          d="M1250.33 294.208L1243.52 290.209L1236.75 294.208V302.469L1243.52 306.695L1250.33 302.469V294.208Z"
          fill="white"
        />
        <path
          d="M1265.84 294.208L1259.04 290.209L1252.27 294.208V302.469L1259.04 306.695L1265.84 302.469V294.208Z"
          fill="white"
        />
        <path
          d="M1312.39 294.208L1305.58 290.209L1298.81 294.208V302.469L1305.58 306.695L1312.39 302.469V294.208Z"
          fill="white"
        />
        <path
          d="M1327.9 294.208L1321.1 290.209L1314.33 294.208V302.469L1321.1 306.695L1327.9 302.469V294.208Z"
          fill="white"
        />
        <path
          d="M1056.38 307.785L1049.57 303.786L1042.8 307.785V316.047L1049.57 320.272L1056.38 316.047V307.785Z"
          fill="white"
        />
        <path
          d="M1071.89 307.785L1065.09 303.786L1058.32 307.785V316.047L1065.09 320.272L1071.89 316.047V307.785Z"
          fill="white"
        />
        <path
          d="M1087.41 307.785L1080.6 303.786L1073.83 307.785V316.047L1080.6 320.272L1087.41 316.047V307.785Z"
          fill="white"
        />
        <path
          d="M1102.93 307.785L1096.12 303.786L1089.35 307.785V316.047L1096.12 320.272L1102.93 316.047V307.785Z"
          fill="white"
        />
        <path
          d="M1118.44 307.785L1111.64 303.786L1104.87 307.785V316.047L1111.64 320.272L1118.44 316.047V307.785Z"
          fill="white"
        />
        <path
          d="M1133.96 307.785L1127.15 303.786L1120.38 307.785V316.047L1127.15 320.272L1133.96 316.047V307.785Z"
          fill="white"
        />
        <path
          d="M1149.47 307.785L1142.67 303.786L1135.9 307.785V316.047L1142.67 320.272L1149.47 316.047V307.785Z"
          fill="white"
        />
        <path
          d="M1164.99 307.785L1158.18 303.786L1151.41 307.785V316.047L1158.18 320.272L1164.99 316.047V307.785Z"
          fill="white"
        />
        <path
          d="M1180.5 307.785L1173.7 303.786L1166.93 307.785V316.047L1173.7 320.272L1180.5 316.047V307.785Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M1196.02 307.785L1189.21 303.786L1182.44 307.785V316.047L1189.21 320.272L1196.02 316.047V307.785Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M1211.54 307.785L1204.73 303.786L1197.96 307.785V316.047L1204.73 320.272L1211.54 316.047V307.785Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M1227.05 307.785L1220.25 303.786L1213.48 307.785V316.047L1220.25 320.272L1227.05 316.047V307.785Z"
          fill="#8676FF"
        />
        <path
          d="M1273.6 307.785L1266.79 303.786L1260.02 307.785V316.047L1266.79 320.272L1273.6 316.047V307.785Z"
          fill="white"
        />
        <path
          d="M1289.12 307.785L1282.31 303.786L1275.54 307.785V316.047L1282.31 320.272L1289.12 316.047V307.785Z"
          fill="white"
        />
        <path
          d="M1304.63 307.785L1297.83 303.786L1291.06 307.785V316.047L1297.83 320.272L1304.63 316.047V307.785Z"
          fill="white"
        />
        <path
          d="M1320.15 307.785L1313.34 303.786L1306.57 307.785V316.047L1313.34 320.272L1320.15 316.047V307.785Z"
          fill="white"
        />
        <path
          d="M1064.14 321.361L1057.33 317.362L1050.56 321.361V329.623L1057.33 333.848L1064.14 329.623V321.361Z"
          fill="white"
        />
        <path
          d="M1079.65 321.361L1072.85 317.362L1066.08 321.361V329.623L1072.85 333.848L1079.65 329.623V321.361Z"
          fill="white"
        />
        <path
          d="M1095.17 321.361L1088.36 317.362L1081.59 321.361V329.623L1088.36 333.848L1095.17 329.623V321.361Z"
          fill="white"
        />
        <path
          d="M1110.68 321.361L1103.88 317.362L1097.11 321.361V329.623L1103.88 333.848L1110.68 329.623V321.361Z"
          fill="white"
        />
        <path
          d="M1126.2 321.361L1119.39 317.362L1112.62 321.361V329.623L1119.39 333.848L1126.2 329.623V321.361Z"
          fill="white"
        />
        <path
          d="M1141.71 321.361L1134.91 317.362L1128.14 321.361V329.623L1134.91 333.848L1141.71 329.623V321.361Z"
          fill="white"
        />
        <path
          d="M1157.23 321.361L1150.42 317.362L1143.65 321.361V329.623L1150.42 333.848L1157.23 329.623V321.361Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M1172.75 321.361L1165.94 317.362L1159.17 321.361V329.623L1165.94 333.848L1172.75 329.623V321.361Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M1188.26 321.361L1181.46 317.362L1174.69 321.361V329.623L1181.46 333.848L1188.26 329.623V321.361Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M1203.78 321.361L1196.97 317.362L1190.2 321.361V329.623L1196.97 333.848L1203.78 329.623V321.361Z"
          fill="#8676FF"
        />
        <path
          d="M1219.29 321.361L1212.49 317.362L1205.72 321.361V329.623L1212.49 333.848L1219.29 329.623V321.361Z"
          fill="#FF2D2E"
        />
        <path
          d="M1234.81 321.361L1228 317.362L1221.23 321.361V329.623L1228 333.848L1234.81 329.623V321.361Z"
          fill="#FF2D2E"
        />
        <path
          d="M1281.36 321.361L1274.55 317.362L1267.78 321.361V329.623L1274.55 333.848L1281.36 329.623V321.361Z"
          fill="white"
        />
        <path
          d="M1296.87 321.361L1290.07 317.362L1283.3 321.361V329.623L1290.07 333.848L1296.87 329.623V321.361Z"
          fill="white"
        />
        <path
          d="M1056.38 334.939L1049.57 330.94L1042.8 334.939V343.201L1049.57 347.426L1056.38 343.201V334.939Z"
          fill="white"
        />
        <path
          d="M1071.89 334.939L1065.09 330.94L1058.32 334.939V343.201L1065.09 347.426L1071.89 343.201V334.939Z"
          fill="white"
        />
        <path
          d="M1087.41 334.939L1080.6 330.94L1073.83 334.939V343.201L1080.6 347.426L1087.41 343.201V334.939Z"
          fill="white"
        />
        <path
          d="M1102.93 334.939L1096.12 330.94L1089.35 334.939V343.201L1096.12 347.426L1102.93 343.201V334.939Z"
          fill="white"
        />
        <path
          d="M1118.44 334.939L1111.64 330.94L1104.87 334.939V343.201L1111.64 347.426L1118.44 343.201V334.939Z"
          fill="white"
        />
        <path
          d="M1133.96 334.939L1127.15 330.94L1120.38 334.939V343.201L1127.15 347.426L1133.96 343.201V334.939Z"
          fill="white"
        />
        <path
          d="M1149.47 334.939L1142.67 330.94L1135.9 334.939V343.201L1142.67 347.426L1149.47 343.201V334.939Z"
          fill="white"
        />
        <path
          d="M1164.99 334.939L1158.18 330.94L1151.41 334.939V343.201L1158.18 347.426L1164.99 343.201V334.939Z"
          fill="white"
        />
        <path
          d="M1180.5 334.939L1173.7 330.94L1166.93 334.939V343.201L1173.7 347.426L1180.5 343.201V334.939Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M1196.02 334.939L1189.21 330.94L1182.44 334.939V343.201L1189.21 347.426L1196.02 343.201V334.939Z"
          fill="#8676FF"
        />
        <path
          d="M1211.54 334.939L1204.73 330.94L1197.96 334.939V343.201L1204.73 347.426L1211.54 343.201V334.939Z"
          fill="#FF2D2E"
        />
        <path
          d="M1227.05 334.939L1220.25 330.94L1213.48 334.939V343.201L1220.25 347.426L1227.05 343.201V334.939Z"
          fill="#FF2D2E"
        />
        <path
          d="M1242.57 334.939L1235.76 330.94L1228.99 334.939V343.201L1235.76 347.426L1242.57 343.201V334.939Z"
          fill="#FF2D2E"
        />
        <path
          d="M1064.14 348.514L1057.33 344.516L1050.56 348.514V356.776L1057.33 361.001L1064.14 356.776V348.514Z"
          fill="white"
        />
        <path
          d="M1079.65 348.514L1072.85 344.516L1066.08 348.514V356.776L1072.85 361.001L1079.65 356.776V348.514Z"
          fill="white"
        />
        <path
          d="M1095.17 348.514L1088.36 344.516L1081.59 348.514V356.776L1088.36 361.001L1095.17 356.776V348.514Z"
          fill="white"
        />
        <path
          d="M1110.68 348.514L1103.88 344.516L1097.11 348.514V356.776L1103.88 361.001L1110.68 356.776V348.514Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M1126.2 348.514L1119.39 344.516L1112.62 348.514V356.776L1119.39 361.001L1126.2 356.776V348.514Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M1141.71 348.514L1134.91 344.516L1128.14 348.514V356.776L1134.91 361.001L1141.71 356.776V348.514Z"
          fill="#8676FF"
        />
        <path
          d="M1157.23 348.514L1150.42 344.516L1143.65 348.514V356.776L1150.42 361.001L1157.23 356.776V348.514Z"
          fill="white"
        />
        <path
          d="M1172.75 348.514L1165.94 344.516L1159.17 348.514V356.776L1165.94 361.001L1172.75 356.776V348.514Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M1188.26 348.514L1181.46 344.516L1174.69 348.514V356.776L1181.46 361.001L1188.26 356.776V348.514Z"
          fill="#8676FF"
        />
        <path
          d="M1203.78 348.514L1196.97 344.516L1190.2 348.514V356.776L1196.97 361.001L1203.78 356.776V348.514Z"
          fill="#8676FF"
        />
        <path
          d="M1219.29 348.514L1212.49 344.516L1205.72 348.514V356.776L1212.49 361.001L1219.29 356.776V348.514Z"
          fill="#FF2D2E"
        />
        <path
          d="M1234.81 348.514L1228 344.516L1221.23 348.514V356.776L1228 361.001L1234.81 356.776V348.514Z"
          fill="#FF2D2E"
        />
        <path
          d="M1250.33 348.514L1243.52 344.516L1236.75 348.514V356.776L1243.52 361.001L1250.33 356.776V348.514Z"
          fill="#D45AFF"
        />
        <path
          d="M1056.38 362.091L1049.57 358.092L1042.8 362.091V370.352L1049.57 374.577L1056.38 370.352V362.091Z"
          fill="white"
        />
        <path
          d="M1071.89 362.091L1065.09 358.092L1058.32 362.091V370.352L1065.09 374.577L1071.89 370.352V362.091Z"
          fill="white"
        />
        <path
          d="M1087.41 362.091L1080.6 358.092L1073.83 362.091V370.352L1080.6 374.577L1087.41 370.352V362.091Z"
          fill="white"
        />
        <path
          d="M1102.93 362.091L1096.12 358.092L1089.35 362.091V370.352L1096.12 374.577L1102.93 370.352V362.091Z"
          fill="white"
        />
        <path
          d="M1118.44 362.091L1111.64 358.092L1104.87 362.091V370.352L1111.64 374.577L1118.44 370.352V362.091Z"
          fill="white"
        />
        <path
          d="M1133.96 362.091L1127.15 358.092L1120.38 362.091V370.352L1127.15 374.577L1133.96 370.352V362.091Z"
          fill="white"
        />
        <path
          d="M1149.47 362.091L1142.67 358.092L1135.9 362.091V370.352L1142.67 374.577L1149.47 370.352V362.091Z"
          fill="white"
        />
        <path
          d="M1164.99 362.091L1158.18 358.092L1151.41 362.091V370.352L1158.18 374.577L1164.99 370.352V362.091Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M1180.5 362.091L1173.7 358.092L1166.93 362.091V370.352L1173.7 374.577L1180.5 370.352V362.091Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M1196.02 362.091L1189.21 358.092L1182.44 362.091V370.352L1189.21 374.577L1196.02 370.352V362.091Z"
          fill="#8676FF"
        />
        <path
          d="M1211.54 362.091L1204.73 358.092L1197.96 362.091V370.352L1204.73 374.577L1211.54 370.352V362.091Z"
          fill="#8676FF"
        />
        <path
          opacity="0.3"
          d="M1227.05 362.091L1220.25 358.092L1213.48 362.091V370.352L1220.25 374.577L1227.05 370.352V362.091Z"
          fill="#8676FF"
        />
        <path
          d="M1242.57 362.091L1235.76 358.092L1228.99 362.091V370.352L1235.76 374.577L1242.57 370.352V362.091Z"
          fill="#8676FF"
        />
        <path
          d="M1064.14 375.666L1057.33 371.667L1050.56 375.666V383.927L1057.33 388.153L1064.14 383.927V375.666Z"
          fill="white"
        />
        <path
          d="M1079.65 375.666L1072.85 371.667L1066.08 375.666V383.927L1072.85 388.153L1079.65 383.927V375.666Z"
          fill="white"
        />
        <path
          d="M1095.17 375.666L1088.36 371.667L1081.59 375.666V383.927L1088.36 388.153L1095.17 383.927V375.666Z"
          fill="white"
        />
        <path
          d="M1110.68 375.666L1103.88 371.667L1097.11 375.666V383.927L1103.88 388.153L1110.68 383.927V375.666Z"
          fill="white"
        />
        <path
          d="M1126.2 375.666L1119.39 371.667L1112.62 375.666V383.927L1119.39 388.153L1126.2 383.927V375.666Z"
          fill="white"
        />
        <path
          d="M1141.71 375.666L1134.91 371.667L1128.14 375.666V383.927L1134.91 388.153L1141.71 383.927V375.666Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M1157.23 375.666L1150.42 371.667L1143.65 375.666V383.927L1150.42 388.153L1157.23 383.927V375.666Z"
          fill="#8676FF"
        />
        <path
          d="M1172.75 375.666L1165.94 371.667L1159.17 375.666V383.927L1165.94 388.153L1172.75 383.927V375.666Z"
          fill="white"
        />
        <path
          d="M1188.26 375.666L1181.46 371.667L1174.69 375.666V383.927L1181.46 388.153L1188.26 383.927V375.666Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M1203.78 375.666L1196.97 371.667L1190.2 375.666V383.927L1196.97 388.153L1203.78 383.927V375.666Z"
          fill="#8676FF"
        />
        <path
          d="M1219.29 375.666L1212.49 371.667L1205.72 375.666V383.927L1212.49 388.153L1219.29 383.927V375.666Z"
          fill="white"
        />
        <path
          d="M1234.81 375.666L1228 371.667L1221.23 375.666V383.927L1228 388.153L1234.81 383.927V375.666Z"
          fill="#8676FF"
        />
        <path
          d="M1056.38 389.244L1049.57 385.245L1042.8 389.244V397.506L1049.57 401.731L1056.38 397.506V389.244Z"
          fill="white"
        />
        <path
          d="M1071.89 389.244L1065.09 385.245L1058.32 389.244V397.506L1065.09 401.731L1071.89 397.506V389.244Z"
          fill="white"
        />
        <path
          d="M1087.41 389.244L1080.6 385.245L1073.83 389.244V397.506L1080.6 401.731L1087.41 397.506V389.244Z"
          fill="white"
        />
        <path
          d="M1133.96 389.244L1127.15 385.245L1120.38 389.244V397.506L1127.15 401.731L1133.96 397.506V389.244Z"
          fill="white"
        />
        <path
          d="M1149.47 389.244L1142.67 385.245L1135.9 389.244V397.506L1142.67 401.731L1149.47 397.506V389.244Z"
          fill="white"
        />
        <path
          d="M1164.99 389.244L1158.18 385.245L1151.41 389.244V397.506L1158.18 401.731L1164.99 397.506V389.244Z"
          fill="white"
        />
        <path
          d="M1180.5 389.244L1173.7 385.245L1166.93 389.244V397.506L1173.7 401.731L1180.5 397.506V389.244Z"
          fill="white"
        />
        <path
          d="M1196.02 389.244L1189.21 385.245L1182.44 389.244V397.506L1189.21 401.731L1196.02 397.506V389.244Z"
          fill="white"
        />
        <path
          d="M1064.14 402.82L1057.33 398.821L1050.56 402.82V411.082L1057.33 415.307L1064.14 411.082V402.82Z"
          fill="white"
        />
        <path
          d="M1079.65 402.82L1072.85 398.821L1066.08 402.82V411.082L1072.85 415.307L1079.65 411.082V402.82Z"
          fill="white"
        />
        <path
          d="M1141.71 402.82L1134.91 398.821L1128.14 402.82V411.082L1134.91 415.307L1141.71 411.082V402.82Z"
          fill="white"
        />
        <path
          d="M1157.23 402.82L1150.42 398.821L1143.65 402.82V411.082L1150.42 415.307L1157.23 411.082V402.82Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M1172.75 402.82L1165.94 398.821L1159.17 402.82V411.082L1165.94 415.307L1172.75 411.082V402.82Z"
          fill="#8676FF"
        />
        <path
          d="M1188.26 402.82L1181.46 398.821L1174.69 402.82V411.082L1181.46 415.307L1188.26 411.082V402.82Z"
          fill="white"
        />
        <path
          d="M1203.78 402.82L1196.97 398.821L1190.2 402.82V411.082L1196.97 415.307L1203.78 411.082V402.82Z"
          fill="white"
        />
        <path
          d="M1056.38 416.395L1049.57 412.396L1042.8 416.395V424.657L1049.57 428.882L1056.38 424.657V416.395Z"
          fill="white"
        />
        <path
          d="M1071.89 416.395L1065.09 412.396L1058.32 416.395V424.657L1065.09 428.882L1071.89 424.657V416.395Z"
          fill="white"
        />
        <path
          d="M1164.99 416.395L1158.18 412.396L1151.41 416.395V424.657L1158.18 428.882L1164.99 424.657V416.395Z"
          fill="white"
        />
        <path
          d="M1180.5 416.395L1173.7 412.396L1166.93 416.395V424.657L1173.7 428.882L1180.5 424.657V416.395Z"
          fill="white"
        />
        <path
          d="M1196.02 416.395L1189.21 412.396L1182.44 416.395V424.657L1189.21 428.882L1196.02 424.657V416.395Z"
          fill="white"
        />
        <path
          d="M1064.14 429.973L1057.33 425.975L1050.56 429.973V438.235L1057.33 442.46L1064.14 438.235V429.973Z"
          fill="white"
        />
        <path
          d="M1079.65 429.973L1072.85 425.975L1066.08 429.973V438.235L1072.85 442.46L1079.65 438.235V429.973Z"
          fill="white"
        />
        <path
          d="M1172.75 429.973L1165.94 425.975L1159.17 429.973V438.235L1165.94 442.46L1172.75 438.235V429.973Z"
          fill="white"
        />
        <path
          d="M1188.26 429.973L1181.46 425.975L1174.69 429.973V438.235L1181.46 442.46L1188.26 438.235V429.973Z"
          fill="white"
        />
        <path
          d="M1203.78 429.973L1196.97 425.975L1190.2 429.973V438.235L1196.97 442.46L1203.78 438.235V429.973Z"
          fill="white"
        />
        <path
          d="M1056.38 443.549L1049.57 439.55L1042.8 443.549V451.81L1049.57 456.035L1056.38 451.81V443.549Z"
          fill="white"
        />
        <path
          d="M1071.89 443.549L1065.09 439.55L1058.32 443.549V451.81L1065.09 456.035L1071.89 451.81V443.549Z"
          fill="white"
        />
        <path
          d="M1164.99 443.549L1158.18 439.55L1151.41 443.549V451.81L1158.18 456.035L1164.99 451.81V443.549Z"
          fill="white"
        />
        <path
          d="M1196.02 443.549L1189.21 439.55L1182.44 443.549V451.81L1189.21 456.035L1196.02 451.81V443.549Z"
          fill="white"
        />
        <path
          d="M1211.54 443.549L1204.73 439.55L1197.96 443.549V451.81L1204.73 456.035L1211.54 451.81V443.549Z"
          fill="white"
        />
        <path
          d="M1064.14 457.126L1057.33 453.127L1050.56 457.126V465.387L1057.33 469.612L1064.14 465.387V457.126Z"
          fill="white"
        />
        <path
          d="M1079.65 457.126L1072.85 453.127L1066.08 457.126V465.387L1072.85 469.612L1079.65 465.387V457.126Z"
          fill="white"
        />
        <path
          d="M1172.75 457.126L1165.94 453.127L1159.17 457.126V465.387L1165.94 469.612L1172.75 465.387V457.126Z"
          fill="white"
        />
        <path
          d="M1071.89 471.052L1065.09 467.053L1058.32 471.052V479.313L1065.09 483.538L1071.89 479.313V471.052Z"
          fill="white"
        />
        <path
          d="M1164.99 471.052L1158.18 467.053L1151.41 471.052V479.313L1158.18 483.538L1164.99 479.313V471.052Z"
          fill="white"
        />
        <path
          d="M1180.5 471.052L1173.7 467.053L1166.93 471.052V479.313L1173.7 483.538L1180.5 479.313V471.052Z"
          fill="white"
        />
        <path
          d="M1242.57 471.052L1235.76 467.053L1228.99 471.052V479.313L1235.76 483.538L1242.57 479.313V471.052Z"
          fill="white"
        />
        <path
          d="M1258.08 471.052L1251.28 467.053L1244.51 471.052V479.313L1251.28 483.538L1258.08 479.313V471.052Z"
          fill="white"
        />
        <path
          d="M1040.86 172.023L1034.06 168.024L1027.29 172.023V180.285L1034.06 184.51L1040.86 180.285V172.023Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M1009.83 199.175L1003.03 195.176L996.255 199.175V207.436L1003.03 211.661L1009.83 207.436V199.175Z"
          fill="#8676FF"
        />
        <path
          d="M1025.35 199.175L1018.54 195.176L1011.77 199.175V207.436L1018.54 211.661L1025.35 207.436V199.175Z"
          fill="white"
        />
        <path
          d="M1040.86 199.175L1034.06 195.176L1027.29 199.175V207.436L1034.06 211.661L1040.86 207.436V199.175Z"
          fill="white"
        />
        <path
          d="M1002.07 212.751L995.267 208.752L988.497 212.751V221.012L995.267 225.237L1002.07 221.012V212.751Z"
          fill="white"
        />
        <path
          d="M1017.59 212.751L1010.78 208.752L1004.01 212.751V221.012L1010.78 225.237L1017.59 221.012V212.751Z"
          fill="white"
        />
        <path
          d="M1033.1 212.751L1026.3 208.752L1019.53 212.751V221.012L1026.3 225.237L1033.1 221.012V212.751Z"
          fill="white"
        />
        <path
          d="M1048.62 212.751L1041.81 208.752L1035.04 212.751V221.012L1041.81 225.237L1048.62 221.012V212.751Z"
          fill="white"
        />
        <path
          d="M1009.83 226.328L1003.03 222.329L996.255 226.328V234.59L1003.03 238.815L1009.83 234.59V226.328Z"
          fill="white"
        />
        <path
          d="M1025.35 226.328L1018.54 222.329L1011.77 226.328V234.59L1018.54 238.815L1025.35 234.59V226.328Z"
          fill="white"
        />
        <path
          d="M1040.86 226.328L1034.06 222.329L1027.29 226.328V234.59L1034.06 238.815L1040.86 234.59V226.328Z"
          fill="white"
        />
        <path
          d="M1048.62 239.903L1041.81 235.904L1035.04 239.903V248.165L1041.81 252.39L1048.62 248.165V239.903Z"
          fill="white"
        />
        <path
          d="M1048.62 267.055L1041.81 263.057L1035.04 267.055V275.317L1041.81 279.542L1048.62 275.317V267.055Z"
          fill="white"
        />
        <path
          d="M1048.62 294.208L1041.81 290.209L1035.04 294.208V302.469L1041.81 306.695L1048.62 302.469V294.208Z"
          fill="white"
        />
        <path
          d="M1048.62 321.361L1041.81 317.362L1035.04 321.361V329.623L1041.81 333.848L1048.62 329.623V321.361Z"
          fill="white"
        />
        <path
          opacity="0.3"
          d="M1048.62 348.514L1041.81 344.516L1035.04 348.514V356.776L1041.81 361.001L1048.62 356.776V348.514Z"
          fill="#8676FF"
        />
        <path
          d="M1048.62 375.666L1041.81 371.667L1035.04 375.666V383.927L1041.81 388.153L1048.62 383.927V375.666Z"
          fill="white"
        />
        <path
          d="M1048.62 402.82L1041.81 398.821L1035.04 402.82V411.082L1041.81 415.307L1048.62 411.082V402.82Z"
          fill="white"
        />
        <path
          d="M1002.07 239.903L995.267 235.904L988.497 239.903V248.165L995.267 252.39L1002.07 248.165V239.903Z"
          fill="white"
        />
        <path
          d="M1017.59 239.903L1010.78 235.904L1004.01 239.903V248.165L1010.78 252.39L1017.59 248.165V239.903Z"
          fill="white"
        />
        <path
          d="M1033.1 239.903L1026.3 235.904L1019.53 239.903V248.165L1026.3 252.39L1033.1 248.165V239.903Z"
          fill="white"
        />
        <path
          d="M1009.83 253.48L1003.03 249.481L996.255 253.48V261.742L1003.03 265.967L1009.83 261.742V253.48Z"
          fill="white"
        />
        <path
          d="M1025.35 253.48L1018.54 249.481L1011.77 253.48V261.742L1018.54 265.967L1025.35 261.742V253.48Z"
          fill="white"
        />
        <path
          d="M1040.86 253.48L1034.06 249.481L1027.29 253.48V261.742L1034.06 265.967L1040.86 261.742V253.48Z"
          fill="white"
        />
        <path
          d="M1002.07 267.055L995.267 263.057L988.497 267.055V275.317L995.267 279.542L1002.07 275.317V267.055Z"
          fill="white"
        />
        <path
          d="M1017.59 267.055L1010.78 263.057L1004.01 267.055V275.317L1010.78 279.542L1017.59 275.317V267.055Z"
          fill="white"
        />
        <path
          d="M1033.1 267.055L1026.3 263.057L1019.53 267.055V275.317L1026.3 279.542L1033.1 275.317V267.055Z"
          fill="white"
        />
        <path
          d="M1009.83 280.635L1003.03 276.636L996.255 280.635V288.896L1003.03 293.121L1009.83 288.896V280.635Z"
          fill="white"
        />
        <path
          d="M1025.35 280.635L1018.54 276.636L1011.77 280.635V288.896L1018.54 293.121L1025.35 288.896V280.635Z"
          fill="white"
        />
        <path
          d="M1040.86 280.635L1034.06 276.636L1027.29 280.635V288.896L1034.06 293.121L1040.86 288.896V280.635Z"
          fill="white"
        />
        <path
          d="M1002.07 294.208L995.267 290.209L988.497 294.208V302.469L995.267 306.695L1002.07 302.469V294.208Z"
          fill="white"
        />
        <path
          d="M1017.59 294.208L1010.78 290.209L1004.01 294.208V302.469L1010.78 306.695L1017.59 302.469V294.208Z"
          fill="white"
        />
        <path
          d="M1033.1 294.208L1026.3 290.209L1019.53 294.208V302.469L1026.3 306.695L1033.1 302.469V294.208Z"
          fill="white"
        />
        <path
          d="M1009.83 307.785L1003.03 303.786L996.255 307.785V316.047L1003.03 320.272L1009.83 316.047V307.785Z"
          fill="white"
        />
        <path
          d="M1025.35 307.785L1018.54 303.786L1011.77 307.785V316.047L1018.54 320.272L1025.35 316.047V307.785Z"
          fill="white"
        />
        <path
          d="M1040.86 307.785L1034.06 303.786L1027.29 307.785V316.047L1034.06 320.272L1040.86 316.047V307.785Z"
          fill="white"
        />
        <path
          d="M1002.07 321.361L995.267 317.362L988.497 321.361V329.623L995.267 333.848L1002.07 329.623V321.361Z"
          fill="white"
        />
        <path
          d="M1017.59 321.361L1010.78 317.362L1004.01 321.361V329.623L1010.78 333.848L1017.59 329.623V321.361Z"
          fill="white"
        />
        <path
          d="M1033.1 321.361L1026.3 317.362L1019.53 321.361V329.623L1026.3 333.848L1033.1 329.623V321.361Z"
          fill="white"
        />
        <path
          d="M1009.83 334.939L1003.03 330.94L996.255 334.939V343.201L1003.03 347.426L1009.83 343.201V334.939Z"
          fill="white"
        />
        <path
          d="M1025.35 334.939L1018.54 330.94L1011.77 334.939V343.201L1018.54 347.426L1025.35 343.201V334.939Z"
          fill="#D45AFF"
        />
        <path
          d="M1040.86 334.939L1034.06 330.94L1027.29 334.939V343.201L1034.06 347.426L1040.86 343.201V334.939Z"
          fill="white"
        />
        <path
          d="M1002.07 348.514L995.267 344.516L988.497 348.514V356.776L995.267 361.001L1002.07 356.776V348.514Z"
          fill="white"
        />
        <path
          d="M1017.59 348.514L1010.78 344.516L1004.01 348.514V356.776L1010.78 361.001L1017.59 356.776V348.514Z"
          fill="white"
        />
        <path
          d="M1033.1 348.514L1026.3 344.516L1019.53 348.514V356.776L1026.3 361.001L1033.1 356.776V348.514Z"
          fill="white"
        />
        <path
          d="M1009.83 362.091L1003.03 358.092L996.255 362.091V370.352L1003.03 374.577L1009.83 370.352V362.091Z"
          fill="white"
        />
        <path
          d="M1025.35 362.091L1018.54 358.092L1011.77 362.091V370.352L1018.54 374.577L1025.35 370.352V362.091Z"
          fill="white"
        />
        <path
          d="M1040.86 362.091L1034.06 358.092L1027.29 362.091V370.352L1034.06 374.577L1040.86 370.352V362.091Z"
          fill="white"
        />
        <path
          d="M1017.59 375.666L1010.78 371.667L1004.01 375.666V383.927L1010.78 388.153L1017.59 383.927V375.666Z"
          fill="white"
        />
        <path
          d="M1033.1 375.666L1026.3 371.667L1019.53 375.666V383.927L1026.3 388.153L1033.1 383.927V375.666Z"
          fill="white"
        />
        <path
          d="M1040.86 389.244L1034.06 385.245L1027.29 389.244V397.506L1034.06 401.731L1040.86 397.506V389.244Z"
          fill="white"
        />
        <path
          d="M1157.23 485.185L1150.42 481.187L1143.65 485.185V493.447L1150.42 497.672L1157.23 493.447V485.185Z"
          fill="white"
        />
        <path
          d="M1172.75 485.185L1165.94 481.187L1159.17 485.185V493.447L1165.94 497.672L1172.75 493.447V485.185Z"
          fill="white"
        />
        <path
          d="M1188.26 485.185L1181.46 481.187L1174.69 485.185V493.447L1181.46 497.672L1188.26 493.447V485.185Z"
          fill="white"
        />
        <path
          d="M1219.29 485.185L1212.49 481.187L1205.72 485.185V493.447L1212.49 497.672L1219.29 493.447V485.185Z"
          fill="white"
        />
        <path
          d="M1234.81 485.185L1228 481.187L1221.23 485.185V493.447L1228 497.672L1234.81 493.447V485.185Z"
          fill="white"
        />
        <path
          d="M1250.33 485.185L1243.52 481.187L1236.75 485.185V493.447L1243.52 497.672L1250.33 493.447V485.185Z"
          fill="white"
        />
        <path
          d="M1265.84 485.185L1259.04 481.187L1252.27 485.185V493.447L1259.04 497.672L1265.84 493.447V485.185Z"
          fill="white"
        />
        <path
          d="M1327.9 485.185L1321.1 481.187L1314.33 485.185V493.447L1321.1 497.672L1327.9 493.447V485.185Z"
          fill="white"
        />
        <path
          d="M1180.5 498.762L1173.7 494.764L1166.93 498.762V507.024L1173.7 511.249L1180.5 507.024V498.762Z"
          fill="white"
        />
        <path
          d="M1196.02 498.762L1189.21 494.764L1182.44 498.762V507.024L1189.21 511.249L1196.02 507.024V498.762Z"
          fill="white"
        />
        <path
          d="M1227.05 498.762L1220.25 494.764L1213.48 498.762V507.024L1220.25 511.249L1227.05 507.024V498.762Z"
          fill="white"
        />
        <path
          d="M1242.57 498.762L1235.76 494.764L1228.99 498.762V507.024L1235.76 511.249L1242.57 507.024V498.762Z"
          fill="white"
        />
        <path
          d="M1258.08 498.762L1251.28 494.764L1244.51 498.762V507.024L1251.28 511.249L1258.08 507.024V498.762Z"
          fill="white"
        />
        <path
          d="M1335.66 498.762L1328.86 494.764L1322.09 498.762V507.024L1328.86 511.249L1335.66 507.024V498.762Z"
          fill="white"
        />
        <path
          d="M1188.26 512.338L1181.46 508.339L1174.69 512.338V520.599L1181.46 524.824L1188.26 520.599V512.338Z"
          fill="white"
        />
        <path
          d="M1234.81 512.338L1228 508.339L1221.23 512.338V520.599L1228 524.824L1234.81 520.599V512.338Z"
          fill="white"
        />
        <path
          d="M1250.33 512.338L1243.52 508.339L1236.75 512.338V520.599L1243.52 524.824L1250.33 520.599V512.338Z"
          fill="white"
        />
        <path
          d="M1265.84 512.338L1259.04 508.339L1252.27 512.338V520.599L1259.04 524.824L1265.84 520.599V512.338Z"
          fill="white"
        />
        <path
          d="M1327.9 512.338L1321.1 508.339L1314.33 512.338V520.599L1321.1 524.824L1327.9 520.599V512.338Z"
          fill="white"
        />
        <path
          d="M1343.42 512.338L1336.61 508.339L1329.84 512.338V520.599L1336.61 524.824L1343.42 520.599V512.338Z"
          fill="white"
        />
        <path
          d="M1358.94 512.338L1352.13 508.339L1345.36 512.338V520.599L1352.13 524.824L1358.94 520.599V512.338Z"
          fill="white"
        />
        <path
          d="M1374.45 512.338L1367.65 508.339L1360.88 512.338V520.599L1367.65 524.824L1374.45 520.599V512.338Z"
          fill="white"
        />
        <path
          d="M1180.5 525.916L1173.7 521.917L1166.93 525.916V534.177L1173.7 538.403L1180.5 534.177V525.916Z"
          fill="white"
        />
        <path
          d="M1196.02 525.916L1189.21 521.917L1182.44 525.916V534.177L1189.21 538.403L1196.02 534.177V525.916Z"
          fill="white"
        />
        <path
          d="M1351.18 525.916L1344.37 521.917L1337.6 525.916V534.177L1344.37 538.403L1351.18 534.177V525.916Z"
          fill="white"
        />
        <path
          d="M1366.69 525.916L1359.89 521.917L1353.12 525.916V534.177L1359.89 538.403L1366.69 534.177V525.916Z"
          fill="white"
        />
        <path
          d="M1382.21 525.916L1375.4 521.917L1368.63 525.916V534.177L1375.4 538.403L1382.21 534.177V525.916Z"
          fill="white"
        />
        <path
          d="M1397.73 525.916L1390.92 521.917L1384.15 525.916V534.177L1390.92 538.403L1397.73 534.177V525.916Z"
          fill="white"
        />
        <path
          d="M1413.24 525.916L1406.44 521.917L1399.67 525.916V534.177L1406.44 538.403L1413.24 534.177V525.916Z"
          fill="white"
        />
        <path
          d="M1188.26 539.492L1181.46 535.493L1174.69 539.492V547.754L1181.46 551.979L1188.26 547.754V539.492Z"
          fill="white"
        />
        <path
          d="M1203.78 539.492L1196.97 535.493L1190.2 539.492V547.754L1196.97 551.979L1203.78 547.754V539.492Z"
          fill="white"
        />
        <path
          d="M1374.45 539.492L1367.65 535.493L1360.88 539.492V547.754L1367.65 551.979L1374.45 547.754V539.492Z"
          fill="white"
        />
        <path
          d="M1389.97 539.492L1383.16 535.493L1376.39 539.492V547.754L1383.16 551.979L1389.97 547.754V539.492Z"
          fill="white"
        />
        <path
          d="M1405.48 539.492L1398.68 535.493L1391.91 539.492V547.754L1398.68 551.979L1405.48 547.754V539.492Z"
          fill="white"
        />
        <path
          d="M1421 539.492L1414.19 535.493L1407.42 539.492V547.754L1414.19 551.979L1421 547.754V539.492Z"
          fill="white"
        />
        <path
          d="M1211.54 553.068L1204.73 549.069L1197.96 553.068V561.33L1204.73 565.555L1211.54 561.33V553.068Z"
          fill="white"
        />
        <path
          d="M1227.05 553.068L1220.25 549.069L1213.48 553.068V561.33L1220.25 565.555L1227.05 561.33V553.068Z"
          fill="white"
        />
        <path
          d="M1366.69 553.068L1359.89 549.069L1353.12 553.068V561.33L1359.89 565.555L1366.69 561.33V553.068Z"
          fill="white"
        />
        <path
          d="M1374.45 566.644L1367.65 562.646L1360.88 566.644V574.906L1367.65 579.131L1374.45 574.906V566.644Z"
          fill="white"
        />
        <path
          d="M1265.84 593.796L1259.04 589.797L1252.27 593.796V602.057L1259.04 606.282L1265.84 602.057V593.796Z"
          fill="white"
        />
        <path
          d="M1281.36 593.796L1274.55 589.797L1267.78 593.796V602.057L1274.55 606.282L1281.36 602.057V593.796Z"
          fill="white"
        />
        <path
          d="M1296.87 593.796L1290.07 589.797L1283.3 593.796V602.057L1290.07 606.282L1296.87 602.057V593.796Z"
          fill="white"
        />
        <path
          d="M1312.39 593.796L1305.58 589.797L1298.81 593.796V602.057L1305.58 606.282L1312.39 602.057V593.796Z"
          fill="white"
        />
        <path
          d="M1327.9 593.796L1321.1 589.797L1314.33 593.796V602.057L1321.1 606.282L1327.9 602.057V593.796Z"
          fill="white"
        />
        <path
          d="M1343.42 593.796L1336.61 589.797L1329.84 593.796V602.057L1336.61 606.282L1343.42 602.057V593.796Z"
          fill="white"
        />
        <path
          d="M1374.45 593.796L1367.65 589.797L1360.88 593.796V602.057L1367.65 606.282L1374.45 602.057V593.796Z"
          fill="white"
        />
        <path
          d="M1273.6 607.372L1266.79 603.373L1260.02 607.372V615.633L1266.79 619.859L1273.6 615.633V607.372Z"
          fill="white"
        />
        <path
          d="M1289.12 607.372L1282.31 603.373L1275.54 607.372V615.633L1282.31 619.859L1289.12 615.633V607.372Z"
          fill="white"
        />
        <path
          d="M1304.63 607.372L1297.83 603.373L1291.06 607.372V615.633L1297.83 619.859L1304.63 615.633V607.372Z"
          fill="white"
        />
        <path
          d="M1320.15 607.372L1313.34 603.373L1306.57 607.372V615.633L1313.34 619.859L1320.15 615.633V607.372Z"
          fill="white"
        />
        <path
          d="M1335.66 607.372L1328.86 603.373L1322.09 607.372V615.633L1328.86 619.859L1335.66 615.633V607.372Z"
          fill="white"
        />
        <path
          d="M1351.18 607.372L1344.37 603.373L1337.6 607.372V615.633L1344.37 619.859L1351.18 615.633V607.372Z"
          fill="white"
        />
        <path
          d="M1366.69 607.372L1359.89 603.373L1353.12 607.372V615.633L1359.89 619.859L1366.69 615.633V607.372Z"
          fill="white"
        />
        <path
          d="M1382.21 607.372L1375.4 603.373L1368.63 607.372V615.633L1375.4 619.859L1382.21 615.633V607.372Z"
          fill="white"
        />
        <path
          d="M1397.73 607.372L1390.92 603.373L1384.15 607.372V615.633L1390.92 619.859L1397.73 615.633V607.372Z"
          fill="white"
        />
        <path
          d="M1234.81 620.949L1228 616.95L1221.23 620.949V629.211L1228 633.436L1234.81 629.211V620.949Z"
          fill="white"
        />
        <path
          d="M1250.33 620.949L1243.52 616.95L1236.75 620.949V629.211L1243.52 633.436L1250.33 629.211V620.949Z"
          fill="white"
        />
        <path
          d="M1265.84 620.949L1259.04 616.95L1252.27 620.949V629.211L1259.04 633.436L1265.84 629.211V620.949Z"
          fill="white"
        />
        <path
          d="M1281.36 620.949L1274.55 616.95L1267.78 620.949V629.211L1274.55 633.436L1281.36 629.211V620.949Z"
          fill="white"
        />
        <path
          d="M1296.87 620.949L1290.07 616.95L1283.3 620.949V629.211L1290.07 633.436L1296.87 629.211V620.949Z"
          fill="white"
        />
        <path
          d="M1312.39 620.949L1305.58 616.95L1298.81 620.949V629.211L1305.58 633.436L1312.39 629.211V620.949Z"
          fill="white"
        />
        <path
          d="M1327.9 620.949L1321.1 616.95L1314.33 620.949V629.211L1321.1 633.436L1327.9 629.211V620.949Z"
          fill="white"
        />
        <path
          d="M1343.42 620.949L1336.61 616.95L1329.84 620.949V629.211L1336.61 633.436L1343.42 629.211V620.949Z"
          fill="white"
        />
        <path
          d="M1358.94 620.949L1352.13 616.95L1345.36 620.949V629.211L1352.13 633.436L1358.94 629.211V620.949Z"
          fill="white"
        />
        <path
          d="M1374.45 620.949L1367.65 616.95L1360.88 620.949V629.211L1367.65 633.436L1374.45 629.211V620.949Z"
          fill="white"
        />
        <path
          d="M1389.97 620.949L1383.16 616.95L1376.39 620.949V629.211L1383.16 633.436L1389.97 629.211V620.949Z"
          fill="white"
        />
        <path
          d="M1227.05 634.527L1220.25 630.528L1213.48 634.527V642.789L1220.25 647.014L1227.05 642.789V634.527Z"
          fill="white"
        />
        <path
          d="M1242.57 634.527L1235.76 630.528L1228.99 634.527V642.789L1235.76 647.014L1242.57 642.789V634.527Z"
          fill="white"
        />
        <path
          d="M1258.08 634.527L1251.28 630.528L1244.51 634.527V642.789L1251.28 647.014L1258.08 642.789V634.527Z"
          fill="white"
        />
        <path
          d="M1273.6 634.527L1266.79 630.528L1260.02 634.527V642.789L1266.79 647.014L1273.6 642.789V634.527Z"
          fill="white"
        />
        <path
          d="M1289.12 634.527L1282.31 630.528L1275.54 634.527V642.789L1282.31 647.014L1289.12 642.789V634.527Z"
          fill="white"
        />
        <path
          d="M1304.63 634.527L1297.83 630.528L1291.06 634.527V642.789L1297.83 647.014L1304.63 642.789V634.527Z"
          fill="white"
        />
        <path
          d="M1320.15 634.527L1313.34 630.528L1306.57 634.527V642.789L1313.34 647.014L1320.15 642.789V634.527Z"
          fill="white"
        />
        <path
          d="M1335.66 634.527L1328.86 630.528L1322.09 634.527V642.789L1328.86 647.014L1335.66 642.789V634.527Z"
          fill="white"
        />
        <path
          d="M1351.18 634.527L1344.37 630.528L1337.6 634.527V642.789L1344.37 647.014L1351.18 642.789V634.527Z"
          fill="white"
        />
        <path
          d="M1366.69 634.527L1359.89 630.528L1353.12 634.527V642.789L1359.89 647.014L1366.69 642.789V634.527Z"
          fill="white"
        />
        <path
          d="M1382.21 634.527L1375.4 630.528L1368.63 634.527V642.789L1375.4 647.014L1382.21 642.789V634.527Z"
          fill="white"
        />
        <path
          d="M1397.73 634.527L1390.92 630.528L1384.15 634.527V642.789L1390.92 647.014L1397.73 642.789V634.527Z"
          fill="white"
        />
        <path
          d="M1413.24 634.527L1406.44 630.528L1399.67 634.527V642.789L1406.44 647.014L1413.24 642.789V634.527Z"
          fill="white"
        />
        <path
          d="M1234.81 648.103L1228 644.104L1221.23 648.103V656.365L1228 660.59L1234.81 656.365V648.103Z"
          fill="white"
        />
        <path
          d="M1250.33 648.103L1243.52 644.104L1236.75 648.103V656.365L1243.52 660.59L1250.33 656.365V648.103Z"
          fill="white"
        />
        <path
          d="M1265.84 648.103L1259.04 644.104L1252.27 648.103V656.365L1259.04 660.59L1265.84 656.365V648.103Z"
          fill="white"
        />
        <path
          d="M1281.36 648.103L1274.55 644.104L1267.78 648.103V656.365L1274.55 660.59L1281.36 656.365V648.103Z"
          fill="white"
        />
        <path
          d="M1296.87 648.103L1290.07 644.104L1283.3 648.103V656.365L1290.07 660.59L1296.87 656.365V648.103Z"
          fill="white"
        />
        <path
          d="M1312.39 648.103L1305.58 644.104L1298.81 648.103V656.365L1305.58 660.59L1312.39 656.365V648.103Z"
          fill="white"
        />
        <path
          d="M1327.9 648.103L1321.1 644.104L1314.33 648.103V656.365L1321.1 660.59L1327.9 656.365V648.103Z"
          fill="white"
        />
        <path
          d="M1343.42 648.103L1336.61 644.104L1329.84 648.103V656.365L1336.61 660.59L1343.42 656.365V648.103Z"
          fill="white"
        />
        <path
          d="M1358.94 648.103L1352.13 644.104L1345.36 648.103V656.365L1352.13 660.59L1358.94 656.365V648.103Z"
          fill="white"
        />
        <path
          d="M1374.45 648.103L1367.65 644.104L1360.88 648.103V656.365L1367.65 660.59L1374.45 656.365V648.103Z"
          fill="white"
        />
        <path
          d="M1389.97 648.103L1383.16 644.104L1376.39 648.103V656.365L1383.16 660.59L1389.97 656.365V648.103Z"
          fill="white"
        />
        <path
          d="M1405.48 648.103L1398.68 644.104L1391.91 648.103V656.365L1398.68 660.59L1405.48 656.365V648.103Z"
          fill="white"
        />
        <path
          d="M1227.05 661.677L1220.25 657.679L1213.48 661.677V669.939L1220.25 674.164L1227.05 669.939V661.677Z"
          fill="white"
        />
        <path
          d="M1242.57 661.677L1235.76 657.679L1228.99 661.677V669.939L1235.76 674.164L1242.57 669.939V661.677Z"
          fill="white"
        />
        <path
          d="M1258.08 661.677L1251.28 657.679L1244.51 661.677V669.939L1251.28 674.164L1258.08 669.939V661.677Z"
          fill="white"
        />
        <path
          d="M1273.6 661.677L1266.79 657.679L1260.02 661.677V669.939L1266.79 674.164L1273.6 669.939V661.677Z"
          fill="white"
        />
        <path
          d="M1289.12 661.677L1282.31 657.679L1275.54 661.677V669.939L1282.31 674.164L1289.12 669.939V661.677Z"
          fill="white"
        />
        <path
          d="M1304.63 661.677L1297.83 657.679L1291.06 661.677V669.939L1297.83 674.164L1304.63 669.939V661.677Z"
          fill="white"
        />
        <path
          d="M1320.15 661.677L1313.34 657.679L1306.57 661.677V669.939L1313.34 674.164L1320.15 669.939V661.677Z"
          fill="white"
        />
        <path
          d="M1335.66 661.677L1328.86 657.679L1322.09 661.677V669.939L1328.86 674.164L1335.66 669.939V661.677Z"
          fill="white"
        />
        <path
          d="M1351.18 661.677L1344.37 657.679L1337.6 661.677V669.939L1344.37 674.164L1351.18 669.939V661.677Z"
          fill="white"
        />
        <path
          d="M1366.69 661.677L1359.89 657.679L1353.12 661.677V669.939L1359.89 674.164L1366.69 669.939V661.677Z"
          fill="white"
        />
        <path
          d="M1382.21 661.677L1375.4 657.679L1368.63 661.677V669.939L1375.4 674.164L1382.21 669.939V661.677Z"
          fill="white"
        />
        <path
          d="M1397.73 661.677L1390.92 657.679L1384.15 661.677V669.939L1390.92 674.164L1397.73 669.939V661.677Z"
          fill="white"
        />
        <path
          d="M1413.24 661.677L1406.44 657.679L1399.67 661.677V669.939L1406.44 674.164L1413.24 669.939V661.677Z"
          fill="white"
        />
        <path
          d="M1234.81 675.256L1228 671.257L1221.23 675.256V683.517L1228 687.742L1234.81 683.517V675.256Z"
          fill="white"
        />
        <path
          d="M1250.33 675.256L1243.52 671.257L1236.75 675.256V683.517L1243.52 687.742L1250.33 683.517V675.256Z"
          fill="white"
        />
        <path
          d="M1265.84 675.256L1259.04 671.257L1252.27 675.256V683.517L1259.04 687.742L1265.84 683.517V675.256Z"
          fill="white"
        />
        <path
          d="M1281.36 675.256L1274.55 671.257L1267.78 675.256V683.517L1274.55 687.742L1281.36 683.517V675.256Z"
          fill="white"
        />
        <path
          d="M1296.87 675.256L1290.07 671.257L1283.3 675.256V683.517L1290.07 687.742L1296.87 683.517V675.256Z"
          fill="white"
        />
        <path
          d="M1312.39 675.256L1305.58 671.257L1298.81 675.256V683.517L1305.58 687.742L1312.39 683.517V675.256Z"
          fill="white"
        />
        <path
          d="M1327.9 675.256L1321.1 671.257L1314.33 675.256V683.517L1321.1 687.742L1327.9 683.517V675.256Z"
          fill="white"
        />
        <path
          d="M1343.42 675.256L1336.61 671.257L1329.84 675.256V683.517L1336.61 687.742L1343.42 683.517V675.256Z"
          fill="white"
        />
        <path
          d="M1358.94 675.256L1352.13 671.257L1345.36 675.256V683.517L1352.13 687.742L1358.94 683.517V675.256Z"
          fill="white"
        />
        <path
          d="M1374.45 675.256L1367.65 671.257L1360.88 675.256V683.517L1367.65 687.742L1374.45 683.517V675.256Z"
          fill="white"
        />
        <path
          d="M1389.97 675.256L1383.16 671.257L1376.39 675.256V683.517L1383.16 687.742L1389.97 683.517V675.256Z"
          fill="white"
        />
        <path
          d="M1405.48 675.256L1398.68 671.257L1391.91 675.256V683.517L1398.68 687.742L1405.48 683.517V675.256Z"
          fill="white"
        />
        <path
          d="M1227.05 688.831L1220.25 684.832L1213.48 688.831V697.092L1220.25 701.318L1227.05 697.092V688.831Z"
          fill="white"
        />
        <path
          d="M1242.57 688.831L1235.76 684.832L1228.99 688.831V697.092L1235.76 701.318L1242.57 697.092V688.831Z"
          fill="white"
        />
        <path
          d="M1258.08 688.831L1251.28 684.832L1244.51 688.831V697.092L1251.28 701.318L1258.08 697.092V688.831Z"
          fill="white"
        />
        <path
          d="M1273.6 688.831L1266.79 684.832L1260.02 688.831V697.092L1266.79 701.318L1273.6 697.092V688.831Z"
          fill="white"
        />
        <path
          d="M1289.12 688.831L1282.31 684.832L1275.54 688.831V697.092L1282.31 701.318L1289.12 697.092V688.831Z"
          fill="white"
        />
        <path
          d="M1304.63 688.831L1297.83 684.832L1291.06 688.831V697.092L1297.83 701.318L1304.63 697.092V688.831Z"
          fill="white"
        />
        <path
          d="M1320.15 688.831L1313.34 684.832L1306.57 688.831V697.092L1313.34 701.318L1320.15 697.092V688.831Z"
          fill="white"
        />
        <path
          d="M1335.66 688.831L1328.86 684.832L1322.09 688.831V697.092L1328.86 701.318L1335.66 697.092V688.831Z"
          fill="white"
        />
        <path
          d="M1351.18 688.831L1344.37 684.832L1337.6 688.831V697.092L1344.37 701.318L1351.18 697.092V688.831Z"
          fill="white"
        />
        <path
          d="M1366.69 688.831L1359.89 684.832L1353.12 688.831V697.092L1359.89 701.318L1366.69 697.092V688.831Z"
          fill="white"
        />
        <path
          d="M1382.21 688.831L1375.4 684.832L1368.63 688.831V697.092L1375.4 701.318L1382.21 697.092V688.831Z"
          fill="white"
        />
        <path
          d="M1397.73 688.831L1390.92 684.832L1384.15 688.831V697.092L1390.92 701.318L1397.73 697.092V688.831Z"
          fill="white"
        />
        <path
          d="M1327.9 702.407L1321.1 698.408L1314.33 702.407V710.669L1321.1 714.894L1327.9 710.669V702.407Z"
          fill="white"
        />
        <path
          d="M1343.42 702.407L1336.61 698.408L1329.84 702.407V710.669L1336.61 714.894L1343.42 710.669V702.407Z"
          fill="white"
        />
        <path
          d="M1358.94 702.407L1352.13 698.408L1345.36 702.407V710.669L1352.13 714.894L1358.94 710.669V702.407Z"
          fill="white"
        />
        <path
          d="M1374.45 702.407L1367.65 698.408L1360.88 702.407V710.669L1367.65 714.894L1374.45 710.669V702.407Z"
          fill="white"
        />
        <path
          d="M1389.97 702.407L1383.16 698.408L1376.39 702.407V710.669L1383.16 714.894L1389.97 710.669V702.407Z"
          fill="white"
        />
        <path
          d="M1335.66 715.982L1328.86 711.983L1322.09 715.982V724.244L1328.86 728.469L1335.66 724.244V715.982Z"
          fill="white"
        />
        <path
          d="M1351.18 715.982L1344.37 711.983L1337.6 715.982V724.244L1344.37 728.469L1351.18 724.244V715.982Z"
          fill="white"
        />
        <path
          d="M1366.69 715.982L1359.89 711.983L1353.12 715.982V724.244L1359.89 728.469L1366.69 724.244V715.982Z"
          fill="white"
        />
        <path
          d="M1382.21 715.982L1375.4 711.983L1368.63 715.982V724.244L1375.4 728.469L1382.21 724.244V715.982Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="filter0_dddddd_625_20601"
          x="0"
          y="0"
          width="1501"
          height="935.948"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2.76726" />
          <feGaussianBlur stdDeviation="1.1069" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.423529 0 0 0 0 0.286275 0 0 0 0 0.67451 0 0 0 0.0196802 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_625_20601"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="6.6501" />
          <feGaussianBlur stdDeviation="2.66004" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.423529 0 0 0 0 0.286275 0 0 0 0 0.67451 0 0 0 0.0282725 0"
          />
          <feBlend
            mode="normal"
            in2="effect1_dropShadow_625_20601"
            result="effect2_dropShadow_625_20601"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="12.5216" />
          <feGaussianBlur stdDeviation="5.00862" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.423529 0 0 0 0 0.286275 0 0 0 0 0.67451 0 0 0 0.035 0"
          />
          <feBlend
            mode="normal"
            in2="effect2_dropShadow_625_20601"
            result="effect3_dropShadow_625_20601"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="22.3363" />
          <feGaussianBlur stdDeviation="8.93452" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.423529 0 0 0 0 0.286275 0 0 0 0 0.67451 0 0 0 0.0417275 0"
          />
          <feBlend
            mode="normal"
            in2="effect3_dropShadow_625_20601"
            result="effect4_dropShadow_625_20601"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="41.7776" />
          <feGaussianBlur stdDeviation="16.711" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.423529 0 0 0 0 0.286275 0 0 0 0 0.67451 0 0 0 0.0503198 0"
          />
          <feBlend
            mode="normal"
            in2="effect4_dropShadow_625_20601"
            result="effect5_dropShadow_625_20601"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="100" />
          <feGaussianBlur stdDeviation="40" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.423529 0 0 0 0 0.286275 0 0 0 0 0.67451 0 0 0 0.07 0"
          />
          <feBlend
            mode="normal"
            in2="effect5_dropShadow_625_20601"
            result="effect6_dropShadow_625_20601"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect6_dropShadow_625_20601"
            result="shape"
          />
        </filter>
      </defs>
    </svg>
  );
}

export default HexaMap;
